export function useAirports() {
    const airports: { [key: string]: string }[] = [
        {
            "UTK": "Utirik Island",
            "OCA": "Key Largo",
            "CSE": "Crested Butte",
            "CUS": "Columbus",
            "JCY": "Stonewall",
            "WLR": "Loring",
            "NUP": "Nunapitchuk",
            "PTC": "Port Alice",
            "ICY": "Icy Bay",
            "PPV": "Port Protection",
            "KKK": "Kalakaket Creek",
            "MHS": "Dunsmuir",
            "NIR": "Beeville",
            "GCT": "Littlefield",
            "ELW": "Ellamar",
            "LVD": "Lime Village",
            "HGZ": "Hogatza",
            "OTN": "Oaktown",
            "TLF": "Telida",
            "BZT": "Brazoria",
            "HBH": "Entrance Island",
            "FAK": "False Island",
            "BYW": "Blakely Island",
            "DRF": "Kenai",
            "BDF": "Bradford",
            "TEH": "Tetlin",
            "VRS": "Versailles",
            "GDH": "Golden Horn Lodge",
            "ATT": "Atmautluak",
            "LIV": "Livengood",
            "PDB": "Pedro Bay",
            "KOZ": "Ouzinkie",
            "TNK": "Tununak",
            "WHD": "Hyder",
            "MNT": "Minto",
            "TKI": "Tokeen",
            "WKK": "Aleknagik",
            "WFB": "Ketchikan",
            "RFK": "Rolling Fork",
            "NNK": "Naknek",
            "BKF": "Katmai National Park",
            "BCS": "Belle Chasse",
            "MMN": "Stow",
            "SPQ": "San Pedro",
            "TSS": "New York",
            "NYS": "New York",
            "BWL": "Blackwell",
            "WYB": "Yes Bay",
            "CWS": "Center Island",
            "TEK": "Tatitlek",
            "DUF": "Corolla",
            "SSW": "Friday Harbor",
            "FOB": "Fort Bragg",
            "PUL": "Poulsbo",
            "CCD": "Los Angeles",
            "WMK": "Meyers Chuck",
            "AXB": "Alexandria Bay",
            "REE": "Lubbock",
            "WDN": "Eastsound",
            "WWP": "Whale Pass",
            "CHU": "Chuathbaluk",
            "UGS": "Ugashik",
            "JID": "City of Industry",
            "PSQ": "Essington",
            "KLL": "Levelock",
            "SGW": "Saginaw Bay",
            "WTL": "Tuntutuliak",
            "TWA": "Twin Hills",
            "KCQ": "Chignik Lake",
            "AAD": "Adado",
            "ABP": "Atkamba Mission",
            "ACM": "Arica",
            "ADV": "El Daein",
            "AEE": "Adar",
            "AEQ": "Chifeng",
            "AFK": "Ampara",
            "AFT": "Bila",
            "RNA": "Arona",
            "ATD": "Atoifi",
            "VEV": "Barakoma",
            "BPF": "Batuna Mission Station",
            "GEF": "Liangia",
            "AGG": "Angoram",
            "AKS": "Auki",
            "BNY": "Anua",
            "CHY": "Choiseul Bay",
            "BAS": "Ballalae",
            "FRE": "Fera Island",
            "HIR": "Honiara",
            "MBU": "Mbambanakira",
            "AVU": "Avu Avu",
            "IRA": "Kirakira",
            "SCZ": "Santa Cruz/Graciosa Bay/Luova",
            "MUA": "Munda",
            "GZO": "Gizo",
            "MNY": "Stirling Island",
            "PRS": "Parasi",
            "RNL": "Rennell Island",
            "EGM": "Sege",
            "NNB": "Santa Ana Island",
            "RUS": "Marau",
            "VAO": "Suavanao",
            "XYA": "Yandina",
            "AGK": "Kagua",
            "KGE": "Kagau Island",
            "KUE": "Kolombangara Island",
            "KWS": "Kwailabesi",
            "LLM": "Lomlom",
            "NAZ": "Star Harbor",
            "MHM": "Manaoba",
            "GTA": "Gatokae",
            "RIN": "Ringi Cove",
            "RBV": "Ramata",
            "TLG": "Tulaghi Island",
            "AHY": "Ambatolahy",
            "AIC": "Bigatyelang Island",
            "CEX": "Chena Hot Springs",
            "SOL": "Solomon",
            "HED": "Herendeen Bay",
            "TWE": "Taylor",
            "KTH": "Tikchik",
            "NKI": "Tuxekan Island",
            "CDL": "Candle",
            "AOS": "Amook Bay",
            "BSW": "Boswell Bay",
            "AKM": "ZaKouma",
            "ALZ": "Lazy Bay",
            "YUK": "Kapan",
            "AME": "Alto Molocue",
            "INU": "Yaren District",
            "ANZ": "Angus Downs Station",
            "CTV": "Saurimo",
            "ANL": "Andulo",
            "CNZ": "Cangamba",
            "DRC": "Dirico",
            "NDF": "N'dalatando",
            "AOD": "Abou-Deïa",
            "AQY": "Girdwood",
            "QRF": "Bragado",
            "CVI": "Caleta Olivia",
            "CNT": "Charata",
            "VGS": "General Villegas",
            "LMD": "Los Menucos",
            "VCF": "Valcheta",
            "CPG": "Carmen de Patagones",
            "LYT": "Lady Elliot Island",
            "GYZ": "Cosmo Newbery",
            "AGW": "Agnew",
            "AYD": "Alroy Downs",
            "BYX": "Baniyala",
            "COB": "Coolibah",
            "CRJ": "Coorabie",
            "CRY": "Carlton Hill",
            "CSD": "Cresswell Downs",
            "DYM": "Diamantina Lakes",
            "HIS": "Hayman Island",
            "HLV": "Helenvale",
            "KBD": "Kimberley Downs",
            "KGR": "Ghan",
            "PEP": "Peppimenarti",
            "RDA": "Rockhampton Downs",
            "SSK": "Sturt Creek",
            "SWB": "Shaw River",
            "TWP": "Torwood",
            "ZVG": "Springvale",
            "AWR": "Awar",
            "AXF": "Bayanhot",
            "AXO": "Kabir",
            "UAE": "Aue",
            "AFR": "Afore",
            "AUP": "Agaun",
            "ATP": "Aitape",
            "AIH": "Aiambak",
            "AMU": "Amanab",
            "ADC": "Andekombe",
            "AIE": "Aiome",
            "AUJ": "Ambunti",
            "AWB": "Awaba",
            "AEK": "Aseki",
            "AYU": "Aiyura Valley",
            "VMU": "Baimuru",
            "BCP": "Bambu",
            "BNM": "Bodinumu",
            "BMZ": "Bamu",
            "BSP": "Bensbach",
            "BWP": "Bewani",
            "BUA": "Buka Island",
            "BAA": "Bialla, Matalilu, Ewase",
            "OPU": "Balimo",
            "BMH": "Bomai",
            "BPD": "Bapi",
            "BPK": "Biangabip",
            "BRP": "Biaru",
            "BUL": "Bulolo",
            "XBN": "Biniguni",
            "CVB": "Chungribu",
            "CGC": "Cape Gloucester",
            "CMU": "Kundiawa",
            "SQT": "Samarai Island",
            "DBP": "Debepare",
            "DER": "Derim",
            "BNT": "Bundi",
            "MDM": "Munduku",
            "KPF": "Kondobol",
            "DNU": "Dinangat",
            "DOI": "Castori Islets",
            "DOO": "Dorobisoro",
            "DAU": "Daru",
            "KRU": "Gunim",
            "EMS": "Embessa",
            "XYR": "Yellow River Mission",
            "EMI": "Emirau Island",
            "EFG": "Efogi",
            "MHY": "Morehead",
            "EPT": "Eliptamin",
            "EGA": "Engati",
            "EMO": "Emo Mission",
            "ERU": "Erume",
            "MFZ": "Demgulu",
            "BOT": "Bosset",
            "ERE": "Erave",
            "SWE": "Siwea",
            "FNE": "Fane Mission",
            "FRQ": "Feramin",
            "FIN": "Buki",
            "FAQ": "Frieda River",
            "FUM": "Fuma",
            "GKA": "Goronka",
            "GEW": "Gewoia",
            "GUG": "Guari",
            "GRL": "Au",
            "GAR": "Garaina",
            "GAZ": "Woodlark (Muyua) Island",
            "GOE": "Gonaili",
            "GUR": "Gurney",
            "GAP": "Gusap",
            "PNP": "Popondetta",
            "GBC": "Gasuke",
            "GMI": "Gasmata Island",
            "AKG": "Anguganak",
            "GVI": "Green River",
            "GOC": "Gora",
            "HBD": "Habi",
            "HNI": "Heiweni",
            "HYF": "Bainyik",
            "HNN": "Honinabi",
            "HKN": "Kimbe",
            "HIT": "Haivaro",
            "HWA": "Hawabango",
            "IIS": "Nissan Island",
            "IDN": "Indagen",
            "IMN": "Imane",
            "KGM": "Kungim",
            "IMD": "Imonda",
            "KIE": "Kieta",
            "IAL": "Ialibu",
            "WSA": "Wasua",
            "WIU": "Garove Island",
            "MPX": "Miyanmin",
            "KGH": "Yongai",
            "JOP": "Josephstaal",
            "LSA": "Losuia",
            "KDR": "Kandrian",
            "KMF": "Hoieti",
            "KPA": "Kopiago",
            "KAQ": "Kamulai Mission",
            "UNG": "Kiunga",
            "KNE": "Kanainj",
            "KRI": "Kikori",
            "KMA": "Kerema",
            "KKD": "Kokoda",
            "KGW": "Kagi",
            "KRX": "Kar Kar Island",
            "KZF": "Kaintiba",
            "KUQ": "Kuri",
            "KVG": "Kavieng",
            "KWO": "Kawito",
            "LNV": "Londolovit",
            "LAB": "Lab Lab Mission",
            "KEG": "Denglagu Mission",
            "KII": "Kibuli",
            "LGN": "Linga Linga",
            "LWI": "Lowai",
            "LPN": "Leron Plains",
            "LNG": "Lese",
            "LMI": "Lumi",
            "LSJ": "Long Island",
            "AYM": "Abu Dhabi",
            "MRM": "Manari",
            "OBM": "Morobe",
            "MYX": "Menyamya",
            "MAG": "Madang",
            "HGU": "Mount Hagen",
            "MXK": "Mindik",
            "MPG": "Makini",
            "GUV": "Mougulu",
            "MDU": "Mendi",
            "MAS": "Manus Island",
            "MLQ": "Malalaua",
            "MQO": "Malam",
            "MXH": "Moro",
            "MIS": "Misima Island",
            "MKN": "Babase Island",
            "MWG": "Marawaka",
            "MPU": "Tatau Island",
            "NKN": "Gwarawon",
            "KEX": "Kanabea",
            "NDN": "Nadunumu",
            "AUI": "Aua Island",
            "GBF": "Negarbo",
            "MFO": "Manguna",
            "NUG": "Nuguria Island",
            "NDI": "Namudi",
            "KSB": "Kasonombe",
            "KDP": "Kandep",
            "NMN": "Namane",
            "BXZ": "Bunsil - Umboi Island",
            "UKU": "Nuku",
            "ATN": "Namatanai",
            "NBA": "Nambaiyufa",
            "LAE": "Lae",
            "OBX": "Obo",
            "KGB": "Konge",
            "OKV": "Okao",
            "OKP": "Oksapmin",
            "HOC": "Komako",
            "KQL": "Kol",
            "OSE": "Omora",
            "KOM": "Komo",
            "KSP": "Kosipe Mission",
            "KCJ": "Komaio",
            "OLQ": "Olsobip",
            "KDE": "Koroba",
            "OPB": "Maitanakunai",
            "PLE": "Paiela",
            "PGB": "Pangoa",
            "PDI": "Pindiu",
            "APR": "April River",
            "PGN": "Pangia",
            "PMP": "Pimaga",
            "MPF": "Mapoda",
            "PMN": "Pumani",
            "WLU": "Puri",
            "POM": "Port Moresby",
            "KRJ": "Amboin",
            "TLP": "Tumolbil",
            "SPH": "Sopu",
            "ONB": "Onange Mission",
            "SXA": "Sialum",
            "KIQ": "Kira",
            "RBP": "Rabaraba",
            "KMR": "Karimui",
            "RKU": "Yule Island",
            "MWI": "Maramuni",
            "KOR": "Kakoro",
            "MRH": "May River",
            "SDI": "Saidor",
            "NIS": "Simberi Island",
            "SFU": "Safia",
            "SIL": "Sila Mission",
            "SBV": "Sabah",
            "SIM": "Simbai",
            "SGK": "Sengapi",
            "SXH": "Sehulea",
            "SBC": "Selbang",
            "SMH": "Sapmanga",
            "SPV": "Sepik Plains",
            "TDS": "Sasereme",
            "SKC": "Suki",
            "SXW": "Sauren",
            "SWG": "Satwag",
            "MBV": "Masa",
            "TIZ": "Tari",
            "TBG": "Tabubil",
            "TFM": "Telefomin",
            "TDB": "Tetebedi",
            "TGL": "Sudest Island",
            "TFB": "Tifalmin",
            "TPI": "Tapini",
            "RAB": "Kokopo",
            "TKW": "Tekin",
            "KDQ": "Kamberatoro Mission",
            "TEP": "Teptep",
            "TBQ": "Tarabo",
            "TSW": "Tsewi",
            "TRJ": "Tarakbits",
            "TFI": "Tufi",
            "TBE": "Timbunke",
            "TWY": "Tawa",
            "TEO": "Terapo Mission",
            "TKB": "Tekadu",
            "UMC": "Umba",
            "URU": "Uroubi",
            "UBI": "Buin",
            "AUV": "Aumo",
            "GLP": "Gulgubip",
            "UPR": "Upiara",
            "UVO": "Uvol",
            "TLW": "Talasea",
            "TCJ": "Torembi",
            "VAI": "Vanimo",
            "TON": "Tonu",
            "WUV": "Wuvulu Island",
            "WAO": "Wabo",
            "WTT": "Wantoat",
            "WBM": "Wapenamanda",
            "WAJ": "Wavoi Falls",
            "AGL": "Wanigela",
            "WNU": "Wanuma",
            "WBC": "Wapolu",
            "WWK": "Wewak",
            "WOA": "Wonenara",
            "WKN": "Wakunai",
            "WSU": "Wasu",
            "WTP": "Fatima Mission",
            "WUG": "Wau",
            "YVD": "Yeva",
            "SMJ": "Sim",
            "TLO": "Tol",
            "WPM": "Wipim",
            "WEP": "Weam",
            "AYY": "Pottuvil",
            "KYX": "Yalumet",
            "TCK": "Tinboli",
            "KSX": "Yasuru",
            "ZEN": "Zenag",
            "SWR": "Silur Mission",
            "WUM": "Wasum",
            "SIZ": "Sissano",
            "OSG": "Ossima",
            "ZXT": "Zabrat",
            "HAE": "Supai Village",
            "BAJ": "Unea Island",
            "BCW": "Benguera Island",
            "BCZ": "Bickerton Island",
            "JAM": "Bezmer",
            "JEG": "Aasiaat",
            "AOQ": "Aappilattoq",
            "AGM": "Tasiilaq",
            "LLU": "Alluitsup Paa",
            "QUV": "Aappilattoq",
            "JRK": "Arsuk",
            "QUW": "Ammassivik",
            "QGQ": "Attu",
            "UAK": "Narsarsuaq",
            "JCH": "Qasigiannguit",
            "CNP": "Neerlerit Inaat",
            "QFG": "Eqalugaarsuit",
            "QFN": "Narsarmijit",
            "JGR": "Kangilinnguit",
            "GOH": "Nuuk",
            "JGO": "Qeqertarsuaq",
            "IKE": "Ikerasak",
            "QFI": "Iginniarfik",
            "QRY": "Ikerassaarsuk",
            "XIQ": "Ilimanaq",
            "IUI": "Innarsuit",
            "IOQ": "Isortoq",
            "QJI": "Ikamiut",
            "JJU": "Qaqortoq",
            "JAV": "Ilulissat",
            "QPW": "Kangaatsiaq",
            "KUS": "Kulusuk",
            "KUZ": "Kuummiut",
            "KHQ": "Kullorsuaq",
            "KGQ": "Kangersuatsiaq",
            "QJE": "Kitsissuarsuit",
            "IOT": "Illorsuit",
            "JSU": "Maniitsoq",
            "JNN": "Nanortalik",
            "JUU": "Nuugaatsiaq",
            "JNS": "Narsaq",
            "NIQ": "Niaqornat",
            "NSQ": "Nuussuaq",
            "JFR": "Paamiut",
            "PQT": "Qeqertaq",
            "NAQ": "Qaanaaq",
            "QJH": "Qassimiut",
            "OBY": "Ittoqqortoormiit",
            "SFJ": "Kangerlussuaq",
            "SGG": "Sermiligaaq",
            "SRK": "Siorapaluk",
            "QOQ": "Saarloq",
            "JHS": "Sisimiut",
            "SAE": "Saattut",
            "SVR": "Savissivik",
            "TQA": "Tasiusaq",
            "THU": "Pituffik",
            "TQI": "Tiniteqilaaq",
            "XEQ": "Tasiusak",
            "JUV": "Upernavik",
            "UMD": "Uummannaq",
            "JQA": "Uummannaq",
            "JUK": "Ukkusissat",
            "BHL": "Ensenada",
            "BHT": "Brighton Downs",
            "AEY": "Akureyri",
            "BIU": "Bildudalur",
            "BGJ": "Borgarfjörður eystri",
            "BJD": "Bakkafjörður",
            "BLO": "Blönduós",
            "BXV": "Breiðdalsvík",
            "DJU": "Djúpivogur",
            "EGS": "Egilsstaðir",
            "FAS": "Fáskrúðsfjörður",
            "FAG": "Fagurhólsmýri",
            "GUU": "Grundarfjörður",
            "GJR": "Gjögur",
            "GRY": "Grímsey",
            "HVK": "Hólmavík",
            "HFN": "Höfn",
            "FLI": "Flateyri",
            "HZK": "Húsavík",
            "HLO": "Onundarfjörður",
            "IFJ": "Ísafjörður",
            "KEF": "Reykjavík",
            "OPA": "Kópasker",
            "SAK": "Sauðárkrókur",
            "NOR": "Norðfjörður",
            "OFJ": "Ólafsfjörður",
            "PFJ": "Patreksfjörður",
            "RHA": "Reykhólar",
            "OLI": "Rif",
            "RFN": "Raufarhöfn",
            "RKV": "Reykjavík",
            "MVA": "Myvatn",
            "SIJ": "Siglufjörður",
            "SYK": "Stykkishólmur",
            "TEY": "Þingeyri",
            "THO": "Þórshöfn",
            "VEY": "Vestmannaeyjar",
            "VPN": "Vopnafjörður",
            "BJE": "Baleela Base Camp",
            "BJQ": "Bahja",
            "BJT": "Bentota",
            "PRN": "Prishtina",
            "BMQ": "Bamburi",
            "BNF": "Baranof",
            "BNV": "Boana",
            "BVL": "Baures",
            "BOV": "Boang Island",
            "BQV": "Gustavus",
            "CJZ": "Cajazeiras",
            "VDC": "Vitória da Conquista",
            "CMP": "Santana do Araguaia",
            "AAI": "Arraias",
            "ITN": "Itabuna",
            "LEP": "Leopoldina",
            "CPU": "Cururupu",
            "CTQ": "Santa Vitória do Palmar",
            "APY": "Alto Parnaíba",
            "JRN": "Juruena",
            "STZ": "Santa Terezinha",
            "MTG": "Vila Bela Da Santíssima Trindade",
            "ALT": "Alenquer",
            "NSB": "Bimini",
            "BSV": "Besakoa",
            "BTZ": "Betong",
            "HUK": "Hukuntsi",
            "BXL": "Nanuya Lailai Island",
            "TXC": "Orsha",
            "BYA": "Boundary",
            "BYL": "Beliyela",
            "BYV": "Colombo",
            "BCV": "Belmopan",
            "BGK": "Big Creek",
            "CUK": "Caye Caulker",
            "CYC": "Caye Chapel",
            "CZH": "Corozal",
            "DGA": "Dangriga",
            "INB": "Independence",
            "MDB": "Melinda",
            "ORZ": "Orange Walk",
            "PND": "Punta Gorda",
            "SJX": "Sartaneja",
            "SPR": "San Pedro",
            "SQS": "Spanish Lookout",
            "STU": "Santa Cruz",
            "SVK": "Silver Creek",
            "TZA": "Belize City",
            "BZB": "Bazaruto Island",
            "BZM": "Bemolanga",
            "PFM": "Primrose",
            "YSV": "Saglek",
            "YRR": "Big Bay",
            "YMV": "Mary River",
            "YHC": "Hecate Island",
            "YMF": "Galiano Island",
            "PYS": "Paradise",
            "YBW": "Bedwell Harbour",
            "YTP": "Tofino",
            "CBA": "West Kelowna",
            "ZNA": "Nanaimo",
            "YZZ": "Trail",
            "YMB": "Merritt",
            "YHH": "Campbell River",
            "YWS": "Whistler",
            "YBF": "Bamfield",
            "YIG": "Stuart Island",
            "CJH": "Chilko Lake",
            "YPT": "Sunshine Coast",
            "ZOF": "Ocean Falls",
            "YCA": "Courtenay",
            "CFQ": "Creston",
            "YAA": "Anahim Lake",
            "DGF": "Douglas Lake",
            "JHL": "Albian Village",
            "ZTS": "Tahsis",
            "DUQ": "Duncan",
            "YHS": "Sechelt",
            "YKK": "Kitkatla",
            "ZQS": "Queen Charlotte",
            "WPL": "Powell River",
            "XQU": "Qualicum Beach",
            "YMP": "Port McNeill",
            "YRN": "Rivers Inlet",
            "YTG": "Sullivan Bay",
            "YMU": "Mansons Landing",
            "YAV": "Miners Bay",
            "YSX": "Bella Bella",
            "YGG": "Salt Spring Island",
            "YTB": "Hartley Bay",
            "YZA": "Cache Creek",
            "ZEL": "Bella Bella",
            "YPB": "Port Alberni",
            "YBO": "Bob Quinn Lake",
            "TNS": "Tungsten",
            "TUX": "Tumbler Ridge",
            "YWM": "Williams Harbour",
            "YSO": "Postville",
            "YBI": "Black Tickle",
            "YHG": "Charlottetown",
            "YFX": "St. Lewis",
            "YHA": "Port Hope Simpson",
            "YRG": "Rigolet",
            "KGN": "Kasongo-Lunda",
            "DVK": "Diavik",
            "JOJ": "Hope Bay",
            "ZFW": "Fairview",
            "YJP": "Hinton",
            "YLE": "Whatì",
            "YDC": "Drayton Valley",
            "NML": "Fort McMurray",
            "CFM": "Conklin",
            "KWD": "Kavadja",
            "GSL": "Taltheilei Narrows",
            "XMP": "Macmillan Pass",
            "DAS": "Great Bear Lake",
            "YFI": "Suncor Energy Site",
            "YOE": "Donnelly",
            "TIL": "Cheadle",
            "OKG": "Okoyo",
            "CGA": "Craig",
            "CGG": "Casiguran",
            "GHK": "Kennedy Lake",
            "CHP": "Circle Hot Springs",
            "CIV": "Chomley",
            "LRQ": "Laurie River",
            "YDJ": "Hatchet Lake",
            "YDU": "Kasba Lake",
            "YFL": "Fort Reliance",
            "XCL": "Cluff Lake",
            "YKE": "Knee Lake",
            "SUR": "Summer Beaver",
            "CKD": "Crooked Creek",
            "YTT": "Tisdale",
            "YAX": "Angling Lake",
            "WNN": "Wunnumin Lake",
            "YBS": "Opapimiskan Lake",
            "YNO": "North Spirit Lake",
            "CKR": "Crane Island",
            "CKU": "Cordova",
            "YDW": "Obre Lake",
            "CKX": "Chicken",
            "CMT": "Cametá",
            "CMZ": "Caia",
            "ZKL": "Zigong (Gongjing)",
            "BZX": "Bazhong (Enyang)",
            "DFA": "Shangluo (Danfeng)",
            "HSC": "Shaoguan",
            "JGS": "Ji'an",
            "JNH": "Xiuzhou, Hangzhou",
            "DWS": "Hulunbuir",
            "LCT": "Shijiazhuang",
            "WHN": "Wuhan (Hannan)",
            "NAY": "Beijing",
            "PFA": "Harbin",
            "PNJ": "Yantai",
            "CBZ": "Binzhou",
            "DDR": "Xigazê (Dingri)",
            "HQL": "Tashikuergan",
            "HEW": "Jinhua (Dongyang)",
            "JDE": "Hangzhou",
            "HLJ": "Suihua",
            "TYC": "Taiyuan",
            "WRH": "Orku",
            "JRJ": "Ganzhou",
            "APJ": "Burang Town",
            "ZFL": "Zhaosu",
            "YEH": "Yinchuan",
            "LCS": "Dehong (Longchuan)",
            "LFH": "Lanping Bai",
            "ZGN": "Zhongshan",
            "BZJ": "Bozhou",
            "BKV": "Bailingmiao",
            "HJB": "Hejing",
            "OTQ": "Otog Front Banner",
            "JBK": "Qitai",
            "LIJ": "Lishui (Liandu)",
            "YHJ": "Nanchang",
            "OTO": "Wulan",
            "BFY": "Bengbu",
            "XBE": "Bearskin Lake",
            "YNP": "Natuashish",
            "YWR": "White River",
            "YPD": "Parry Sound",
            "XBR": "Brockville",
            "KIF": "Kingfisher Lake",
            "LCR": "La Chorrera",
            "YEB": "Echo Bay",
            "YSI": "Frying Pan Island",
            "KEW": "Keewaywin",
            "ACO": "Cóbano",
            "KFM": "Kirby Lake",
            "YSA": "Sable Island",
            "YLS": "Lebel-sur-Quévillon",
            "YNX": "Snap Lake Mine",
            "SSQ": "La Sarre",
            "YKU": "Chisasibi",
            "ZTB": "Tête-à-la-Baleine",
            "ZKG": "Côte-Nord-du-Golfe-du-Saint-Laurent",
            "YWQ": "Chutes-des-Passes",
            "CTP": "Carutapera",
            "YAU": "Kattiniq",
            "ZGS": "Le Golfe-du-Saint-Laurent",
            "YFG": "Fontanges",
            "ZLT": "La Tabatière",
            "CUJ": "Culion",
            "CXC": "Chitina",
            "YAB": "Arctic Bay",
            "YAC": "Cat Lake",
            "YAR": "La Grande-3",
            "YAG": "Fort Frances",
            "YAH": "La Grande-4",
            "YAL": "Alert Bay",
            "YAM": "Sault Ste Marie",
            "XKS": "Kasabonika",
            "YKG": "Kangirsuk",
            "YAT": "Attawapiskat",
            "YAY": "St. Anthony",
            "YAZ": "Tofino",
            "YBA": "Banff",
            "YBB": "Kugaaruk",
            "YBC": "Baie-Comeau",
            "QBC": "Bella Coola",
            "YBE": "Uranium City",
            "YBY": "Bonnyville",
            "YBG": "La Baie",
            "YBK": "Baker Lake",
            "YBL": "Campbell River",
            "XTL": "Tadoule Lake",
            "YBR": "Brandon",
            "YBT": "Brochet",
            "YBV": "Berens River",
            "YBX": "Blanc-Sablon",
            "YRF": "Cartwright",
            "YCB": "Cambridge Bay",
            "YCC": "Cornwall",
            "YCD": "Nanaimo",
            "YCE": "Huron Park",
            "YCG": "Castlegar",
            "YCH": "Miramichi",
            "XCM": "Chatham-Kent",
            "YCL": "Charlo",
            "YCN": "Cochrane",
            "YCO": "Kugluktuk",
            "YCQ": "Chetwynd",
            "YCR": "Cross Lake",
            "YCS": "Chesterfield Inlet",
            "YCT": "Coronation",
            "YCW": "Chilliwack",
            "YCY": "Clyde River",
            "YCZ": "Fairmont Hot Springs",
            "YDA": "Dawson City",
            "YDB": "Burwash Landing",
            "YDF": "Deer Lake",
            "YDL": "Dease Lake",
            "XRR": "Ross River",
            "YDN": "Dauphin",
            "YDO": "Dolbeau-Saint-Felicien",
            "YDP": "Nain",
            "YDQ": "Dawson Creek",
            "YEG": "Edmonton",
            "YEK": "Arviat",
            "YEL": "Elliot Lake",
            "YEM": "Sheguiandah",
            "YEN": "Estevan",
            "YER": "Fort Severn",
            "YET": "Edson",
            "YEU": "Eureka",
            "YEV": "Inuvik",
            "YEY": "Amos",
            "YFA": "Fort Albany",
            "YFB": "Iqaluit",
            "YFC": "Fredericton",
            "YFE": "Forestville",
            "YFH": "Fort Hope",
            "YTM": "La Macaza",
            "YFO": "Flin Flon",
            "YFR": "Fort Resolution",
            "YFS": "Fort Simpson",
            "YMN": "Makkovik",
            "YGB": "Texada",
            "YGH": "Fort Good Hope",
            "YGK": "Kingston",
            "YGL": "La Grande Rivière",
            "YGM": "Gimli",
            "YGO": "Gods Lake Narrows",
            "YGP": "Gaspé",
            "YGQ": "Geraldton",
            "YGR": "Les Îles-de-la-Madeleine",
            "YGT": "Igloolik",
            "YGV": "Havre-Saint-Pierre",
            "YGW": "Kuujjuarapik",
            "YGX": "Gillam",
            "YGZ": "Grise Fiord",
            "YQC": "Quaqtaq",
            "YHB": "Hudson Bay",
            "CXH": "Vancouver",
            "YHD": "Dryden",
            "YHE": "Hope",
            "YHF": "Hearst",
            "YNS": "Nemiscau",
            "YHI": "Ulukhaktok",
            "YHK": "Gjoa Haven",
            "YHM": "Hamilton",
            "YHN": "Hornepayne",
            "YHO": "Hopedale",
            "YHP": "Poplar Hill",
            "YHR": "Chevery",
            "YHT": "Haines Junction",
            "YHU": "Montréal",
            "YHY": "Hay River",
            "YHZ": "Halifax",
            "YIB": "Atikokan",
            "YDG": "Digby",
            "YIF": "St-Augustin",
            "YIK": "Ivujivik",
            "YIO": "Pond Inlet",
            "YIV": "Island Lake",
            "YJA": "Jasper",
            "YJF": "Fort Liard",
            "YJN": "St Jean",
            "YJT": "Stephenville",
            "YKA": "Kamloops",
            "YKC": "Collins Bay",
            "LAK": "Aklavik",
            "YKF": "Breslau",
            "YWB": "Kangiqsujuaq",
            "YKJ": "Key Lake",
            "YKL": "Schefferville",
            "YKD": "Kincardine",
            "AKV": "Akulivik",
            "YOG": "Ogoki Post",
            "YKQ": "Waskaganish",
            "YKX": "Kirkland Lake",
            "YKY": "Kindersley",
            "YPJ": "Aupaluk",
            "YLB": "Lac La Biche",
            "YLC": "Kimmirut",
            "YLD": "Chapleau",
            "YLH": "Lansdowne House",
            "YLJ": "Meadow Lake",
            "YSG": "Lutselk'e",
            "YLL": "Lloydminster",
            "YLQ": "La Tuque",
            "YLR": "Leaf Rapids",
            "YLK": "Barrie",
            "YLT": "Alert",
            "XGR": "Kangiqsualujjuaq",
            "YLW": "Kelowna",
            "CYM": "Chatham",
            "YMA": "Mayo",
            "YME": "Matane",
            "YMG": "Manitouwadge",
            "YMH": "Mary's Harbour",
            "YMJ": "Moose Jaw",
            "YML": "Charlevoix",
            "YMM": "Fort McMurray",
            "YMO": "Moosonee",
            "YMT": "Chibougamau",
            "YUD": "Umiujaq",
            "YMW": "Messines",
            "YMX": "Montréal",
            "YNA": "Natashquan",
            "YNC": "Wemindji",
            "YND": "Gatineau",
            "YNE": "Norway House",
            "YNH": "Hudson's Hope",
            "YLY": "Langley",
            "YNL": "Points North Landing",
            "YNM": "Matagami",
            "HZP": "Fort Mackay",
            "YOA": "Ekati",
            "YOC": "Old Crow",
            "YOD": "Cold Lake",
            "YOH": "Oxford House",
            "YOJ": "High Level",
            "YOO": "Oshawa",
            "YOP": "Rainbow Lake",
            "YOS": "Owen Sound",
            "YOW": "Ottawa",
            "YPA": "Prince Albert",
            "YPC": "Paulatuk",
            "YPS": "Port Hawkesbury",
            "YPE": "Peace River",
            "YPG": "Portage la Prairie",
            "YPH": "Inukjuak",
            "YPL": "Pickle Lake",
            "YPM": "Pikangikum",
            "YPN": "Port-Menier",
            "YPO": "Peawanuck",
            "YPQ": "Peterborough",
            "YPR": "Prince Rupert",
            "YPW": "Powell River",
            "YPX": "Puvirnituq",
            "YPY": "Fort Chipewyan",
            "YPZ": "Burns Lake",
            "YQA": "Gravenhurst",
            "YQB": "Quebec",
            "YQD": "The Pas",
            "YQF": "Springbrook",
            "YQG": "Windsor",
            "YQH": "Watson Lake",
            "YQI": "Yarmouth",
            "YQK": "Kenora",
            "YQL": "Lethbridge",
            "YQM": "Moncton",
            "YQN": "Nakina",
            "YQQ": "Comox",
            "YQR": "Regina",
            "YQS": "St Thomas",
            "YQT": "Thunder Bay",
            "YQU": "Grande Prairie",
            "YQV": "Yorkton",
            "YQW": "North Battleford",
            "YQX": "Gander",
            "YQY": "Sydney",
            "YQZ": "Quesnel",
            "YRA": "Gamètì",
            "YRB": "Resolute Bay",
            "YRI": "Rivière-du-Loup",
            "YRJ": "Roberval",
            "YRL": "Red Lake",
            "YRM": "Rocky Mountain House",
            "YRO": "Ottawa",
            "YRQ": "Trois-Rivières",
            "YRS": "Red Sucker Lake",
            "YRT": "Rankin Inlet",
            "YRV": "Revelstoke",
            "YSB": "Sudbury",
            "YSC": "Sherbrooke",
            "YSD": "Ralston",
            "YSE": "Squamish",
            "YSF": "Stony Rapids",
            "YSH": "Smiths Falls",
            "YSJ": "Saint John",
            "YSK": "Sanikiluaq",
            "YSL": "Saint-Léonard",
            "YSM": "Fort Smith",
            "YCM": "Niagara-on-the-Lake",
            "YSP": "Marathon",
            "YST": "St. Theresa Point",
            "YSU": "Slemon Park",
            "YSY": "Sachs Harbour",
            "YTA": "Pembroke",
            "YTE": "Kinngait",
            "YTF": "Alma",
            "YTH": "Thompson",
            "YTL": "Big Trout Lake",
            "YTQ": "Tasiujaq",
            "YTR": "Trenton",
            "YTS": "Timmins",
            "YTZ": "Toronto",
            "YUB": "Tuktoyaktuk",
            "YUL": "Montréal",
            "YUT": "Repulse Bay",
            "YUX": "Sanirajak",
            "YUY": "Rouyn-Noranda",
            "YVB": "Bonaventure",
            "YVC": "La Ronge",
            "YVG": "Vermilion",
            "YVE": "Vernon",
            "YCK": "Colville Lake",
            "YVM": "Qikiqtarjuaq",
            "YVO": "Val-d'Or",
            "YVP": "Kuujjuaq",
            "YVQ": "Norman Wells",
            "YVR": "Vancouver",
            "YVT": "Buffalo Narrows",
            "YVV": "Wiarton",
            "YVZ": "Deer Lake",
            "YWA": "Petawawa",
            "YFJ": "Wekweètì",
            "YWG": "Winnipeg",
            "YWH": "Victoria",
            "YWJ": "Déline",
            "YWK": "Wabush",
            "YWL": "Williams Lake",
            "YWP": "Webequie",
            "YWY": "Wrigley",
            "YXC": "Cranbrook",
            "YXE": "Saskatoon",
            "YXH": "Medicine Hat",
            "YXJ": "Fort Saint John",
            "YXK": "Rimouski",
            "YXL": "Sioux Lookout",
            "YXN": "Whale Cove",
            "YXP": "Pangnirtung",
            "YXQ": "Beaver Creek",
            "YXR": "Earlton",
            "YXS": "Prince George",
            "YXT": "Terrace",
            "YXU": "London",
            "YXX": "Abbotsford",
            "YXY": "Whitehorse",
            "YXZ": "Wawa",
            "YYB": "North Bay",
            "YYC": "Calgary",
            "YYD": "Smithers",
            "YYE": "Fort Nelson",
            "YYF": "Penticton",
            "YYG": "Charlottetown",
            "YYH": "Taloyoak",
            "YYJ": "Victoria",
            "YYL": "Lynn Lake",
            "YYM": "Cowley",
            "YYN": "Swift Current",
            "YYQ": "Churchill",
            "YYR": "Goose Bay",
            "YYT": "St. John's",
            "YYU": "Kapuskasing",
            "YYW": "Armstrong",
            "YYY": "Mont-Joli",
            "YYZ": "Toronto",
            "YZE": "Gore Bay",
            "YZF": "Yellowknife",
            "YZG": "Salluit",
            "YZH": "Slave Lake",
            "YZP": "Sandspit",
            "YZR": "Sarnia",
            "YZS": "Coral Harbour",
            "YZT": "Port Hardy",
            "YZU": "Whitecourt",
            "YZV": "Sept-Îles",
            "YZW": "Teslin",
            "YZX": "Greenwood",
            "ZAC": "York Landing",
            "YSN": "Salmon Arm",
            "YDT": "Delta",
            "ILF": "Ilford",
            "ZBF": "South Tetagouche",
            "ZBM": "Bromont",
            "KES": "Kelsey",
            "ZEM": "Eastmain River",
            "ZFA": "Faro",
            "ZFD": "Fond-du-Lac",
            "XPK": "Pukatawagan",
            "ZFM": "Fort Mcpherson",
            "ZFN": "Tulita",
            "ZGF": "Grand Forks",
            "ZGI": "Gods River",
            "ZGR": "Little Grand Rapids",
            "ZHP": "High Prairie",
            "CZJ": "Tupile",
            "ZJG": "Jenpeg",
            "ZJN": "Swan River",
            "ZKE": "Kashechewan",
            "YTD": "Thicket Portage",
            "MSA": "Muskrat Dam",
            "ZMH": "108 Mile",
            "PIW": "Pikwitonei",
            "ZMT": "Masset",
            "CZN": "Chisana",
            "XPP": "Poplar River",
            "CZO": "Chistochina",
            "ZPB": "Sachigo Lake",
            "WPC": "Pincher Creek",
            "ZPO": "Pinehouse Lake",
            "ZRJ": "Round Lake",
            "ZSJ": "Sandy Lake",
            "XSI": "South Indian Lake",
            "ZST": "Stewart",
            "ZSW": "Prince Rupert",
            "YDV": "Bloodvein River",
            "ZTM": "Shamattawa",
            "ZUC": "Ignace",
            "ZUM": "Churchill Falls",
            "XLB": "Lac Brochet",
            "ZWL": "Wollaston Lake",
            "IUA": "Ontario County IDA",
            "DJN": "Delta Junction",
            "MQV": "Sayada",
            "BUJ": "Ouled Sidi Brahim",
            "BJA": "Béjaïa",
            "ALG": "Algiers",
            "DJG": "Djanet",
            "VVZ": "Illizi",
            "QSF": "Sétif",
            "TMR": "Tamanrasset",
            "GJL": "Tahir",
            "MZW": "Mecheria",
            "AAE": "Annaba",
            "CZL": "Constantine",
            "QMH": "Oum El Bouaghi",
            "TEE": "Tébessi",
            "BLJ": "Batna",
            "HRM": "Hassi R'Mel",
            "DAH": "Dathina",
            "TID": "Tiaret",
            "TIN": "Tindouf",
            "CFK": "Chlef",
            "TAF": "Tafraoui",
            "TLM": "Zenata",
            "ORN": "Es-Sénia",
            "CBH": "Béchar",
            "BFW": "Sidi Bel Abbès",
            "MUW": "Ghriss",
            "EBH": "El Bayadh",
            "INF": "In Guezzam",
            "BMW": "Bordj Badji Mokhtar",
            "AZR": "Adrar",
            "BSK": "Biskra",
            "ELG": "El Menia",
            "GHA": "El Atteuf",
            "HME": "Hassi Messaoud",
            "INZ": "In Salah",
            "TGR": "Touggourt",
            "LOO": "Laghouat",
            "ELU": "Guemar",
            "TMX": "Timimoun",
            "OGX": "Ouargla",
            "IAM": "In Aménas",
            "COO": "Cotonou",
            "DJA": "Djougou",
            "KDC": "Kandi",
            "NAE": "Natitingou",
            "PKO": "Parakou",
            "SVF": "Savé",
            "DBK": "Kalpitiya Island",
            "DBU": "Dambulla",
            "DCK": "Dahl Creek",
            "DEQ": "Huzhou",
            "DEX": "Dekai",
            "XKY": "Kaya",
            "OUG": "Ouahigouya",
            "XDJ": "Djibo",
            "XLU": "Leo",
            "PUP": "Po",
            "XBO": "Boulsa",
            "XBG": "Bogande",
            "DIP": "Diapaga",
            "DOR": "Dori",
            "FNG": "Fada N'gourma",
            "XGG": "Gorom-Gorom",
            "XKA": "Kantchari",
            "TMQ": "Tambao",
            "XPA": "Pama",
            "ARL": "Arly",
            "XSE": "Sebba",
            "TEG": "Tenkodogo",
            "XZA": "Zabré",
            "OUA": "Ouagadougou",
            "BNR": "Banfora",
            "DGU": "Dedougou",
            "XGA": "Gaoua",
            "XNU": "Nouna",
            "BOY": "Bobo Dioulasso",
            "TUQ": "Tougan",
            "XDE": "Diebougou",
            "XAR": "Aribinda",
            "ACC": "Accra",
            "TML": "Tamale",
            "WZA": "Wa",
            "DGM": "Colombo",
            "KMS": "Kumasi",
            "NYI": "Sunyani",
            "TKD": "Sekondi-Takoradi",
            "DHB": "Deer Harbor",
            "DHG": "Dalnegorsk",
            "DHL": "Ad-Dali",
            "ABO": "Aboisso",
            "ABJ": "Abidjan",
            "OGO": "Abengourou",
            "BXI": "Boundiali",
            "BYK": "Bouaké",
            "BQO": "Bouna",
            "BDK": "Bondoukou",
            "DIM": "Dimbokro",
            "GGN": "Gagnoa",
            "GGO": "Guiglo",
            "BBV": "Grand-Béréby",
            "HGO": "Korhogo",
            "KEO": "Odienne",
            "OFI": "Ouango Fitini",
            "SEO": "Séguéla",
            "ZSS": "Sassandra",
            "TXU": "Tabou",
            "TOZ": "Touba",
            "DIW": "Dickwella",
            "ASK": "Yamoussoukro",
            "DLR": "Dalnerechensk",
            "DIO": "Diomede",
            "DKA": "Katsina",
            "ABV": "Abuja",
            "QUO": "Uyo",
            "AKR": "Akure",
            "ABB": "Asaba",
            "BCU": "Bauchi",
            "BNI": "Benin",
            "CBQ": "Calabar",
            "ENU": "Enegu",
            "GMO": "Gombe",
            "IBA": "Ibadan",
            "ILR": "Ilorin",
            "QOW": "Owerri",
            "JOS": "Jos",
            "KAD": "Kaduna",
            "KAN": "Kano",
            "MIU": "Maiduguri",
            "MDI": "Makurdi",
            "LOS": "Lagos",
            "MXJ": "Minna",
            "PHC": "Port Harcourt",
            "SKO": "Sokoto",
            "QRW": "Okpe",
            "YOL": "Yola",
            "ZAR": "Zaria",
            "DPT": "Deputatskiy",
            "MFQ": "Maradi",
            "NIM": "Niamey",
            "THZ": "Tahoua",
            "AJY": "Agadez",
            "RLT": "Arlit",
            "ZND": "Zinder",
            "DSG": "Dilasag",
            "TBJ": "Tabarka",
            "MIR": "Monastir",
            "NBE": "Enfidha",
            "TUN": "Tunis",
            "GAF": "Gafsa",
            "GAE": "Gabès",
            "DJE": "Mellita",
            "EBM": "El Borma",
            "SFA": "Sfax",
            "TOE": "Tozeur",
            "DVD": "Andavadoaka",
            "DWO": "Sri Jayawardenepura Kotte",
            "LRL": "Niamtougou",
            "LFW": "Lomé",
            "EAL": "Mejato Island",
            "ANR": "Antwerp",
            "BRU": "Zaventem",
            "CRL": "Charleroi",
            "GNE": "Gent",
            "KJK": "Wevelgem",
            "LGG": "Grâce-Hollogne",
            "EBO": "Ebon Atoll",
            "OST": "Oostende",
            "OBL": "Zoersel",
            "MZD": "Santiago de Méndez",
            "EDA": "Edna Bay",
            "AOC": "Nobitz",
            "HDF": "Zirchow",
            "IES": "Riesa",
            "REB": "Lärz",
            "CSO": "Hecklingen",
            "BBH": "Barth",
            "FNB": "Trollenhagen",
            "GTI": "Dreschvitz",
            "KOQ": "Köthen (Anhalt)",
            "PEF": "Peenemünde",
            "BER": "Berlin",
            "DRS": "Dresden",
            "ERF": "Erfurt",
            "FRA": "Frankfurt am Main",
            "FMO": "Greven",
            "HAM": "Hamburg",
            "CGN": "Köln (Cologne)",
            "DUS": "Düsseldorf",
            "MUC": "Munich",
            "NUE": "Nuremberg",
            "LEJ": "Schkeuditz",
            "SCN": "Saarbrücken",
            "STR": "Stuttgart",
            "HAJ": "Hannover",
            "BRE": "Bremen",
            "HHN": "Frankfurt am Main (Lautzenhausen)",
            "MHG": "Mannheim",
            "EIB": "Hörselberg-Hainich",
            "ZOE": "Ludwigshafen am Rhein",
            "SGE": "Burbach",
            "IZE": "Hohenlockstedt",
            "XFW": "Hamburg",
            "KEL": "Kiel",
            "LBC": "Lübeck",
            "EUM": "Neumünster",
            "FMM": "Memmingen",
            "AAH": "Aachen",
            "ESS": "Essen",
            "BFE": "Bielefeld",
            "MGL": "Mönchengladbach",
            "PAD": "Büren",
            "NRN": "Weeze",
            "DTM": "Dortmund",
            "AGB": "Augsburg",
            "OBF": "Weßling",
            "RBM": "Atting",
            "FDH": "Friedrichshafen",
            "BYU": "Bindlach",
            "URD": "Ebermannstadt",
            "GHF": "Giebelstadt",
            "HOQ": "Hof",
            "BBJ": "Bitburg",
            "ZQW": "Zweibrücken",
            "FKB": "Rheinmünster",
            "LHA": "Lahr/Schwarzwald",
            "BWE": "Braunschweig",
            "KSF": "Calden",
            "EME": "Emden",
            "AGE": "Wangerooge",
            "WVN": "Wilhelmshaven",
            "JUI": "Juist",
            "LGO": "Langeoog",
            "BMK": "Borkum",
            "NOD": "Norddeich",
            "VAC": "Cloppenburg",
            "NRD": "Norderney",
            "BMR": "Baltrum",
            "HEI": "Oesterdeichstrich",
            "FLF": "Flensburg",
            "HGL": "Helgoland",
            "QHU": "Husum",
            "PSH": "Sankt Peter-Ording",
            "GWT": "Sylt",
            "OHR": "Wyk auf Föhr",
            "CHE": "Tallinn",
            "KDL": "Kärdla",
            "URE": "Kuressaare",
            "EPU": "Pärnu",
            "EES": "Berenice Troglodytica",
            "TLL": "Tallinn",
            "TAY": "Reola",
            "ENF": "Enontekio",
            "KEV": "Jämsä",
            "HEN": "Helsinki",
            "HEL": "Helsinki (Vantaa)",
            "HYV": "Hyvinkää",
            "KTQ": "Kitee",
            "IVL": "Ivalo",
            "JOE": "Joensuu",
            "JYV": "Jyväskylän Maalaiskunta",
            "KAU": "Kauhava",
            "KEM": "Kemi / Tornio",
            "KAJ": "Kajaani",
            "KHJ": "Kauhajoki",
            "KOK": "Kokkola / Kruunupyy",
            "KAO": "Kuusamo",
            "KTT": "Kittilä",
            "KUO": "Kuopio / Siilinjärvi",
            "LPP": "Lappeenranta",
            "MHQ": "Mariehamn",
            "MIK": "Mikkeli",
            "OUL": "Oulu / Oulunsalo",
            "POR": "Pori",
            "RVN": "Rovaniemi",
            "SVL": "Savonlinna",
            "SJY": "Seinäjoki / Ilmajoki",
            "SOT": "Sodankyla",
            "TMP": "Tampere / Pirkkala",
            "TKU": "Turku",
            "UTI": "Utti / Valkeala",
            "VAA": "Vaasa",
            "VRK": "Varkaus / Joroinen",
            "YLI": "Ylivieska",
            "TFR": "New Cairo",
            "AUE": "Ras Abu Rudeis",
            "BFS": "Belfast",
            "ENK": "Enniskillen, Fermanagh and Omagh",
            "BHD": "Belfast",
            "LDY": "Derry",
            "BHX": "Birmingham, West Midlands",
            "CVT": "Coventry, West Midlands",
            "GLO": "Staverton",
            "ORM": "Northampton, Northamptonshire",
            "GBA": "Cirencester, Gloucestershire",
            "MAN": "Manchester, Greater Manchester",
            "UPV": "Pewsey, Wiltshire",
            "YEO": "Yeovil, Somerset",
            "CAL": "Campbeltown",
            "EOI": "Eday",
            "FIE": "Fair Isle",
            "WHS": "Whalsay, Shetlands",
            "SKL": "Ashaig",
            "COL": "Coll Island",
            "NRL": "North Ronaldsay",
            "OBN": "North Connel",
            "PPW": "Papa Westray",
            "SOY": "Stronsay",
            "NDY": "Sanday",
            "LWK": "Lerwick, Shetland Islands",
            "WRY": "Westray",
            "CSA": "Colonsay",
            "HAW": "Haverfordwest",
            "CWL": "Cardiff",
            "SWS": "Swansea",
            "BRS": "Bristol",
            "LPL": "Liverpool",
            "LTN": "Luton, Bedfordshire",
            "LEQ": "Land's End, Cornwall",
            "ISC": "St. Mary's, Isles of Scilly",
            "BOH": "Bournemouth",
            "SOU": "Southampton",
            "BBP": "Bembridge, Isle of Wight",
            "NQY": "Newquay",
            "QUG": "Chichester, West Sussex",
            "ACI": "Saint Anne",
            "GCI": "Saint Peter Port",
            "JER": "St. Peter",
            "ESH": "Brighton, East Sussex",
            "BQH": "London",
            "LGW": "London",
            "LCY": "London",
            "FAB": "Farnborough, Hampshire",
            "BBS": "Camberley, Surrey",
            "LHR": "London",
            "SEN": "Southend-on-Sea, Essex",
            "LYX": "Romney Marsh, Kent",
            "CAX": "Carlisle, Cumbria",
            "BLK": "Blackpool",
            "HUY": "Grimsby, Lincolnshire",
            "BWF": "Barrow-in-Furness",
            "LBA": "Leeds, West Yorkshire",
            "WRT": "Warton",
            "CEG": "Broughton",
            "IOM": "Castletown",
            "NCL": "Newcastle upon Tyne, Tyne and Wear",
            "MME": "Darlington, Durham",
            "EMA": "Nottingham",
            "VLY": "Angelsey",
            "KOI": "Orkney Islands",
            "LSI": "Lerwick, Shetland",
            "WIC": "Wick",
            "ABZ": "Aberdeen",
            "INV": "Inverness",
            "GLA": "Glasgow",
            "EDI": "Edinburgh",
            "ILY": "Isle of Islay, Argyll and Bute",
            "PIK": "Prestwick, South Ayrshire",
            "BEB": "Balivanich",
            "DND": "Dundee",
            "SYY": "Stornoway, Western Isles",
            "BRR": "Eoligarry",
            "PSL": "Perth",
            "TRE": "Balemartine",
            "ADX": "Leuchars, Fife",
            "LMO": "Lossiemouth",
            "CBG": "Cambridge, Cambridgeshire",
            "NWI": "Norwich, Norfolk",
            "STN": "London",
            "HYC": "Marlow, Buckinghamshire",
            "EXT": "Exeter, Devon",
            "OXF": "Kidlington, Oxfordshire",
            "RCS": "Rochester, Kent",
            "BEX": "Wallingford, Oxfordshire",
            "LKZ": "Brandon, Suffolk",
            "MHZ": "Bury Saint Edmunds, Suffolk",
            "FFD": "Fairford, Gloucestershire",
            "BZZ": "Carterton, Oxfordshire",
            "ODH": "Hook, Hampshire",
            "NHT": "London",
            "QCY": "Lincoln, Lincolnshire",
            "BEQ": "Bury Saint Edmunds, Suffolk",
            "WTN": "Lincoln, Lincolnshire",
            "KNF": "King's Lynn, Norfolk",
            "MPN": "Mount Pleasant",
            "AMS": "Amsterdam",
            "MST": "Maastricht",
            "EIN": "Eindhoven",
            "GRQ": "Groningen",
            "GLZ": "Rijen",
            "DHR": "Den Helder",
            "LEY": "Lelystad",
            "LWR": "Leeuwarden",
            "RTM": "Rotterdam",
            "ENS": "Enschede",
            "UDE": "Uden",
            "WOE": "Hoogerheide",
            "BYT": "Bantry",
            "BLY": "Belmullet",
            "NNR": "Inverin",
            "ORK": "Cork",
            "CFN": "Donegal",
            "DUB": "Dublin",
            "IOR": "Inis Mór",
            "INQ": "Inis Oírr",
            "KKY": "Kilkenny",
            "NOC": "Charlestown",
            "KIR": "Farranfore",
            "IIA": "Inis Meáin",
            "SNN": "Shannon",
            "SXL": "Sligo",
            "WAT": "Waterford",
            "EJN": "Ejin Banner",
            "EJT": "Enejit Island",
            "AAR": "Aarhus",
            "BLL": "Billund",
            "CPH": "Copenhagen",
            "EBJ": "Esbjerg",
            "KRP": "Karup",
            "BYR": "Læsø",
            "MRW": "Rødby",
            "ODE": "Odense",
            "RKE": "Roskilde",
            "RNN": "Rønne",
            "SGD": "Sønderborg",
            "CNL": "Sindal",
            "SKS": "Vojens",
            "SQW": "Skive",
            "TED": "Thisted",
            "FAE": "Vágar",
            "STA": "Skjern",
            "AAL": "Aalborg",
            "LUX": "Luxembourg",
            "EMR": "El Mirador",
            "AES": "Ålesund",
            "ANX": "Andenes",
            "ALF": "Alta",
            "FDE": "Førde",
            "BNN": "Brønnøy",
            "BOO": "Bodø",
            "BGO": "Bergen",
            "BJF": "Båtsfjord",
            "BVG": "Berlevåg",
            "KRS": "Kjevik",
            "BDU": "Målselv",
            "EVE": "Evenes",
            "FRO": "Florø",
            "OSL": "Oslo (Gardermoen)",
            "HMR": "Hamar",
            "HAU": "Karmøy",
            "HFT": "Hammerfest",
            "HAA": "Hasvik",
            "HVG": "Honningsvåg",
            "KSU": "Kvernberget",
            "GLL": "Klanten flyplass",
            "KKN": "Kirkenes",
            "LKN": "Leknes",
            "MEH": "Mehamn",
            "MOL": "Årø",
            "MJF": "Mosjøen",
            "LKL": "Lakselv",
            "OSY": "Namsos",
            "NTB": "Notodden",
            "OLA": "Ørland",
            "HOV": "Ørsta",
            "MQN": "Mo i Rana",
            "RVK": "Rørvik",
            "RRS": "Røros",
            "RET": "Røst",
            "LYR": "Longyearbyen",
            "SDN": "Sandane",
            "SOG": "Sogndal",
            "SVJ": "Svolvær",
            "SKN": "Hadsel",
            "SRP": "Leirvik",
            "SOJ": "Sørkjosen",
            "VAW": "Vardø",
            "SSJ": "Alstahaug",
            "TOS": "Tromsø",
            "TRF": "Torp",
            "TRD": "Trondheim",
            "VDS": "Vadsø",
            "VRY": "Værøy",
            "SVG": "Stavanger",
            "BZG": "Bydgoszcz",
            "GDN": "Gdańsk",
            "KRK": "Balice",
            "KTW": "Katowice",
            "LUZ": "Lublin",
            "LCJ": "Łódź",
            "WMI": "Nowy Dwór Mazowiecki",
            "POZ": "Poznań",
            "RDO": "Radom",
            "RZE": "Jasionka",
            "SZZ": "Glewice",
            "SZY": "Szymany",
            "WAW": "Warsaw",
            "WRO": "Wrocław",
            "IEG": "Nowe Kramsko",
            "ERT": "Erdenet",
            "RNB": "Ronneby",
            "GOT": "Göteborg",
            "JKG": "Jönköping",
            "LDK": "Lidköping",
            "GSE": "Göteborg",
            "KVB": "Skövde",
            "THN": "Trollhättan",
            "KSK": "Karlskoga",
            "MXX": "Mora",
            "NYO": "Nyköping",
            "SCR": "Malung-Sälen",
            "KID": "Kristianstad",
            "OSK": "Oskarshamn",
            "KLR": "Kalmar",
            "MMX": "Malmö",
            "HAD": "Halmstad",
            "VXO": "Växjö",
            "EVG": "Sveg",
            "GEV": "Gällivare",
            "KRF": "Nyland",
            "LYC": "Lycksele",
            "SDL": "Sundsvall/ Härnösand",
            "OER": "Örnsköldsvik",
            "KRN": "Kiruna",
            "SFT": "Skellefteå",
            "UME": "Umeå",
            "VHM": "Vilhelmina",
            "AJR": "Arvidsjaur",
            "SOO": "Söderhamn",
            "OSD": "Östersund",
            "ORB": "Örebro",
            "HFS": "Råda",
            "KSD": "Karlstad",
            "VST": "Stockholm / Västerås",
            "LLA": "Luleå",
            "ARN": "Stockholm",
            "BMA": "Stockholm",
            "BLE": "Borlange",
            "HLF": "Hultsfred",
            "GVX": "Gävle / Sandviken",
            "LPI": "Linköping",
            "NRK": "Norrköping",
            "TYF": "Torsby",
            "EKT": "Eskilstuna",
            "VBY": "Visby",
            "VVK": "Västervik",
            "AGH": "Ängelholm",
            "SQO": "Storuman",
            "IDB": "Idre",
            "PJA": "Pajala",
            "HMV": "Hemavan",
            "GLC": "Geladi",
            "SHC": "Shire Inda Selassie",
            "SPM": "Trier",
            "RMS": "Ramstein-Miesenbach",
            "FRZ": "Fritzlar",
            "ILH": "Illesheim",
            "KZG": "Kitzingen",
            "FCN": "Wurster Nordseeküste",
            "GKE": "Geilenkirchen",
            "RLG": "Laage",
            "WBG": "Jagel",
            "WIE": "Wiesbaden",
            "IGS": "Manching",
            "LPX": "Liepāja",
            "RIX": "Riga",
            "VNT": "Ventspils",
            "EXI": "Excursion Inlet",
            "KUN": "Kaunas",
            "PLQ": "Palanga",
            "PNV": "Panevėžys",
            "SQQ": "Šiauliai",
            "VNO": "Vilnius",
            "RGR": "Ranger",
            "ALJ": "Alexander Bay",
            "AGZ": "Aggeneys",
            "ADY": "Alldays",
            "BIY": "Bisho",
            "BFN": "Bloemfontain",
            "UTE": "Bultfontein",
            "ASS": "Arathusa",
            "CDO": "Cradock",
            "CPT": "Cape Town",
            "DUK": "Mubatuba",
            "PZL": "Phinda",
            "ELS": "East London",
            "EMG": "Empangeni",
            "ELL": "Ellisras",
            "FCB": "Ficksburg",
            "GCJ": "Midrand",
            "GRJ": "George",
            "GIY": "Giyani",
            "QRA": "Johannesburg",
            "HLW": "Hluhluwe",
            "HRS": "Harrismith",
            "HDS": "Hoedspruit",
            "KXE": "Klerksdorp",
            "KIM": "Kimberley",
            "MQP": "Mpumalanga",
            "KOF": "Komatipoort",
            "KMH": "Kuruman",
            "KLZ": "Kleinsee",
            "HLA": "Johannesburg",
            "LMR": "Lime Acres",
            "LDZ": "Londolozi",
            "DUR": "Durban",
            "LCD": "Louis Trichardt",
            "SDB": "Langebaanweg",
            "LAY": "Ladysmith",
            "AAM": "Malamala",
            "MGH": "Margate",
            "MEZ": "Musina",
            "MBD": "Mafeking",
            "LLE": "Malelane",
            "MZY": "Mossel Bay",
            "MZQ": "Mkuze",
            "NCS": "Newcastle",
            "NGL": "Ngala",
            "NLP": "Nelspruit",
            "OVG": "Overberg",
            "OUH": "Oudtshoorn",
            "JNB": "Johannesburg",
            "AFD": "Port Alfred",
            "PLZ": "Gqeberha (Port Elizabeth)",
            "PBZ": "Plettenberg Bay",
            "PHW": "Phalaborwa",
            "JOH": "Port St Johns",
            "PRK": "Prieska",
            "PZB": "Pietermaritzburg",
            "NTY": "Pilanesberg",
            "PTG": "Polokwane",
            "PCF": "Potchefstroom",
            "UTW": "Queenstown",
            "RCB": "Richards Bay",
            "RVO": "Reivilo",
            "ROD": "Robertson",
            "SBU": "Springbok",
            "ZEC": "Secunda",
            "GSS": "Belfast",
            "SIS": "Sishen",
            "SZK": "Skukuza",
            "THY": "Thohoyandou",
            "TCU": "Homeward",
            "LTA": "Tzaneen",
            "ULD": "Ulundi",
            "UTN": "Upington",
            "ULX": "Ulusaba",
            "UTT": "Mthatha",
            "VRU": "Vyrburg",
            "VIR": "Durban",
            "VRE": "Vredendal",
            "VYD": "Vryheid",
            "PRY": "Pretoria",
            "WKF": "Pretoria",
            "WEL": "Welkom",
            "FRW": "Francistown",
            "GNZ": "Ghanzi",
            "JWA": "Jwaneng",
            "BBK": "Kasane",
            "KHW": "Khwai River Lodge",
            "LOQ": "Lobatse",
            "MUB": "Maun",
            "ORP": "Orapa",
            "GBE": "Gaborone",
            "SXN": "Sowa",
            "PKW": "Selebi Phikwe",
            "SVT": "Savuti",
            "SWX": "Shakawe",
            "TLD": "Tuli Lodge",
            "TBY": "Tshabong",
            "BZV": "Brazzaville",
            "DJM": "Djambala",
            "KNJ": "Kindamba",
            "LCO": "Lague",
            "MUY": "Mouyondzi",
            "SIB": "Sibiti",
            "NKY": "Nkayi",
            "ANJ": "Zanaga",
            "MSX": "Mossendjo",
            "BOE": "Boundji",
            "OLL": "Oyo",
            "EWO": "Ewo",
            "GMM": "Gamboma",
            "ION": "Impfondo",
            "KEE": "Kelle",
            "MKJ": "Makoua",
            "FTX": "Owando",
            "SOE": "Souanke",
            "BTB": "Betou",
            "KMK": "Makabana",
            "DIS": "Dolisie",
            "PNR": "Pointe Noire",
            "MTS": "Manzini",
            "SHO": "Mpaka",
            "CRF": "Carnot",
            "BGF": "Bangui",
            "BGU": "Bangassou",
            "IRO": "Birao",
            "BBY": "Bambari",
            "NDL": "N'Délé",
            "BOP": "Bouar",
            "BIV": "Bria",
            "BSN": "Bossangoa",
            "BBT": "Berbérati",
            "ODA": "Ouadda",
            "AIG": "Yalinga",
            "IMO": "Zemio",
            "MKI": "Mboki",
            "BTG": "Batangafo",
            "GDI": "Melle",
            "BMF": "Bakouma",
            "ODJ": "Ouanda Djallé",
            "RFA": "Rafaï",
            "BCF": "Bouca",
            "BOZ": "Bozoum",
            "NBN": "San Antonio de Palé",
            "BSG": "Bata",
            "GEM": "Mengomeyén",
            "SSG": "Malabo",
            "ASI": "Cat Hill",
            "HLE": "Longwood",
            "MRU": "Plaine Magnien",
            "RRG": "Port Mathurin",
            "KVU": "Korolevu",
            "NKW": "Diego Garcia",
            "KBI": "Kribi",
            "TKC": "Tiko",
            "DLA": "Douala",
            "MMF": "Mamfe",
            "BLC": "Bali",
            "KLE": "Kaélé",
            "OUR": "Batouri",
            "GXX": "Yagoua",
            "MVR": "Maroua",
            "FOM": "Foumban",
            "NGE": "N'Gaoundéré",
            "BTA": "Bertoua",
            "GOU": "Garoua",
            "DSC": "Dschang",
            "BFX": "Bafoussam",
            "BPC": "Bamenda",
            "EBW": "Ebolowa",
            "YAO": "Yaoundé",
            "NSI": "Yaoundé",
            "MMQ": "Mbala",
            "CIP": "Chipata",
            "CGX": "Chunga",
            "JEK": "Jeki",
            "CGJ": "Chingola",
            "KLB": "Kalabo",
            "KMZ": "Kaoma",
            "KAA": "Kasama",
            "ZKB": "Kasaba Bay",
            "LVI": "Livingstone",
            "LXU": "Lukulu",
            "LUN": "Lusaka",
            "MNS": "Mansa",
            "MFU": "Mfuwe",
            "MNR": "Mongu",
            "ZGM": "Ngoma",
            "RYL": "Lower Zambezi River",
            "NLA": "Ndola",
            "SXG": "Senanga",
            "KIW": "Kitwe",
            "SJQ": "Sesheke",
            "SLI": "Solwesi",
            "FLT": "Flat",
            "BBZ": "Zambezi",
            "ULI": "Falalop Island",
            "HAH": "Moroni",
            "NWA": "Fomboni",
            "AJN": "Ouani",
            "DZA": "Dzaoudzi",
            "RUN": "Sainte-Marie",
            "ZSE": "Saint-Pierre",
            "OHB": "Moramanga",
            "WML": "Malaimbandy",
            "ATJ": "Antsirabe",
            "WAQ": "Antsalova",
            "VVB": "Mahanoro",
            "TNR": "Antananarivo",
            "JVA": "Ankavandra",
            "BMD": "Belo sur Tsiribihina",
            "ZVA": "Miandrivazo",
            "MXT": "Maintirano",
            "ILK": "Ilaka",
            "TVA": "Morafenobe",
            "SMS": "Vohilava",
            "TMM": "Toamasina",
            "WTA": "Tambohorano",
            "MOQ": "Morondava",
            "WTS": "Tsiroanomandidy",
            "VAT": "Vatomandry",
            "WAM": "Ambatondrazaka",
            "DIE": "Antisiranana",
            "WBE": "Bealanana",
            "WMR": "Mananara Nord",
            "WBD": "Befandriana",
            "WPB": "Port Bergé",
            "ANM": "Antsirabe",
            "HVA": "Analalava",
            "MJN": "Mahajanga",
            "NOS": "Nosy Be",
            "DWB": "Soalala",
            "WMP": "Mampikony",
            "BPY": "Besalampy",
            "WMN": "Maroantsetra",
            "SVB": "Sambava",
            "TTS": "Tsaratanana",
            "VOH": "Vohemar",
            "WAI": "Antsohihy",
            "WMA": "Mandritsara",
            "WBO": "Beroroha",
            "WMD": "Mandabe",
            "FTU": "Tôlanaro",
            "WFI": "Fianarantsoa",
            "RVA": "Farafangana",
            "IHO": "Ihosy",
            "MJA": "Manja",
            "WVK": "Manakara",
            "OVA": "Bekily",
            "MNJ": "Mananjary",
            "TDV": "Tanandava",
            "MXM": "Morombe",
            "TLE": "Toliara",
            "VND": "Vangaindrano",
            "BKU": "Betioky",
            "AMP": "Ampanihy",
            "WAK": "Ankazoabo",
            "AZZ": "Ambriz",
            "SSY": "Mbanza Congo",
            "BUG": "Benguela",
            "NBJ": "Luanda (Ícolo e Bengo)",
            "GGC": "Lumbala N'guimbo",
            "CAB": "Cabinda",
            "CFF": "Cafunfo",
            "PGI": "Chitato",
            "KNP": "Capanda",
            "CBT": "Catumbela",
            "CTI": "Cuito Cuanavale",
            "CXM": "Camaxilo",
            "CAV": "Cazombo",
            "FND": "Funadhoo",
            "DUE": "Chitato",
            "VPE": "Ngiva",
            "NOV": "Huambo",
            "SVP": "Kuito",
            "LLT": "Lobito",
            "LBZ": "Lucapa",
            "LAD": "Luanda",
            "LZM": "Luzamba",
            "MEG": "Malanje",
            "SPP": "Menongue",
            "MSZ": "Moçâmedes",
            "GXG": "Negage",
            "PBN": "Port Amboim",
            "VHC": "Saurimo",
            "SZA": "Soyo",
            "NDD": "Sumbe",
            "UAL": "Luau",
            "SDD": "Lubango",
            "LUO": "Luena",
            "UGO": "Uige",
            "CEO": "Waco Kungo",
            "XGN": "Xangongo",
            "ARZ": "N'zeto",
            "NZA": "Nzagi",
            "AKE": "Akieni",
            "BGB": "Booue",
            "KDN": "Ndende",
            "FOU": "Fougamou",
            "MBC": "M'Bigou",
            "MGX": "Moabi",
            "KDJ": "N'Djolé",
            "KOU": "Koulamoutou",
            "MJL": "Mouila",
            "OYE": "Oyem",
            "OKN": "Okondja",
            "LBQ": "Lambarene",
            "MVX": "Minvoul",
            "AWE": "Wonga Wongué Presidential Reserve",
            "BMM": "Bitam",
            "MFF": "Moanda",
            "MKB": "Mekambo",
            "POG": "Port Gentil",
            "OMB": "Omboue",
            "IGE": "Iguela",
            "MKU": "Makokou",
            "LBV": "Libreville",
            "MZC": "Mitzic",
            "MVB": "Franceville",
            "LTL": "Lastourville",
            "TCH": "Tchibanga",
            "MYB": "Mayumba",
            "FOY": "Foya",
            "PCP": "São Tomé & Príncipe",
            "TMS": "São Tomé",
            "ANO": "Angoche",
            "BEW": "Beira",
            "FXO": "Cuamba",
            "VPY": "Chimoio",
            "IHC": "Inhaca",
            "IBO": "Ibo",
            "INH": "Inhambane",
            "VXC": "Lichinga",
            "LFB": "Lumbo",
            "MPM": "Maputo",
            "MUD": "Mueda",
            "MZB": "Mocímboa da Praia",
            "MNC": "Nacala",
            "APL": "Nampula",
            "POL": "Pemba",
            "PDD": "Ponta do Ouro",
            "UEL": "Quelimane",
            "TET": "Tete",
            "VNX": "Vilanculo",
            "VJB": "Xai-Xai",
            "DES": "Desroches Island",
            "SEZ": "Mahe Island",
            "FSL": "Fossil Downs Station",
            "PRI": "Praslin Island",
            "BDI": "Bird Island",
            "DEI": "Denis Island",
            "FRK": "Frégate Island",
            "SRH": "Sarh",
            "OGR": "Bongor",
            "AEH": "Abeche",
            "MQQ": "Moundou",
            "LTC": "Lai",
            "ATV": "Ati",
            "NDJ": "N'Djamena",
            "BKR": "Bokoro",
            "OTC": "Bol",
            "MVO": "Mongo",
            "AMC": "Am Timan",
            "PLF": "Pala",
            "OUT": "Bousso",
            "AMO": "Mao",
            "FYT": "Faya-Largeau",
            "FUB": "Fulleborn",
            "BZH": "Bumi",
            "BUQ": "Bulawayo",
            "CHJ": "Chipinge",
            "BFO": "Chiredzi",
            "VFA": "Victoria Falls",
            "HRE": "Harare",
            "KAB": "Kariba",
            "MJW": "Gonarezhou National Park",
            "UTA": "Mutare",
            "MVZ": "Masvingo",
            "GWE": "Gweru",
            "HWN": "Gwayi River Farms",
            "WKI": "Hwange",
            "BLZ": "Blantyre",
            "CMK": "Club Makokola",
            "DWA": "Dwangwa",
            "KGJ": "Karonga",
            "KBQ": "Kasungu",
            "LLW": "Lumbadzi",
            "LIX": "Likoma Island",
            "MYZ": "Monkey Bay",
            "LMB": "Salima",
            "ZZU": "Mzuzu",
            "LEF": "Lebakeng",
            "LRB": "Leribe",
            "LES": "Lesobeng",
            "MSG": "Matsaile",
            "MFC": "Mafeteng",
            "MKH": "Mokhotlong",
            "MSU": "Mazenod",
            "NKU": "Nkaus",
            "PEL": "Pelaneng",
            "UTG": "Quthing",
            "UNE": "Qacha's Nek",
            "SHK": "Sehonghong",
            "SKQ": "Sekakes",
            "SOK": "Semonkong",
            "SHZ": "Seshutes",
            "THB": "Thaba-Tseka",
            "TKO": "Tlokoeng",
            "AIW": "Ai-Ais",
            "ADI": "Arandis",
            "GOG": "Gobabis",
            "GFY": "Grootfontein",
            "HAL": "Halali",
            "KAS": "Karasburg",
            "MPA": "Mpacha",
            "KMP": "Keetmanshoop",
            "LHU": "Muneambuanas",
            "LUD": "Luderitz",
            "MJO": "Mount Etjo Safari Lodge",
            "MQG": "Midgard",
            "OKU": "Mokuti Lodge",
            "NNI": "Namutoni",
            "OGV": "Ombika",
            "OND": "Ondangwa",
            "OMG": "Omega",
            "OMD": "Oranjemund",
            "OKF": "Okaukuejo",
            "OPW": "Opuwa",
            "OHI": "Oshakati",
            "OTJ": "Otjiwarongo",
            "NDU": "Rundu",
            "RHN": "Rosh Pinah",
            "SWP": "Swakopmund",
            "SZM": "Sesriem",
            "TCY": "Terrace Bay",
            "TSB": "Tsumeb",
            "WVB": "Rooikop",
            "ERS": "Windhoek",
            "WDH": "Windhoek",
            "FIH": "Kinshasa",
            "NLO": "N'dolo",
            "MNB": "Muanda",
            "BOA": "Boma",
            "LZI": "Luozi",
            "MAT": "Matadi",
            "NKL": "N'Kolo-Fuma",
            "INO": "Inongo",
            "NIO": "Nioki",
            "FDU": "Bandundu",
            "KRZ": "Kiri",
            "KKW": "Kikwit",
            "IDF": "Idiofa",
            "MSM": "Masi Manimba",
            "MDK": "Mbandaka",
            "BSU": "Basankusu",
            "LIE": "Libenge",
            "BDT": "Gbadolite",
            "GMA": "Gemena",
            "KLI": "Kotakoli",
            "BMB": "Bumba",
            "LIQ": "Lisala",
            "BNB": "Boende",
            "IKL": "Ikela",
            "FKI": "Kisangani",
            "YAN": "Yangambi",
            "IRP": "Isiro",
            "BUX": "Bunia",
            "BZU": "Buta",
            "BKY": "Kamakombe",
            "RUE": "Butembo",
            "GOM": "Goma",
            "BNC": "Beni",
            "KND": "Kindu",
            "KLY": "Kalima",
            "PUN": "Punia",
            "FBM": "Lubumbashi",
            "PWO": "Pweto",
            "KEC": "Kasenga",
            "KWZ": "Kolwezi",
            "MNO": "Manono",
            "BDV": "Moba",
            "FMI": "Kalemie",
            "KBO": "Kabalo",
            "KOO": "Kongolo",
            "KMN": "Kamina",
            "KAP": "Kapanga",
            "KNM": "Kaniama",
            "KGA": "Kananga",
            "LZA": "Luiza",
            "TSH": "Tshikapa",
            "LJA": "Lodja",
            "LBO": "Lusambo",
            "MEW": "Mweka",
            "BAN": "Basongo",
            "PFR": "Ilebo",
            "MJM": "Mbuji Mayi",
            "KBN": "Kabinda",
            "NKA": "Ntoum",
            "GIM": "Miele Mimbale",
            "GAX": "Gamba",
            "BKO": "Bamako",
            "GUD": "Goundam",
            "KNZ": "Kenieba",
            "KTX": "Koutiala",
            "MZI": "Sévaré",
            "NRM": "Nara",
            "NIX": "Nioro du Sahel",
            "KSS": "Sikasso",
            "TOM": "Timbuktu",
            "EYL": "Yélimané",
            "PZE": "Penzance, Cornwall",
            "FLH": "Flotta Isle",
            "FOA": "Foula",
            "GBM": "Garbaharey",
            "BJL": "Yundum",
            "FUE": "El Matorral",
            "GMZ": "Alajero, La Gomera Island",
            "VDE": "El Hierro Island",
            "SPC": "Sta Cruz de la Palma, La Palma Island",
            "LPA": "Gran Canaria Island",
            "ACE": "San Bartolomé",
            "TFS": "Tenerife",
            "GCV": "Gravatai",
            "TFN": "Tenerife",
            "JCU": "Ceuta",
            "MLN": "Melilla",
            "OYC": "Camopi",
            "KBS": "Bo",
            "GBK": "Gbangbatok",
            "HGS": "Freetown",
            "KBA": "Kabala",
            "KEN": "Kenema",
            "FNA": "Freetown (Lungi-Town)",
            "WYE": "Yengema",
            "BQE": "Bubaque",
            "OXB": "Bissau",
            "GHE": "Garachiné",
            "QCU": "Akunnaaq",
            "UCN": "Buchanan",
            "CPA": "Harper",
            "SNI": "Greenville",
            "MLW": "Monrovia",
            "NIA": "Nimba",
            "ROB": "Monrovia",
            "SAZ": "Sasstown",
            "THC": "Zwedru",
            "VOI": "Voinjama",
            "AGA": "Agadir (Temsia)",
            "TTA": "Tan Tan",
            "OZG": "Zagora",
            "UAR": "Bouarfa",
            "FEZ": "Saïss",
            "ERH": "Errachidia",
            "MEK": "Meknes",
            "OUD": "Ahl Angad",
            "SMW": "Smara",
            "GMD": "Ben Slimane",
            "BEM": "Oulad Yaich",
            "RBA": "Rabat",
            "VIL": "Dakhla",
            "ESU": "Essaouira",
            "EUN": "El Aaiún",
            "CMN": "Casablanca",
            "NDR": "Al Aaroui",
            "RAK": "Marrakech",
            "NNA": "Kenitra",
            "OZZ": "Ouarzazate",
            "AHU": "Al Hoceima",
            "TTU": "Tétouan",
            "TNG": "Tangier",
            "GNU": "Goodnews",
            "DSS": "Dakar",
            "KDA": "Kolda",
            "ZIG": "Ziguinchor",
            "CSK": "Cap Skirring",
            "KLC": "Kaolack",
            "DKR": "Dakar",
            "MAX": "Ouro Sogui",
            "POD": "Podor",
            "RDT": "Richard Toll",
            "XLS": "Saint Louis",
            "BXE": "Bakel",
            "KGG": "Kédougou",
            "SMY": "Simenti",
            "TUD": "Tambacounda",
            "AEO": "Aioun El Atrouss",
            "OTL": "Boutilimit",
            "THI": "Tichitt",
            "TIY": "Tidjikja",
            "BGH": "Boghe",
            "KFA": "Kiffa",
            "TMD": "Timbedra",
            "EMN": "Néma",
            "AJJ": "Akjoujt",
            "KED": "Kaédi",
            "MOM": "Moudjeria",
            "NKC": "Nouakchott",
            "SEY": "Sélibaby",
            "THT": "Tamchakett",
            "ATR": "Atar",
            "FGD": "Fderik",
            "NDB": "Nouadhibou",
            "OUZ": "Zouérate",
            "GRC": "Grand Cess",
            "CIQ": "Chiquimula",
            "DON": "Dos Lagunas",
            "ENJ": "El Naranjo",
            "PCG": "Paso Caballos",
            "UAX": "Uaxactun",
            "CKY": "Conakry",
            "GUE": "Guriaso",
            "FIG": "Fria",
            "FAA": "Faranah",
            "KSI": "Kissidougou",
            "LEK": "Labé",
            "MCA": "Macenta",
            "NZE": "Nzérékoré",
            "BKJ": "Boké",
            "SBI": "Koundara",
            "GII": "Siguiri",
            "SID": "Espargos",
            "NTO": "Ponta do Sol",
            "BVC": "Rabil",
            "MMO": "Vila do Maio",
            "MTI": "Vila do Mosteiros",
            "RAI": "Praia",
            "SFL": "São Filipe",
            "SNE": "Preguiça",
            "VXE": "São Pedro",
            "KNN": "Kankan",
            "BCG": "Kumaka",
            "BTO": "Botopasi",
            "DOE": "Djumu-Djomoe",
            "ADD": "Addis Ababa",
            "AMH": "Arba Minch",
            "AXU": "Axum",
            "BCO": "Baco",
            "BJR": "Bahir Dar",
            "BEI": "Beica",
            "DSE": "Dessie",
            "DEM": "Dembidollo",
            "DBM": "Debre Markos",
            "DIR": "Dire Dawa",
            "DBT": "Debre Tabor",
            "FNH": "Fincha",
            "GOB": "Goba",
            "GNN": "Ghinnir",
            "GMB": "Gambela",
            "GDQ": "Azezo",
            "GDE": "Gode",
            "GOR": "Gore",
            "QHR": "Debre Zeyit",
            "HUE": "Akwi",
            "JIJ": "Jijiga",
            "JIM": "Jimma",
            "ABK": "Kebri Dahar",
            "LFO": "Kelafo",
            "AWA": "Hawassa",
            "LLI": "Girany Amba",
            "MKS": "Mekane Selam",
            "MQX": "Mekele",
            "ETE": "Metema",
            "NDM": "Mendi",
            "MUJ": "Omo National Park",
            "MTF": "Mizan Teferi",
            "EGL": "Negele Borana",
            "NEJ": "Nejo",
            "NEK": "Nekemte",
            "PWI": "Pawe",
            "SXU": "Soddu",
            "SKR": "Shakiso",
            "HIL": "Shilavo",
            "SZE": "Semera",
            "ASO": "Asosa",
            "TIE": "Tippi",
            "WRA": "Warder",
            "HAZ": "Hatzfeldhaven",
            "BJM": "Bujumbura",
            "GID": "Gitega",
            "KRE": "Kirundo",
            "HBT": "Hambantota",
            "ALU": "Alula",
            "BIB": "Baidoa",
            "CXN": "Candala",
            "BSY": "Baardheere",
            "HCM": "Eyl",
            "BSA": "Bosaso",
            "GSR": "Gardo",
            "HGA": "Hargeisa",
            "BBO": "Berbera",
            "LGX": "Luuq",
            "KMU": "Kismayo",
            "MGQ": "Mogadishu",
            "BLW": "Beledweyne",
            "CMO": "Hobyo",
            "GLK": "Galcaio",
            "CMS": "Iskushuban",
            "ERA": "Erigavo",
            "BUO": "Burao",
            "GGR": "Garowe",
            "JIB": "Djibouti City",
            "AII": "Ali-Sabieh",
            "MHI": "Moucha Island",
            "OBC": "Obock",
            "TDJ": "Tadjoura",
            "EMY": "El Minya",
            "RDL": "El Hassana",
            "SQK": "Sidi El Barrani",
            "DBB": "El Alamein",
            "AAC": "El Arish",
            "ATZ": "Asyut",
            "HBE": "Alexandria",
            "ABS": "Abu Simbel",
            "CAI": "Cairo",
            "CCE": "New Cairo",
            "DAK": "Dakhla Oases",
            "HRG": "Hurghada",
            "EGH": "El Jora",
            "UVL": "Kharja Oases",
            "LXR": "Luxor",
            "RMF": "Marsa Alam",
            "MUH": "Marsa Matruh",
            "HEO": "Haelogo",
            "GSQ": "Sharq El Owainat",
            "PSD": "Port Said",
            "SKV": "Saint Catherine",
            "HMB": "Suhaj",
            "SSH": "Sharm El Sheikh",
            "ASW": "Aswan",
            "SEW": "Siwa Oasis",
            "SPX": "Al Jiza",
            "TCP": "Taba",
            "ELT": "At Tur",
            "HEY": "Fort Rucker Ozark",
            "HGT": "Jolon",
            "ASM": "Asmara",
            "MSW": "Massawa",
            "ASA": "Assab",
            "TES": "Tessenei",
            "HPV": "Hanalei",
            "WKL": "Waikoloa Village",
            "JUB": "Juba",
            "ASV": "Amboseli National Park",
            "HKB": "Healy Lake",
            "EDL": "Eldoret",
            "EYS": "Eliye Springs",
            "KLK": "Kalokol",
            "GAS": "Garissa",
            "HOA": "Hola",
            "NBO": "Nairobi",
            "KEU": "Keekorok",
            "GGM": "Kakamega",
            "KIS": "Kisumu",
            "ILU": "Kilaguni",
            "KEY": "Kericho",
            "KTL": "Kitale",
            "LKG": "Lokichogio",
            "LOK": "Lodwar",
            "LAU": "Lamu",
            "LOY": "Loyengalani",
            "NDE": "Mandera",
            "RBT": "Marsabit",
            "JJM": "Meru-Kinna",
            "MYD": "Malindi",
            "MBA": "Mombasa",
            "MRE": "Masai Mara",
            "OYL": "Moyale (Lower)",
            "NYE": "Nyeri",
            "NUU": "Nakuru",
            "NYK": "Nanyuki",
            "WIL": "Nairobi",
            "UAS": "Samburu",
            "UKA": "Ukunda",
            "WJR": "Wajir",
            "SRX": "Sirt",
            "GHT": "Ghat",
            "AKF": "Kufra",
            "BEN": "Benina",
            "MJI": "Tripoli",
            "LAQ": "Al Albraq",
            "SEB": "Sabha",
            "LMQ": "Marsa al Brega",
            "MRA": "Misrata",
            "NFR": "Nafurah 1",
            "LTD": "Ghadames",
            "TOB": "Adam",
            "QUB": "Ubari",
            "ZIS": "Zintan",
            "WAX": "Zuwarah",
            "EDQ": "Erandique",
            "HOO": "Đăk R'Lấp",
            "HRC": "Zhayrem",
            "GYI": "Gisenyi",
            "BTQ": "Butare",
            "KGL": "Kigali",
            "RHG": "Ruhengeri",
            "KME": "Kamembe",
            "ATB": "Atbara",
            "EDB": "Al Dabbah",
            "DOG": "Dongola",
            "RSS": "Ad Damazin",
            "ELF": "El Fasher",
            "DNX": "Dinder",
            "EGN": "Geneina",
            "HEG": "Heglig Oilfield",
            "HSJ": "Zhengzhou",
            "KSL": "Kassala",
            "GBU": "Khashm El Girba",
            "KDX": "Kadugli",
            "RBX": "Rumbek",
            "MWE": "Merowe",
            "NUD": "En Nahud",
            "UYL": "Nyala",
            "NHF": "New Halfa",
            "EBD": "El-Obeid",
            "PZU": "Port Sudan",
            "KRT": "Khartoum",
            "MAK": "Malakal",
            "WHF": "Wadi Halfa",
            "WUU": "Wau",
            "ZLX": "Zalingei",
            "ARK": "Arusha",
            "BKZ": "Bukoba",
            "DAR": "Dar es Salaam",
            "DOD": "Dodoma",
            "GTC": "Chato District",
            "GTZ": "Grumeti Game Reserve",
            "MBI": "Mbeya",
            "IRI": "Nduli",
            "TKQ": "Kigoma",
            "KIY": "Kilwa Masoko",
            "JRO": "Arusha",
            "LDI": "Lindi",
            "LKY": "Lake Manyara National Park",
            "MFA": "Kilindoni",
            "MWN": "Mwadui",
            "XMI": "Masasi",
            "NPY": "Mpanda",
            "QSI": "Moshi",
            "MYW": "Mtwara",
            "MUZ": "Musoma",
            "MWZ": "Mwanza",
            "NCH": "Nachingwea",
            "JOM": "Njombe",
            "PMA": "Chake Chake",
            "SEU": "Seronera",
            "SGX": "Songea",
            "SUT": "Sumbawanga",
            "SHY": "Shinyanga",
            "TBO": "Tabora",
            "TGT": "Tanga",
            "ZNZ": "Zanzibar",
            "RUA": "Arua",
            "EBB": "Kampala",
            "ULU": "Gulu",
            "JIN": "Jinja",
            "KJJ": "Kampala",
            "KSE": "Kasese",
            "MBQ": "Mbarara",
            "KCU": "Masindi",
            "PAF": "Pakuba",
            "SRT": "Soroti",
            "TRY": "Tororo",
            "HWI": "Hawk Inlet",
            "HYL": "Hollis",
            "HZU": "Chengdu (Jintang)",
            "IBI": "Iboki",
            "IBL": "Bazaruto Island",
            "ICO": "Carles",
            "PPJ": "Jakarta",
            "GXM": "Kuala Kurun",
            "ENG": "Enggano",
            "GYO": "Kabupaten Gayo Lues",
            "DHX": "Kediri",
            "SKJ": "Singkawang",
            "RUF": "Amgotro",
            "BJG": "Kota Mobagu",
            "AAS": "Apalapsili",
            "AGD": "Anggi-Papua Island",
            "AKQ": "Menggala",
            "ELR": "Elelim",
            "EWE": "Agats",
            "GAV": "Gag Island",
            "IUL": "Ilu",
            "KOD": "Kotabangun-Borneo Island",
            "KRC": "Sungai Penuh",
            "LLN": "Kelila",
            "MSI": "Masalembo Island",
            "NAF": "Banaina-Borneo Island",
            "OBD": "Obano",
            "RKI": "Sipura Island",
            "TMY": "Tiom-Papua Island",
            "UGU": "Bilogai",
            "IMA": "Iamalele, Fergusson Island",
            "IMG": "Inhaminga",
            "PYG": "Pakyong",
            "AYJ": "Faizabad",
            "SDW": "Chipi",
            "NMI": "Navi Mumbai",
            "RQY": "Shimoga",
            "HGI": "Hollongi",
            "UKE": "Bhawanipatna",
            "AHA": "Ambikapur",
            "JGB": "Jagdalpur",
            "RJI": "Rajouri",
            "INE": "Chinde",
            "IOK": "Iokea",
            "IOP": "Ioma",
            "IRU": "Iranamadu",
            "ITK": "Itokama",
            "IVI": "Isla Viveros",
            "JIO": "Tiakur",
            "JLA": "Cooper Landing",
            "JMB": "Jamba",
            "JPN": "Washington DC",
            "JRA": "New York",
            "JRB": "New York",
            "JUH": "Chizhou",
            "AMK": "Durango",
            "BDX": "Broadus",
            "EUE": "Eureka",
            "KPT": "Jackpot",
            "RLA": "Rolla",
            "FID": "Fishers Island",
            "HUD": "Humboldt",
            "TWD": "Port Townsend",
            "MVM": "Kayenta",
            "HCC": "Hudson",
            "AHD": "Ardmore",
            "GCW": "Peach Springs",
            "CKE": "Lakeport",
            "ROF": "Montague",
            "CNE": "Penrose",
            "RSX": "Rouses Point",
            "COP": "Cooperstown",
            "CIL": "Council",
            "NWH": "Newport",
            "IRB": "Iraan",
            "ODM": "Accident",
            "GNF": "Quincy",
            "CHZ": "Chiloquin",
            "LTW": "California",
            "USC": "Union",
            "AHF": "Arapahoe",
            "PCT": "Princeton/Rocky Hill",
            "CTO": "Calverton",
            "NRI": "Afton",
            "GTP": "Grants Pass",
            "NLE": "Niles",
            "GCD": "Electric City",
            "VLE": "Grand Canyon",
            "FPY": "Perry",
            "NTJ": "Manti",
            "SBO": "Salina",
            "JVI": "Manville",
            "UCE": "Eunice",
            "GOL": "Gold Beach",
            "KKT": "Kentland",
            "PRW": "Prentice",
            "EGP": "Eagle Pass",
            "BLD": "Boulder City",
            "MFH": "Mesquite",
            "ECA": "East Tawas",
            "FMU": "Florence",
            "OTS": "Anacortes",
            "ROL": "Roosevelt",
            "CTK": "Canton",
            "WPO": "Paonia",
            "ATE": "Antlers",
            "ASQ": "Austin",
            "AAF": "Apalachicola",
            "ABE": "Allentown",
            "ABI": "Abilene",
            "ABQ": "Albuquerque",
            "ABR": "Aberdeen",
            "ABY": "Albany",
            "ACB": "Bellaire",
            "ACK": "Nantucket",
            "ACT": "Waco",
            "ACV": "Arcata/Eureka",
            "ACY": "Atlantic City",
            "ADG": "Adrian",
            "ADT": "Ada",
            "ADM": "Ardmore",
            "ADS": "Dallas",
            "ADW": "Camp Springs",
            "KAE": "Kake",
            "AEL": "Albert Lea",
            "AEX": "Alexandria",
            "KAF": "Karato",
            "AFF": "Colorado Springs",
            "WSG": "Washington",
            "AFN": "Jaffrey",
            "AFO": "Afton",
            "AFW": "Fort Worth",
            "AGC": "Pittsburgh",
            "AGO": "Magnolia",
            "AGS": "Augusta",
            "AHC": "Herlong",
            "AHH": "Amery",
            "AHN": "Athens",
            "AIA": "Alliance",
            "AID": "Anderson",
            "AIK": "Aiken",
            "AIO": "Atlantic",
            "AIV": "Aliceville",
            "AIZ": "Kaiser Lake Ozark",
            "KAK": "Kar",
            "AKO": "Akron",
            "AKC": "Akron",
            "ALB": "Albany",
            "ALI": "Alice",
            "ALM": "Alamogordo",
            "ALN": "Alton/St Louis",
            "ALO": "Waterloo",
            "ALS": "Alamosa",
            "ALW": "Walla Walla",
            "ALX": "Alexander City",
            "AMA": "Amarillo",
            "AMN": "Alma",
            "AMW": "Ames",
            "ANB": "Anniston",
            "AND": "Anderson",
            "SLT": "Salida",
            "ANP": "Annapolis",
            "ANQ": "Angola",
            "ANW": "Ainsworth",
            "ANY": "Anthony",
            "AOH": "Lima",
            "AOO": "Altoona",
            "APA": "Denver",
            "APC": "Napa",
            "APF": "Naples",
            "APG": "Aberdeen",
            "APH": "Bowling Green",
            "APN": "Alpena",
            "APT": "Jasper",
            "APV": "Apple Valley",
            "ARA": "New Iberia",
            "ARB": "Ann Arbor",
            "ARG": "Walnut Ridge",
            "WHT": "Wharton",
            "AUZ": "Chicago/Aurora",
            "ART": "Watertown",
            "ARV": "Woodruff",
            "BFT": "Beaufort",
            "ASE": "Aspen",
            "SPZ": "Springdale",
            "ASH": "Nashua",
            "ASL": "Marshall",
            "ASN": "Talladega",
            "AST": "Astoria",
            "ASX": "Ashland",
            "ASY": "Ashley",
            "ATL": "Atlanta",
            "ATS": "Artesia",
            "ATW": "Appleton",
            "ATY": "Watertown",
            "AUG": "Augusta",
            "AUM": "Austin",
            "AUN": "Auburn",
            "AUO": "Auburn",
            "AUS": "Austin",
            "AUW": "Wausau",
            "AVL": "Asheville",
            "AVO": "Avon Park",
            "AVP": "Wilkes-Barre/Scranton",
            "AVW": "Marana",
            "AVX": "Avalon",
            "AWM": "West Memphis",
            "AXG": "Algona",
            "AXN": "Alexandria",
            "AXS": "Altus",
            "AXV": "Wapakoneta",
            "AXX": "Angel Fire",
            "AYS": "Waycross",
            "TUH": "Manchester",
            "AZO": "Kalamazoo",
            "BAB": "Beale Air Force Base",
            "BAD": "Bossier City",
            "BAF": "Westfield",
            "CLU": "Columbus",
            "BAM": "Battle Mountain",
            "BBB": "Benson",
            "BBD": "Brady",
            "BKG": "Branson",
            "BTN": "Bennettsville",
            "BBW": "Broken Bow",
            "BCB": "Blacksburg",
            "BCE": "Bryce Canyon",
            "BCT": "Boca Raton",
            "BDE": "Baudette",
            "BDG": "Blanding",
            "ILL": "Willmar",
            "BDL": "Hartford",
            "BDR": "Bridgeport",
            "WBU": "Boulder",
            "KBE": "Bell Island",
            "BEC": "Wichita",
            "BED": "Bedford",
            "BEH": "Benton Harbor",
            "BFD": "Bradford",
            "BFF": "Scottsbluff",
            "BFI": "Seattle",
            "BFL": "Bakersfield",
            "BFM": "Mobile",
            "BFR": "Bedford",
            "BGD": "Borger",
            "BGE": "Bainbridge",
            "BGM": "Binghamton",
            "BGR": "Bangor",
            "KBH": "Kahama",
            "BHB": "Bar Harbor",
            "BHM": "Birmingham",
            "BID": "Block Island",
            "BIE": "Beatrice",
            "BIF": "Fort Bliss/El Paso",
            "BIH": "Bishop",
            "BIL": "Billings",
            "BIS": "Bismarck",
            "BIX": "Biloxi",
            "BJC": "Denver",
            "BJI": "Bemidji",
            "BJJ": "Wooster",
            "BKD": "Breckenridge",
            "BKE": "Baker City",
            "BFK": "Aurora",
            "BKL": "Cleveland",
            "BKT": "Blackstone",
            "BKW": "Beaver",
            "BKX": "Brookings",
            "BLF": "Bluefield",
            "BLH": "Blythe",
            "BLI": "Bellingham",
            "BLM": "Belmar/Farmingdale",
            "BLU": "Emigrant Gap",
            "BLV": "Belleville",
            "BMC": "Brigham City",
            "BMG": "Bloomington",
            "BMI": "Bloomington/Normal",
            "BML": "Berlin",
            "BMT": "Beaumont",
            "BNA": "Nashville",
            "BNG": "Banning",
            "BNL": "Barnwell",
            "BNO": "Burns",
            "BNW": "Boone",
            "BOI": "Boise",
            "BOK": "Brookings",
            "BOS": "Boston",
            "BOW": "Bartow",
            "HCA": "Big Spring",
            "BPI": "Big Piney",
            "WMH": "Mountain Home",
            "BPT": "Beaumont/Port Arthur",
            "BQK": "Brunswick",
            "BRD": "Brainerd",
            "BRL": "Burlington",
            "BRO": "Brownsville",
            "BRY": "Bardstown",
            "KBT": "Kaben",
            "BTF": "Bountiful",
            "BTL": "Battle Creek",
            "BTM": "Butte",
            "TTO": "Britton",
            "BTP": "Butler",
            "BTR": "Baton Rouge",
            "BTV": "South Burlington",
            "BTY": "Beatty",
            "BUB": "Burwell",
            "BUF": "Buffalo",
            "BUM": "Butler",
            "BUR": "Burbank",
            "BFP": "Beaver Falls",
            "BVO": "Bartlesville",
            "MVW": "Burlington",
            "BVX": "Batesville",
            "BVY": "Beverly / Danvers",
            "BWC": "Brawley",
            "BWD": "Brownwood",
            "BWG": "Bowling Green",
            "BWI": "Baltimore",
            "WAH": "Wahpeton",
            "BWM": "Bowman",
            "BXA": "Bogalusa",
            "BXK": "Buckeye",
            "NHZ": "Brunswick",
            "BYG": "Buffalo",
            "BYH": "Blytheville",
            "BYI": "Burley",
            "BYS": "Fort Irwin/Barstow",
            "BBC": "Bay City",
            "BZN": "Bozeman",
            "XES": "Lake Geneva",
            "PLY": "Plymouth",
            "CLG": "Coalinga",
            "CAD": "Cadillac",
            "CAE": "Columbia",
            "CIG": "Craig",
            "CAK": "Akron",
            "CAO": "Clayton",
            "CAR": "Caribou",
            "CBE": "Wiley Ford",
            "CBF": "Council Bluffs",
            "CBK": "Colby",
            "CBM": "Columbus",
            "KCC": "Coffman Cove",
            "CCB": "Upland",
            "CCR": "Concord",
            "CCY": "Charles City",
            "LLX": "Lyndonville",
            "CDC": "Cedar City",
            "CDH": "Camden",
            "CDK": "Cedar Key",
            "CDN": "Camden",
            "CDR": "Chadron",
            "CDS": "Childress",
            "CDW": "Caldwell",
            "CEA": "Wichita",
            "CEC": "Crescent City",
            "CEF": "Chicopee",
            "CEU": "Clemson",
            "CEV": "Connersville",
            "CEW": "Crestview",
            "CEY": "Murray",
            "CEZ": "Cortez",
            "CFD": "Bryan",
            "TZC": "Caro",
            "CFT": "Clifton",
            "CFV": "Coffeyville",
            "CGE": "Cambridge",
            "CGF": "Cleveland",
            "CGI": "Cape Girardeau",
            "CGS": "College Park",
            "CGZ": "Casa Grande",
            "CHA": "Chattanooga",
            "CHK": "Chickasha",
            "CHO": "Charlottesville",
            "CHS": "Charleston",
            "CIC": "Chico",
            "CID": "Cedar Rapids",
            "CIN": "Carroll",
            "CIR": "Cairo",
            "CIU": "Kincheloe",
            "CKA": "Cherokee",
            "CKB": "Bridgeport",
            "GRM": "Grand Marais",
            "CKM": "Clarksdale",
            "CKN": "Crookston",
            "CKV": "Clarksville",
            "KCL": "Chignik Flats",
            "CLE": "Cleveland",
            "CLI": "Clintonville",
            "CLK": "Clinton",
            "CLL": "College Station",
            "CLM": "Port Angeles",
            "CLR": "Calipatria",
            "CLS": "Chehalis",
            "CLT": "Charlotte",
            "CLW": "Clearwater",
            "CMH": "Columbus",
            "CMI": "Savoy",
            "CMX": "Hancock",
            "CMY": "Sparta",
            "KCN": "Chernofski Harbor",
            "CNH": "Claremont",
            "CNK": "Concordia",
            "CNM": "Carlsbad",
            "CNO": "Chino",
            "CNU": "Chanute",
            "CNW": "Waco",
            "CNY": "Moab",
            "COD": "Cody",
            "COE": "Coeur d'Alene",
            "COF": "Cocoa Beach",
            "COI": "Merritt Island",
            "COM": "Coleman",
            "CON": "Concord",
            "COS": "Colorado Springs",
            "COT": "Cotulla",
            "COU": "Columbia",
            "CPM": "Compton",
            "CPR": "Casper",
            "CPS": "Cahokia/St Louis",
            "HCW": "Cheraw",
            "KCR": "Colorado Creek",
            "CRE": "North Myrtle Beach",
            "CRG": "Jacksonville",
            "CRP": "Corpus Christi",
            "CLD": "Carlsbad",
            "CRS": "Corsicana",
            "CRT": "Crossett",
            "CRW": "Charleston",
            "CRX": "Corinth",
            "CSG": "Columbus",
            "CSM": "Clinton",
            "CSQ": "Creston",
            "CSV": "Crossville",
            "CTB": "Cut Bank",
            "CTY": "Cross City",
            "CTZ": "Clinton",
            "CUB": "Columbia",
            "CUH": "Cushing",
            "CVG": "Cincinnati / Covington",
            "HLI": "Hollister",
            "CKK": "Ash Flat",
            "CVN": "Clovis",
            "CVO": "Corvallis",
            "CVS": "Clovis",
            "CWA": "Mosinee",
            "KIP": "Wichita Falls",
            "CWF": "Lake Charles",
            "CWI": "Clinton",
            "CXL": "Calexico",
            "CXO": "Houston",
            "CSN": "Carson City",
            "HAR": "Harrisburg",
            "CYS": "Cheyenne",
            "CZK": "Cascade Locks",
            "CZT": "Carrizo Springs",
            "VEX": "Tioga",
            "DAA": "Fort Belvoir",
            "DAB": "Daytona Beach",
            "DAG": "Daggett",
            "DAL": "Dallas",
            "DAN": "Danville",
            "DAY": "Dayton",
            "DBN": "Dublin",
            "DBQ": "Dubuque",
            "DCA": "Washington",
            "DCU": "Decatur",
            "DDC": "Dodge City",
            "DEC": "Decatur",
            "DEH": "Decorah",
            "DEN": "Denver",
            "DET": "Detroit",
            "DFI": "Defiance",
            "DFW": "Dallas-Fort Worth",
            "DGL": "Douglas",
            "DGW": "Douglas",
            "DHN": "Dothan",
            "DHT": "Dalhart",
            "DIK": "Dickinson",
            "DKK": "Dunkirk",
            "DLL": "Dillon",
            "DLF": "Del Rio",
            "DLH": "Duluth",
            "DLN": "Dillon",
            "DLS": "Dallesport / The Dalles",
            "DMA": "Tucson",
            "DMN": "Deming",
            "DMO": "Sedalia",
            "DNL": "Augusta",
            "DNN": "Dalton",
            "DNS": "Denison",
            "DNV": "Danville",
            "DOV": "Dover",
            "DPA": "Chicago/West Chicago",
            "DPG": "Dugway Proving Ground",
            "DRA": "Mercury",
            "DRI": "DeRidder",
            "DRE": "Drummond Island",
            "DRO": "Durango",
            "DRT": "Del Rio",
            "KDS": "Kamaran Downs",
            "DSM": "Des Moines",
            "DSV": "Dansville",
            "DTA": "Delta",
            "DTL": "Detroit Lakes",
            "DTN": "Shreveport",
            "DSI": "Destin",
            "DTW": "Detroit",
            "DUA": "Durant",
            "DUC": "Duncan",
            "DUG": "Douglas Bisbee",
            "DUJ": "Dubois",
            "DVL": "Devils Lake",
            "DVN": "Davenport",
            "NOT": "Novato",
            "NSL": "Slayton",
            "DVT": "Phoenix",
            "KDW": "Kandy",
            "DWH": "Houston",
            "DXR": "Danbury",
            "DYL": "Doylestown",
            "DYS": "Abilene",
            "KDZ": "Kandy",
            "LBN": "Lake Baringo",
            "VPG": "Vipingo Estate",
            "KTJ": "Kichwa Tembo",
            "HKR": "Mara",
            "ANA": "Maasai Mara",
            "MDR": "Musiara",
            "OLX": "Olkiombo",
            "KRV": "Kimwarer",
            "KIU": "Kiunga",
            "LBK": "Liboi",
            "LKU": "Kalokol",
            "MIF": "Monahans",
            "CCG": "Crane",
            "ESO": "Espanola",
            "WTR": "Whiteriver",
            "ALE": "Alpine",
            "BGT": "Bagdad",
            "EAN": "Wheatland",
            "EAR": "Kearney",
            "EAT": "Wenatchee",
            "EAU": "Eau Claire",
            "KEB": "Nanwalek",
            "EBS": "Webster City",
            "ECG": "Elizabeth City",
            "ECP": "Panama City Beach",
            "ECS": "Newcastle",
            "EDE": "Edenton",
            "ETS": "Enterprise",
            "EDW": "Edwards",
            "EED": "Needles",
            "EEN": "Keene",
            "EFD": "Houston",
            "EFK": "Newport",
            "EFW": "Jefferson",
            "EGE": "Eagle",
            "EGI": "Crestview",
            "EGV": "Eagle River",
            "KEK": "Ekwok",
            "EKA": "Eureka",
            "EKI": "Elkhart",
            "EKN": "Elkins",
            "EKO": "Elko",
            "EKX": "Elizabethtown",
            "ELA": "Eagle Lake",
            "ELD": "El Dorado",
            "ELK": "Elk City",
            "ELM": "Elmira/Corning",
            "ELN": "Ellensburg",
            "LYU": "Ely",
            "ELP": "El Paso",
            "ELY": "Ely",
            "ELZ": "Wellsville",
            "EMM": "Kemmerer",
            "EMP": "Emporia",
            "EMT": "El Monte",
            "END": "Enid",
            "ENL": "Centralia",
            "ENV": "Wendover",
            "ENW": "Kenosha",
            "EOK": "Keokuk",
            "EOS": "Neosho",
            "EPH": "Ephrata",
            "EDK": "El Dorado",
            "ERI": "Erie",
            "ERR": "Errol",
            "ERV": "Kerrville",
            "ESC": "Escanaba",
            "ESF": "Alexandria",
            "ESN": "Easton",
            "EST": "Estherville",
            "ESW": "Easton",
            "ETB": "West Bend",
            "ETN": "Eastland",
            "EUF": "Eufaula",
            "EUG": "Eugene",
            "EVM": "Eveleth",
            "EVV": "Evansville",
            "EVW": "Evanston",
            "EWB": "New Bedford",
            "EWK": "Newton",
            "EWN": "New Bern",
            "EWR": "Newark",
            "EYW": "Key West",
            "KEZ": "Colombo",
            "WIB": "Vernon",
            "RBK": "Murrieta",
            "FAF": "Newport News (Fort Eustis)",
            "FAM": "Farmington",
            "FAR": "Fargo",
            "FAT": "Fresno",
            "FAY": "Fayetteville",
            "FBG": "Fort Bragg",
            "FBL": "Faribault",
            "FBR": "Fort Bridger",
            "FBY": "Fairbury",
            "FCH": "Fresno",
            "FCM": "Minneapolis",
            "FCS": "Fort Carson",
            "FCY": "Forrest City",
            "FDK": "Frederick",
            "FDR": "Frederick",
            "FDY": "Findlay",
            "FEP": "Freeport",
            "FET": "Fremont",
            "FFA": "Kill Devil Hills",
            "FFL": "Fairfield",
            "FFM": "Fergus Falls",
            "FFO": "Dayton",
            "FFT": "Frankfort",
            "MSC": "Mesa",
            "FRD": "Friday Harbor",
            "FHU": "Fort Huachuca / Sierra Vista",
            "FKL": "Franklin",
            "FKN": "Franklin",
            "FLD": "Fond du Lac",
            "FLG": "Flagstaff",
            "FLL": "Fort Lauderdale",
            "FLO": "Florence",
            "FLP": "Flippin",
            "FLV": "Fort Leavenworth",
            "FLX": "Fallon",
            "FME": "Fort Meade(Odenton)",
            "FMH": "Falmouth",
            "FMN": "Farmington",
            "FMY": "Fort Myers",
            "FNL": "Loveland",
            "FNT": "Flint",
            "FOD": "Fort Dodge",
            "FOE": "Topeka",
            "FOK": "Westhampton Beach",
            "FIL": "Fillmore",
            "FPR": "Fort Pierce",
            "FRG": "Farmingdale",
            "FRH": "French Lick",
            "FRI": "Fort Riley (Junction City)",
            "FRM": "Fairmont",
            "FRR": "Front Royal",
            "FSD": "Sioux Falls",
            "FSI": "Fort Sill",
            "FSK": "Fort Scott",
            "FSM": "Fort Smith",
            "FST": "Fort Stockton",
            "FSU": "Fort Sumner",
            "FMS": "Fort Madison",
            "FTK": "Fort Knox",
            "FTW": "Fort Worth",
            "FTY": "Atlanta",
            "FUL": "Fullerton",
            "WFK": "Frenchville",
            "FWA": "Fort Wayne",
            "FXE": "Fort Lauderdale",
            "FXY": "Forest City",
            "FYM": "Fayetteville",
            "FYV": "Fayetteville",
            "GAB": "Gabbs",
            "GAD": "Gadsden",
            "GAG": "Gage",
            "GAI": "Gaithersburg",
            "GBD": "Great Bend",
            "GBG": "Galesburg",
            "GBR": "Great Barrington",
            "GCC": "Gillette",
            "JDA": "John Day",
            "GCK": "Garden City",
            "GCN": "Grand Canyon - Tusayan",
            "GCY": "Greeneville",
            "GDM": "Gardner",
            "GDV": "Glendive",
            "GDW": "Gladwin",
            "GED": "Georgetown",
            "GEG": "Spokane",
            "GEY": "Greybull",
            "GFA": "Great Falls",
            "GFD": "Greenfield",
            "GFK": "Grand Forks",
            "GFL": "Glens Falls",
            "GGE": "Georgetown",
            "GGG": "Longview",
            "GGW": "Glasgow",
            "GHM": "Centerville",
            "IDH": "Grangeville",
            "GIF": "Winter Haven",
            "GJT": "Grand Junction",
            "MEJ": "Meadville",
            "GKT": "Sevierville",
            "GLD": "Goodland",
            "GLE": "Gainesville",
            "GLH": "Greenville",
            "GLR": "Gaylord",
            "GLS": "Galveston",
            "GLW": "Glasgow",
            "GMU": "Greenville",
            "GNG": "Gooding",
            "GNT": "Grants",
            "GNV": "Gainesville",
            "GOK": "Guthrie",
            "GON": "Groton",
            "FCA": "Kalispell",
            "GPT": "Gulfport",
            "GPZ": "Grand Rapids",
            "GQQ": "Galion",
            "GRB": "Green Bay",
            "GRD": "Greenwood",
            "GRE": "Greenville",
            "GRF": "Fort Lewis/Tacoma",
            "GRI": "Grand Island",
            "GRK": "Fort Cavazos",
            "GRN": "Gordon",
            "GRR": "Grand Rapids",
            "GSB": "Goldsboro",
            "GSH": "Goshen",
            "GSO": "Greensboro",
            "GSP": "Greer",
            "GTF": "Great Falls",
            "GTG": "Grantsburg",
            "GTR": "Columbus/W Point/Starkville",
            "GUC": "Gunnison",
            "GUP": "Gallup",
            "GUS": "Peru",
            "GUY": "Guymon",
            "GVE": "Gordonsville",
            "GVL": "Gainesville",
            "GVT": "Greenville",
            "GWO": "Greenwood",
            "GWS": "Glenwood Springs",
            "KGX": "Grayling",
            "GXY": "Greeley",
            "GDC": "Greenville",
            "PNX": "Denison",
            "GYR": "Goodyear",
            "GYY": "Gary",
            "KGZ": "Glacier Creek",
            "DSY": "Ta Noun",
            "KTI": "Phnom Penh (Boeng Khyang)",
            "HAB": "Hamilton",
            "HAF": "Half Moon Bay",
            "HAI": "Three Rivers",
            "HAO": "Hamilton",
            "HBG": "Hattiesburg",
            "HBR": "Hobart",
            "HDE": "Holdrege",
            "HDN": "Hayden",
            "HEE": "West Helena",
            "MNZ": "Manassas",
            "HEZ": "Natchez",
            "HFD": "Hartford",
            "HFF": "Hoffman",
            "HGR": "Hagerstown",
            "HHR": "Hawthorne",
            "HUJ": "Hugo",
            "HIB": "Hibbing",
            "HIE": "Whitefield",
            "HIF": "Ogden",
            "HII": "Lake Havasu City",
            "HIO": "Portland",
            "HKA": "Blytheville",
            "HKS": "Jackson",
            "HKY": "Hickory",
            "HLB": "Batesville",
            "HLC": "Hill City",
            "HLG": "Wheeling",
            "HLN": "Helena",
            "HLR": "Fort Cavazos (Killeen)",
            "HMN": "Alamogordo",
            "HMT": "Hemet",
            "HNB": "Huntingburg",
            "HSH": "Las Vegas",
            "HOB": "Hobbs",
            "HON": "Huron",
            "HOP": "Fort Campbell",
            "HOT": "Hot Springs",
            "HOU": "Houston",
            "HPN": "White Plains",
            "HPT": "Hampton",
            "HPY": "Baytown",
            "HQM": "Hoquiam",
            "HES": "Hermiston",
            "HRL": "Harlingen",
            "HRO": "Harrison",
            "HSB": "Harrisburg",
            "HNC": "Hatteras",
            "THP": "Thermopolis",
            "HSI": "Hastings",
            "HSP": "Hot Springs",
            "HST": "Homestead",
            "HSV": "Huntsville",
            "HTH": "Hawthorne",
            "HTL": "Houghton Lake",
            "HTO": "East Hampton",
            "HTS": "Huntington",
            "HTW": "South Point",
            "HUA": "Redstone Arsnl Huntsville",
            "HUF": "Terre Haute",
            "HUL": "Houlton",
            "HUM": "Houma",
            "HUT": "Hutchinson",
            "HVE": "Hanksville",
            "HVN": "New Haven",
            "HVR": "Havre",
            "HVS": "Hartsville",
            "HWD": "Hayward",
            "HWO": "Hollywood",
            "WSH": "Shirley",
            "HHH": "Hilton Head Island",
            "HYA": "Hyannis",
            "HYR": "Hayward",
            "HYS": "Hays",
            "HZL": "Hazleton",
            "JFN": "Ashtabula",
            "IAB": "Wichita",
            "IAD": "Dulles",
            "IAG": "Niagara Falls",
            "IAH": "Houston",
            "KIB": "Ivanof Bay",
            "ICL": "Clarinda",
            "ICT": "Wichita",
            "IDA": "Idaho Falls",
            "IDG": "Ida Grove",
            "IDI": "Indiana",
            "IDP": "Independence",
            "XPR": "Pine Ridge",
            "IFA": "Iowa Falls",
            "IFP": "Bullhead City",
            "IGM": "Kingman",
            "IJX": "Jacksonville",
            "IKK": "Kankakee",
            "KIL": "Kilwa",
            "ILE": "Killeen",
            "ILG": "Wilmington",
            "ILM": "Wilmington",
            "ILN": "Wilmington",
            "IML": "Imperial",
            "IMM": "Immokalee",
            "MDN": "Madison",
            "IMT": "Kingsford",
            "IND": "Indianapolis",
            "INK": "Wink",
            "INL": "International Falls",
            "INS": "Indian Springs",
            "INT": "Winston Salem",
            "INW": "Winslow",
            "IOW": "Iowa City",
            "IPL": "Imperial",
            "IPT": "Williamsport",
            "IRK": "Kirksville",
            "IRS": "Sturgis",
            "ISM": "Orlando",
            "ISO": "Kinston",
            "ISP": "Islip",
            "ISQ": "Manistique",
            "ISW": "Wisconsin Rapids",
            "ITH": "Ithaca",
            "AZA": "Mesa",
            "IWD": "Ironwood",
            "ISS": "Wiscasset",
            "IWS": "Houston",
            "JCI": "New Century",
            "IYK": "Inyokern",
            "SQA": "Santa Ynez",
            "FRY": "Fryeburg",
            "JAC": "Jackson",
            "JAN": "Jackson",
            "JAS": "Jasper",
            "JAX": "Jacksonville",
            "JBR": "Jonesboro",
            "JCT": "Junction",
            "JDN": "Jordan",
            "JEF": "Jefferson City",
            "JFK": "New York",
            "JHW": "Jamestown",
            "GUF": "Gulf Shores",
            "JLN": "Joplin",
            "JMS": "Jamestown",
            "JOT": "Joliet",
            "USA": "Concord",
            "JKV": "Jacksonville",
            "JST": "Johnstown",
            "JVL": "Janesville",
            "KJX": "Blangpidie",
            "JXN": "Jackson",
            "OSB": "Osage Beach",
            "KKB": "Kitoi Bay",
            "KIC": "King City",
            "KKL": "Karluk Lake",
            "KLS": "Kelso",
            "KNB": "Kanab",
            "KKU": "Ekuk",
            "DTH": "Death Valley",
            "BXS": "Borrego Springs",
            "RBF": "Big Bear",
            "MYH": "Marble Canyon",
            "TRH": "Trona",
            "LAA": "Lamar",
            "LAF": "West Lafayette",
            "LAL": "Lakeland",
            "LAM": "Los Alamos",
            "LAN": "Lansing",
            "LAR": "Laramie",
            "LAS": "Las Vegas",
            "LAW": "Lawton",
            "LAX": "Los Angeles",
            "LBB": "Lubbock",
            "LBE": "Latrobe",
            "LBF": "North Platte",
            "LBL": "Liberal",
            "LBT": "Lumberton",
            "LJN": "Angleton",
            "LCH": "Lake Charles",
            "LCI": "Laconia / Gilford",
            "LCK": "Columbus",
            "LCQ": "Lake City",
            "LDJ": "Linden",
            "LDM": "Ludington",
            "LEB": "Lebanon",
            "LEE": "Leesburg",
            "LEM": "Lemmon",
            "LEW": "Auburn/Lewiston",
            "LEX": "Lexington",
            "LFI": "Hampton",
            "LFK": "Lufkin",
            "LFT": "Lafayette",
            "LGA": "New York",
            "LGB": "Long Beach",
            "LGC": "LaGrange",
            "LGD": "La Grande",
            "LGF": "Yuma Proving Ground(Yuma)",
            "LGU": "Logan",
            "LHV": "Lock Haven",
            "LIY": "Hinesville",
            "LFN": "Louisburg",
            "LIC": "Limon",
            "LIT": "Little Rock",
            "LKP": "Lake Placid",
            "LOW": "Louisa",
            "LKV": "Lakeview",
            "CHL": "Challis",
            "LMS": "Louisville",
            "LMT": "Klamath Falls",
            "LNA": "West Palm Beach",
            "LND": "Lander",
            "LNK": "Lincoln",
            "LNN": "Willoughby",
            "LNP": "Wise",
            "LNR": "Spring Green",
            "LNS": "Lancaster",
            "LOL": "Lovelock",
            "BBX": "Philadelphia",
            "LOT": "Chicago/Romeoville",
            "LOU": "Louisville",
            "LOZ": "London",
            "LPC": "Lompoc",
            "LQK": "Pickens",
            "LRD": "Laredo",
            "LRF": "Jacksonville",
            "LRJ": "Le Mars",
            "LRU": "Las Cruces",
            "LSB": "Lordsburg",
            "LSE": "La Crosse",
            "LSF": "Fort Benning",
            "LSK": "Lusk",
            "LSN": "Los Banos",
            "LSV": "Las Vegas",
            "LTS": "Altus",
            "LUF": "Glendale",
            "LUK": "Cincinnati",
            "LUL": "Laurel",
            "LVK": "Livermore",
            "LVL": "Lawrenceville",
            "LVM": "Livingston",
            "LVS": "Las Vegas",
            "LWB": "Lewisburg",
            "LWC": "Lawrence",
            "LWL": "Wells",
            "LWM": "Lawrence",
            "LWS": "Lewiston",
            "LWT": "Lewistown",
            "LWV": "Lawrenceville",
            "LXN": "Lexington",
            "LXV": "Leadville",
            "LYH": "Lynchburg",
            "LYO": "Lyons",
            "LZU": "Lawrenceville",
            "PCU": "Poplarville",
            "MLK": "Malta",
            "MAC": "Macon",
            "MAE": "Madera",
            "MAF": "Midland",
            "MAW": "Malden",
            "KMB": "Konambe",
            "MBG": "Mobridge",
            "MBL": "Manistee",
            "DXE": "Madison",
            "MBS": "Freeland",
            "MBY": "Moberly",
            "MCB": "McComb",
            "MCC": "Sacramento",
            "MCD": "Mackinac Island",
            "MCE": "Merced",
            "MCF": "Tampa",
            "MCI": "Kansas City",
            "MCK": "McCook",
            "MCN": "Macon",
            "MCO": "Orlando",
            "MCW": "Mason City",
            "MDA": "San Antonio",
            "MDD": "Midland",
            "MDH": "Murphysboro",
            "XMD": "Madison",
            "MDT": "Harrisburg",
            "MDW": "Chicago",
            "MDF": "Medford",
            "MXE": "Maxton",
            "MEI": "Meridian",
            "MEM": "Memphis",
            "MER": "Merced",
            "MEV": "Minden",
            "UMZ": "Mena",
            "MFD": "Mansfield",
            "MFE": "McAllen",
            "MFI": "Marshfield",
            "MFR": "Medford",
            "MFV": "Melfa",
            "MGC": "Michigan City",
            "MGE": "Marietta",
            "MGJ": "Montgomery",
            "MGM": "Montgomery",
            "MGR": "Moultrie",
            "MGW": "Morgantown",
            "MGY": "Dayton",
            "MHE": "Mitchell",
            "MHK": "Manhattan",
            "MHL": "Marshall",
            "MHR": "Sacramento",
            "MHT": "Manchester",
            "MHV": "Mojave",
            "MIA": "Miami",
            "MIB": "Minot",
            "MIC": "Minneapolis",
            "MIE": "Muncie",
            "MIO": "Miami",
            "MIT": "Shafter",
            "MIV": "Millville",
            "MIW": "Marshalltown",
            "MJQ": "Jackson",
            "MJX": "Toms River",
            "MKC": "Kansas City",
            "MKE": "Milwaukee",
            "MKG": "Muskegon",
            "MKL": "Jackson",
            "MKO": "Muskogee",
            "MKT": "Mankato",
            "MRK": "Marco Island",
            "MLB": "Melbourne",
            "MLC": "Mc Alester",
            "MLD": "Malad City",
            "MIQ": "Omaha",
            "MLF": "Milford",
            "MLI": "Moline",
            "MLJ": "Milledgeville",
            "MLS": "Miles City",
            "MLT": "Millinocket",
            "MLU": "Monroe",
            "KMM": "Kimaam",
            "MMH": "Mammoth Lakes",
            "MMI": "Athens",
            "MML": "Marshall",
            "MMS": "Marks",
            "MMT": "Eastover",
            "MMU": "Morristown",
            "MNM": "Menominee",
            "MNN": "Marion",
            "MOB": "Mobile",
            "MOD": "Modesto",
            "MOP": "Mount Pleasant",
            "MOR": "Morristown",
            "MOT": "Minot",
            "MOX": "Morris",
            "RMY": "Mariposa",
            "MPJ": "Morrilton",
            "MPO": "Mount Pocono",
            "MPR": "Mc Pherson",
            "MPV": "Barre/Montpelier",
            "MPZ": "Mount Pleasant",
            "MQB": "Macomb",
            "MEO": "Manteo",
            "CTH": "Coatesville",
            "MQW": "Mc Rae",
            "MQY": "Smyrna",
            "MRB": "Martinsburg",
            "MRC": "Columbia/Mount Pleasant",
            "MRF": "Marfa",
            "MRN": "Morganton",
            "MRY": "Monterey",
            "MSL": "Muscle Shoals",
            "MSN": "Madison",
            "MSO": "Missoula",
            "MSP": "Minneapolis",
            "MSS": "Massena",
            "MSV": "Monticello",
            "MSY": "New Orleans",
            "MTC": "Mount Clemens",
            "MTH": "Marathon",
            "MTJ": "Montrose",
            "MTN": "Baltimore",
            "MTO": "Mattoon",
            "MTP": "Montauk",
            "MTW": "Manitowoc",
            "MUI": "Fort Indiantown Gap(Annville)",
            "MUL": "Moultrie",
            "MUO": "Mountain Home",
            "MUT": "Muscatine",
            "MVC": "Monroeville",
            "MVE": "Montevideo",
            "MVL": "Morrisville",
            "MVN": "Mount Vernon",
            "MVY": "Martha's Vineyard",
            "MWA": "Marion",
            "MWC": "Milwaukee",
            "MWH": "Moses Lake",
            "MWL": "Mineral Wells",
            "MWM": "Windom",
            "MWO": "Middletown",
            "MXA": "Manila",
            "MXF": "Montgomery",
            "MXO": "Monticello",
            "KMY": "Moser Bay",
            "MYF": "San Diego",
            "MYL": "McCall",
            "MYR": "Myrtle Beach",
            "MYV": "Marysville",
            "MZJ": "Marana",
            "MZZ": "Marion",
            "CTX": "Cortland",
            "SXY": "Sidney",
            "ONH": "Oneonta",
            "NBG": "New Orleans",
            "NHX": "Foley",
            "DGN": "Dahlgren",
            "NEL": "Lakehurst",
            "NEN": "Jacksonville",
            "NEW": "New Orleans",
            "NFL": "Fallon",
            "FWH": "Fort Worth",
            "NGP": "Corpus Christi",
            "NGU": "Norfolk",
            "NGW": "Corpus Christi",
            "NHK": "Patuxent River",
            "NIP": "Jacksonville",
            "NJK": "El Centro",
            "NKX": "San Diego",
            "NLC": "Lemoore",
            "NPA": "Pensacola",
            "NQA": "Millington",
            "NQI": "Kingsville",
            "NQX": "Key West",
            "NRB": "Jacksonville",
            "NRS": "Imperial Beach",
            "NSE": "Milton",
            "NTD": "Point Mugu",
            "NTU": "Virginia Beach",
            "NUQ": "Mountain View",
            "NUW": "Oak Harbor",
            "NVD": "Nevada",
            "NYG": "Quantico",
            "YUM": "Yuma",
            "NZY": "San Diego",
            "NVN": "Beckwourth",
            "COA": "Columbia",
            "ODC": "Oakdale",
            "EYR": "Yerington",
            "OAJ": "Richlands",
            "OAK": "Oakland",
            "OAR": "Marina",
            "OBE": "Okeechobee",
            "OCF": "Ocala",
            "OCH": "Nacogdoches",
            "OCW": "Washington",
            "ODT": "Odessa",
            "OEA": "Lawrenceville",
            "OEO": "Osceola",
            "OFF": "Omaha",
            "OFK": "Norfolk",
            "OGA": "Ogallala",
            "OGB": "Orangeburg",
            "OGD": "Ogden",
            "OGS": "Ogdensburg",
            "OIC": "Norwich",
            "OJC": "Olathe",
            "OCN": "Oceanside",
            "OKC": "Oklahoma City",
            "ODW": "Oak Harbor",
            "OKK": "Kokomo",
            "OKM": "Okmulgee",
            "OKS": "Oshkosh",
            "WGO": "Winchester",
            "OLD": "Old Town",
            "OLE": "Olean",
            "OLF": "Wolf Point",
            "OLM": "Olympia",
            "OLS": "Nogales",
            "OLU": "Columbus",
            "OLV": "Olive Branch",
            "OLY": "Olney-Noble",
            "OMA": "Omaha",
            "OMK": "Omak",
            "ONA": "Winona",
            "ONL": "O'Neill",
            "ONM": "Socorro",
            "ONO": "Oregon",
            "ONP": "Newport",
            "ONT": "Ontario",
            "ONY": "Olney",
            "OOA": "Cedar",
            "OPF": "Miami",
            "OPL": "Opelousas",
            "NCO": "North Kingstown",
            "ORD": "Chicago",
            "ORF": "Norfolk",
            "ORH": "Worcester",
            "ORL": "Orlando",
            "ESD": "Eastsound",
            "MPS": "Mount Pleasant",
            "OSC": "Oscoda",
            "OSH": "Oshkosh",
            "OSU": "Columbus",
            "OSX": "Kosciusko",
            "OTG": "Worthington",
            "OTH": "North Bend",
            "OTM": "Ottumwa",
            "OUN": "Norman",
            "OVE": "Oroville",
            "OWA": "Owatonna",
            "OWB": "Owensboro",
            "OWD": "Norwood",
            "OWK": "Norridgewock",
            "OCE": "Ocean City",
            "OXC": "Oxford",
            "OXD": "Oxford",
            "OXR": "Oxnard",
            "KOY": "Olga Bay",
            "STQ": "St Marys",
            "OZA": "Ozona",
            "OZR": "Fort Rucker/Ozark",
            "BSQ": "Bisbee",
            "PXL": "Polacca",
            "GLB": "Globe",
            "HBK": "Holbrook",
            "CWX": "Willcox",
            "CTW": "Cottonwood",
            "PAE": "Everett",
            "PAH": "Paducah",
            "PAM": "Panama City",
            "PJB": "Payson",
            "PAO": "Palo Alto",
            "KPB": "Point Baker",
            "PBF": "Pine Bluff",
            "PBG": "Plattsburgh",
            "PBI": "West Palm Beach",
            "PVL": "Pikeville",
            "PCD": "Prairie Du Chien",
            "PDK": "Atlanta",
            "PDT": "Pendleton",
            "PDX": "Portland",
            "PEQ": "Pecos",
            "PFC": "Pacific City",
            "PGA": "Page",
            "PGD": "Punta Gorda",
            "PGR": "Paragould",
            "PGV": "Greenville",
            "PHD": "New Philadelphia",
            "PHF": "Newport News",
            "ADR": "Andrews",
            "PHK": "Pahokee",
            "PHL": "Philadelphia",
            "PHN": "Port Huron",
            "PHP": "Philip",
            "PHT": "Paris",
            "PHX": "Phoenix",
            "PIA": "Peoria",
            "PIB": "Moselle",
            "PIE": "Pinellas Park",
            "PIH": "Pocatello",
            "PIM": "Pine Mountain",
            "PIR": "Pierre",
            "PIT": "Pittsburgh",
            "PKB": "Parkersburg (Williamstown)",
            "PKD": "Park Rapids",
            "PKF": "Park Falls",
            "KPL": "Kapal",
            "PLK": "Branson / Hollister",
            "PLN": "Pellston",
            "PLR": "Pell City",
            "PMB": "Pembina",
            "PMD": "Palmdale",
            "PMH": "Portsmouth",
            "PPM": "Pompano Beach",
            "PWY": "Pinedale",
            "PNC": "Ponca City",
            "PNE": "Philadelphia",
            "PNN": "Princeton",
            "PNS": "Pensacola",
            "POB": "Fort Bragg",
            "POC": "La Verne",
            "POE": "Fort Polk",
            "POF": "Poplar Bluff",
            "POH": "Pocahontas",
            "POU": "Poughkeepsie",
            "POY": "Powell",
            "PPA": "Pampa",
            "PPF": "Parsons",
            "LPO": "La Porte",
            "PQI": "Presque Isle",
            "PGL": "Pascagoula",
            "KPR": "Port Williams",
            "PRB": "Paso Robles",
            "PRC": "Prescott",
            "PRO": "Perry",
            "PRX": "Paris",
            "PSB": "Philipsburg",
            "PSC": "Pasco",
            "PSF": "Pittsfield",
            "PSK": "Dublin",
            "PSM": "Portsmouth",
            "PSN": "Palestine",
            "PGO": "Pagosa Springs",
            "PSP": "Palm Springs",
            "PSX": "Palacios",
            "PTB": "Petersburg",
            "PTK": "Pontiac",
            "PTN": "Patterson",
            "PTS": "Pittsburg",
            "PTT": "Pratt",
            "PTV": "Porterville",
            "PTW": "Pottstown",
            "PUB": "Pueblo",
            "PUC": "Price",
            "PUW": "Pullman",
            "PVC": "Provincetown",
            "PVD": "Warwick",
            "PVF": "Placerville",
            "PVU": "Provo",
            "PVW": "Plainview",
            "PWA": "Oklahoma City",
            "PWD": "Plentywood",
            "PWK": "Chicago/Prospect Heights/Wheeling",
            "PWM": "Portland",
            "PWT": "Bremerton",
            "KPY": "Port Bailey",
            "PYM": "Plymouth",
            "JCJ": "Chuja, Hach’uja-do (Chujado Islands)",
            "RAC": "Racine",
            "RAL": "Riverside",
            "RAP": "Rapid City",
            "RBD": "Dallas",
            "RBG": "Roseburg",
            "RBL": "Red Bluff",
            "RBW": "Walterboro",
            "RCA": "Rapid City",
            "RCK": "Rockdale",
            "RCR": "Rochester",
            "RCT": "Reed City",
            "RDD": "Redding",
            "RDG": "Reading",
            "RDM": "Redmond",
            "RDR": "Grand Forks",
            "RDU": "Raleigh/Durham",
            "REO": "Rome",
            "RFD": "Chicago/Rockford",
            "RFG": "Refugio",
            "RHI": "Rhinelander",
            "RHV": "San Jose",
            "RIC": "Richmond",
            "RID": "Richmond",
            "RIF": "Richfield",
            "RIL": "Rifle",
            "RIR": "Riverside",
            "RIV": "Riverside",
            "RIW": "Riverton",
            "RKD": "Rockland",
            "RKP": "Rockport",
            "RKR": "Poteau",
            "RKS": "Rock Springs",
            "RKW": "Rockwood",
            "RLD": "Richland",
            "RME": "Rome",
            "RMG": "Rome",
            "RNC": "Mc Minnville",
            "RND": "Universal City",
            "RNH": "New Richmond",
            "RNO": "Reno",
            "RNT": "Renton",
            "ROA": "Roanoke",
            "ROC": "Rochester",
            "ROG": "Rogers",
            "ROW": "Roswell",
            "ROX": "Roseau",
            "RIE": "Rice Lake",
            "RPX": "Roundup",
            "WBR": "Big Rapids",
            "RQO": "El Reno",
            "RRL": "Merrill",
            "RRT": "Warroad",
            "RSL": "Russell",
            "RSN": "Ruston",
            "RST": "Rochester",
            "RSW": "Fort Myers",
            "RTN": "Raton",
            "SRW": "Salisbury",
            "RUT": "Rutland",
            "RED": "Reedsville",
            "RVS": "Tulsa",
            "RWF": "Redwood Falls",
            "RWI": "Rocky Mount",
            "RWL": "Rawlins",
            "RXE": "Rexburg",
            "RNZ": "Rensselaer",
            "AHM": "Ashland",
            "BDY": "Bandon",
            "SUO": "Sunriver",
            "MDJ": "Madras",
            "PRZ": "Prineville",
            "SAA": "Saratoga",
            "SAC": "Sacramento",
            "SAD": "Safford",
            "SAF": "Santa Fe",
            "SAN": "San Diego",
            "SAR": "Sparta",
            "SAS": "Salton City",
            "SAT": "San Antonio",
            "SAV": "Savannah",
            "MQT": "Gwinn",
            "SBA": "Santa Barbara",
            "SBD": "San Bernardino",
            "SBM": "Sheboygan",
            "SBN": "South Bend",
            "SBP": "San Luis Obispo",
            "SBS": "Steamboat Springs",
            "SBX": "Shelby",
            "SBY": "Salisbury",
            "SCB": "Scribner",
            "SCH": "Schenectady",
            "SCK": "Stockton",
            "SDF": "Louisville",
            "SCF": "Scottsdale",
            "SDM": "San Diego",
            "SDY": "Sidney",
            "SEA": "Seattle",
            "SEE": "San Diego/El Cajon",
            "SEF": "Sebring",
            "SEG": "Selinsgrove",
            "SEM": "Selma",
            "SEP": "Stephenville",
            "SER": "Seymour",
            "SDX": "Sedona",
            "SFB": "Orlando",
            "SFF": "Spokane",
            "SFM": "Sanford",
            "SFO": "San Francisco",
            "SFZ": "Pawtucket",
            "SGF": "Springfield",
            "SGH": "Springfield",
            "UST": "St Augustine",
            "SGR": "Houston",
            "SGT": "Stuttgart",
            "SGU": "St George",
            "SHD": "Weyers Cave",
            "SHN": "Shelton",
            "SHR": "Sheridan",
            "SHV": "Shreveport",
            "SIK": "Sikeston",
            "SIV": "Sullivan",
            "SIY": "Montague",
            "SJC": "San Jose",
            "SJN": "St Johns",
            "SJT": "San Angelo",
            "SKA": "Spokane",
            "SKF": "San Antonio",
            "TSM": "Taos",
            "SLB": "Storm Lake",
            "SLC": "Salt Lake City",
            "SLE": "Salem",
            "SLG": "Siloam Springs",
            "SLK": "Saranac Lake",
            "SLN": "Salina",
            "SLO": "Salem",
            "SLR": "Sulphur Springs",
            "SMD": "Fort Wayne",
            "SME": "Somerset",
            "SMF": "Sacramento",
            "SMN": "Salmon",
            "SMO": "Santa Monica",
            "SUM": "Sumter",
            "SMX": "Santa Maria",
            "SNA": "Santa Ana",
            "SNK": "Snyder",
            "SNL": "Shawnee",
            "SNS": "Salinas",
            "SNY": "Sidney",
            "SOP": "Carthage",
            "SOW": "Show Low",
            "SPA": "Spartanburg",
            "SPF": "Spearfish",
            "SPG": "St Petersburg",
            "SPI": "Springfield",
            "SPS": "Wichita Falls",
            "SPW": "Spencer",
            "SQI": "Rock Falls",
            "SQL": "San Carlos",
            "SRC": "Searcy",
            "SRQ": "Sarasota/Bradenton",
            "RUI": "Alto",
            "SSC": "Sumter",
            "SSF": "San Antonio",
            "SSI": "St Simons Island",
            "STC": "Saint Cloud",
            "STE": "Stevens Point",
            "STJ": "St Joseph",
            "STK": "Sterling",
            "STL": "St Louis",
            "STP": "Saint Paul",
            "STS": "Santa Rosa",
            "SUA": "Stuart",
            "SUD": "Stroud",
            "SUE": "Sturgeon Bay",
            "SUN": "Hailey",
            "SUS": "St Louis",
            "SUU": "Fairfield",
            "SUW": "Superior",
            "SUX": "Sioux City",
            "SVC": "Silver City",
            "SVE": "Susanville",
            "SVH": "Statesville",
            "SVN": "Savannah",
            "SWF": "Newburgh",
            "SWO": "Stillwater",
            "SWW": "Sweetwater",
            "SYI": "Shelbyville",
            "SYN": "Dennison",
            "SYR": "Syracuse",
            "SYV": "Sylvester",
            "SZL": "Knob Noster",
            "SZN": "Santa Cruz Island",
            "SZP": "Santa Paula",
            "TBC": "Tuba City",
            "TAD": "Trinidad",
            "KTB": "Thorne Bay",
            "TBN": "Fort Leonard Wood",
            "TBR": "Statesboro",
            "KTC": "Katiola",
            "TCC": "Tucumcari",
            "TCL": "Tuscaloosa",
            "TCM": "Tacoma",
            "TCS": "Truth or Consequences",
            "TDO": "Toledo",
            "TDW": "Amarillo",
            "TDZ": "Toledo",
            "TEB": "Teterboro",
            "TEX": "Telluride",
            "THA": "Tullahoma",
            "THM": "Thompson Falls",
            "THV": "Thomasville",
            "TIK": "Oklahoma City",
            "TIW": "Tacoma",
            "TIX": "Titusville",
            "KNT": "Kennett",
            "TLH": "Tallahassee",
            "TLR": "Tulare",
            "TMA": "Tifton",
            "TMB": "Miami",
            "OTK": "Tillamook",
            "TNP": "Twentynine Palms",
            "TNT": "Miami",
            "TNU": "Newton",
            "XSD": "Tonopah",
            "TOA": "Torrance",
            "TOC": "Toccoa",
            "TOI": "Troy",
            "TOL": "Toledo",
            "TOP": "Topeka",
            "TOR": "Torrington",
            "TPA": "Tampa",
            "TPF": "Tampa",
            "TPH": "Tonopah",
            "TPL": "Temple",
            "TRI": "Blountville",
            "TKF": "Truckee",
            "TRL": "Terrell",
            "TRM": "Palm Springs",
            "TRX": "Trenton",
            "TSP": "Tehachapi",
            "TTD": "Portland",
            "TTN": "Ewing Township",
            "TUL": "Tulsa",
            "TUP": "Tupelo",
            "TUS": "Tucson",
            "TVC": "Traverse City",
            "TVF": "Thief River Falls",
            "TVI": "Thomasville",
            "TVL": "South Lake Tahoe",
            "TWF": "Twin Falls",
            "TXK": "Texarkana",
            "TYZ": "Taylor",
            "TYR": "Tyler",
            "TYS": "Alcoa",
            "BFG": "Bullfrog",
            "NPH": "Nephi",
            "RVR": "Green River",
            "PNU": "Panguitch",
            "ICS": "Cascade",
            "UBS": "Columbus",
            "UCY": "Union City",
            "UDD": "Bermuda Dunes",
            "UES": "Waukesha",
            "UGN": "Chicago/Waukegan",
            "UIL": "Quillayute",
            "UIN": "Quincy",
            "IKB": "North Wilkesboro",
            "UKI": "Ukiah",
            "UKT": "Quakertown",
            "ULM": "New Ulm",
            "ATO": "Albany",
            "UNU": "Juneau",
            "SCE": "State College",
            "UOS": "Sewanee",
            "UOX": "Oxford",
            "KUP": "Kupiano",
            "UTM": "Tunica",
            "HTV": "Huntsville",
            "NPT": "Newport",
            "UVA": "Uvalde",
            "RKH": "Rock Hill",
            "VAD": "Valdosta",
            "LLY": "Lumberton",
            "VBG": "Lompoc",
            "VCT": "Victoria",
            "VCV": "Victorville",
            "VDI": "Vidalia",
            "KVE": "Kitava Island",
            "VEL": "Vernal",
            "VGT": "Las Vegas",
            "VHN": "Van Horn",
            "VIH": "Vichy",
            "VIS": "Visalia",
            "VJI": "Abingdon",
            "VKS": "Vicksburg",
            "VLA": "Vandalia",
            "VLD": "Valdosta",
            "VNC": "Venice",
            "VNY": "Van Nuys",
            "VOK": "Camp Douglas",
            "VPS": "Valparaiso",
            "VPZ": "Valparaiso",
            "VQQ": "Jacksonville",
            "VRB": "Vero Beach",
            "VSF": "North Springfield",
            "VTN": "Valentine",
            "VYS": "Peru",
            "GTY": "Gettysburg",
            "SQV": "Sequim",
            "PGC": "Petersburg",
            "WAL": "Wallops Island",
            "WAY": "Waynesburg",
            "WBW": "Wilkes-Barre",
            "WDG": "Enid",
            "WDR": "Winder",
            "WEA": "Weatherford",
            "KWF": "Waterfall",
            "WHP": "Pacoima",
            "WJF": "Lancaster",
            "WLD": "Winfield / Arkansas City",
            "WLW": "Willows",
            "WMC": "Winnemucca",
            "KWP": "West Point",
            "WRB": "Warner Robins",
            "WRI": "Wrightstown",
            "WRL": "Worland",
            "WST": "Westerly",
            "WVI": "Watsonville",
            "WVL": "Waterville",
            "WWD": "Wildwood",
            "WWR": "Woodward",
            "KWY": "Kiwayu",
            "WYS": "West Yellowstone",
            "KYO": "Tampa",
            "KXA": "Kasaan",
            "XNA": "Fayetteville/Springdale/Rogers",
            "XWA": "Williston",
            "WBK": "West Branch",
            "YIP": "Detroit",
            "YKM": "Yakima",
            "YKN": "Yankton",
            "YNG": "Youngstown/Warren",
            "ATX": "Atbasar",
            "KZB": "Zachar Bay",
            "ZPH": "Zephyrhills",
            "ZZV": "Zanesville",
            "PGS": "Peach Springs",
            "BOR": "Ton Phueng",
            "LAC": "Pulau Layang-Layang (Swallow Reef)",
            "KFZ": "Kukës",
            "TIA": "Rinas",
            "BOJ": "Burgas",
            "GOZ": "Gorna Oryahovitsa",
            "LBH": "Sydney",
            "LBM": "Luabo",
            "PDV": "Plovdiv",
            "ROU": "Shtraklevo",
            "SOF": "Sofia",
            "VAR": "Varna",
            "ECN": "Tymbou (Kirklar)",
            "GEC": "Lefkoniko (Geçitkale)",
            "LCA": "Larnaca",
            "LCP": "Loncopue",
            "PFO": "Paphos",
            "AKT": "Akrotiri",
            "DBV": "Čilipi",
            "LSZ": "Mali Lošinj",
            "OSI": "Klisa",
            "PUY": "Pula",
            "RJK": "Omišalj",
            "BWK": "Gornji Humac",
            "SPU": "Kaštel Štafilić",
            "LDW": "Lansdowne Station",
            "ZAG": "Velika Gorica",
            "ZAD": "Zemunik Donji (Zadar)",
            "ABC": "Albacete",
            "ALC": "Alicante",
            "LEI": "Almería",
            "OVD": "Ranón",
            "ODB": "Córdoba",
            "BIO": "Bilbao",
            "RGS": "Burgos",
            "BCN": "Barcelona",
            "BJZ": "Badajoz",
            "CDT": "Castellón de la Plana",
            "LCG": "Culleredo",
            "ILD": "Lleida",
            "GRO": "Girona",
            "GRX": "Granada",
            "HSK": "Monflorite/Alcalá del Obispo",
            "IBZ": "Ibiza (Eivissa)",
            "XRY": "Jerez de la Frontera",
            "LEN": "La Virgen Del Camino",
            "RJL": "Logroño",
            "MAD": "Madrid",
            "AGP": "Málaga",
            "MAH": "Mahón (Maó)",
            "RMU": "Corvera",
            "OZP": "Morón",
            "LEO": "Lekoni",
            "PMI": "Palma de Mallorca",
            "PNA": "Pamplona",
            "CQM": "Ciudad Real",
            "REU": "Reus",
            "ROZ": "Rota",
            "SLM": "Salamanca",
            "EAS": "Hondarribia",
            "SCQ": "Santiago de Compostela",
            "LEU": "La Seu d'Urgell Pyrenees and Andorra",
            "TEV": "Teruel",
            "TOJ": "Madrid",
            "VLC": "Valencia",
            "VLL": "Valladolid",
            "VIT": "Alava",
            "VGO": "Vigo",
            "SDR": "Santander",
            "ZAZ": "Zaragoza",
            "SVQ": "Sevilla",
            "DPE": "Saint-Aubin-sur-Scie",
            "CQF": "Calais",
            "BYF": "Albert",
            "LTQ": "Le Touquet-Paris-Plage",
            "AGF": "Agen",
            "BOD": "Bordeaux",
            "EGC": "Bergerac",
            "CNG": "Cognac/Châteaubernard",
            "LRH": "La Rochelle",
            "PIS": "Poitiers/Biard",
            "MCU": "Lépaud, Creuse",
            "LIG": "Limoges/Bellegarde",
            "NIT": "Niort/Souché",
            "TLS": "Toulouse/Blagnac",
            "PUF": "Pau/Pyrénées (Uzein)",
            "LDE": "Tarbes/Lourdes/Pyrénées",
            "ANG": "Angoulême",
            "PGX": "Périgueux/Bassillac",
            "BIQ": "Biarritz",
            "ZAO": "Cahors",
            "LBI": "Albi",
            "DCM": "Castres",
            "RDZ": "Rodez/Marcillac",
            "RYN": "Royan/Médis",
            "RCO": "Rochefort/Saint-Agnant",
            "BIC": "Bangor",
            "OUI": "Ushant",
            "IDY": "Île d'Yeu",
            "CMR": "Colmar",
            "DLE": "Dole",
            "MVV": "Megève",
            "OBS": "Lanas, Ardèche",
            "LPY": "Chaspuzac, Haute-Loire",
            "AHZ": "Huez, Isère",
            "ETZ": "Goin",
            "ANE": "Angers",
            "BIA": "Bastia",
            "CLY": "Calvi",
            "FSC": "Figari",
            "AJA": "Ajaccio",
            "PRP": "Propriano",
            "SOZ": "Solenzara",
            "MFX": "Les Allues",
            "AUF": "Auxerre",
            "CMF": "Chambéry",
            "CFE": "Clermont-Ferrand",
            "BOU": "Bourges",
            "CVF": "Saint-Bon",
            "LYS": "Colombier-Saugnieu, Rhône",
            "SYT": "L'Hôpital-le-Mercier, Saône-et-Loire",
            "RNE": "Saint-Léger-sur-Roanne",
            "NCY": "Annecy",
            "GNB": "Grenoble",
            "VAF": "Chabeuil, Drôme",
            "VHY": "Charmeil, Allier",
            "AUR": "Aurillac",
            "CHR": "Châteauroux",
            "LYN": "Chassieu, Lyon",
            "CEQ": "Cannes",
            "EBU": "Andrézieux-Bouthéon, Loire",
            "CCF": "Carcassonne",
            "MRS": "Marignane, Bouches-du-Rhône",
            "NCE": "Nice, Alpes-Maritimes",
            "PGF": "Perpignan/Rivesaltes",
            "CTT": "Le Castellet, Var",
            "BAE": "Saint-Pons, Alpes-de-Haute-Provence",
            "MPL": "Montpellier/Méditerranée",
            "BZR": "Béziers",
            "AVN": "Avignon",
            "GAT": "Tallard, Hautes-Alpes",
            "MEN": "Mende/Brénoux",
            "SCP": "Saint-Crépin, Hautes-Alpes",
            "BVA": "Beauvais",
            "EVX": "Fauville, Eure",
            "LEH": "Le Havre",
            "XCR": "Chalons en Champagne",
            "LSO": "Les Sables-d'Olonne",
            "URO": "Boos",
            "TUF": "Tours, Indre-et-Loire",
            "CET": "Cholet",
            "LVA": "Laval, Mayenne",
            "ORE": "Saint-Denis-de-l'Hôtel, Loiret",
            "LBG": "Paris",
            "CSF": "Creil",
            "CDG": "Paris (Roissy-en-France, Val-d'Oise)",
            "TNF": "Toussus-le-Noble, Yvelines",
            "ORY": "Paris (Orly, Val-de-Marne)",
            "POX": "Cormeilles-en-Vexin, Val-d'Oise",
            "VIY": "Vélizy-Villacoublay, Yvelines",
            "NVS": "Marzy, Nièvre",
            "LIL": "Lesquin",
            "HZB": "Merville, Nord",
            "BES": "Brest",
            "CER": "Cherbourg",
            "DNR": "Dinard",
            "LBY": "La Baule-Escoublac",
            "GFR": "Bréville-sur-Mer, Manche",
            "DOL": "Deauville",
            "LRT": "Lorient/Lann/Bihoué",
            "EDM": "La Roche-sur-Yon",
            "LDV": "Landivisiau",
            "CFR": "Caen",
            "LME": "Le Mans, Sarthe",
            "RNS": "Saint-Jacques-de-la-Lande, Ille-et-Vilaine",
            "LAI": "Lannion",
            "UIP": "Quimper/Pluguffan",
            "NTE": "Nantes",
            "SBK": "Trémuson, Côtes-d'Armor",
            "MXN": "Morlaix/Ploujean",
            "VNE": "Vannes/Meucon",
            "SNR": "Saint-Nazaire/Montoir",
            "BSL": "Bâle / Mulhouse",
            "DIJ": "Dijon",
            "EPL": "Épinal",
            "BVE": "Brive",
            "ENC": "Tomblaine, Meurthe-et-Moselle",
            "SXB": "Strasbourg",
            "TLN": "Hyères, Var",
            "FNI": "Nîmes/Garons",
            "LTT": "Saint-Tropez",
            "MQC": "Miquelon",
            "FSP": "Saint-Pierre",
            "PYR": "Andravida",
            "AXD": "Alexandroupolis",
            "ATH": "Spata-Artemida",
            "VOL": "Nea Anchialos",
            "LGE": "Lake Gregory",
            "JKH": "Chios Island",
            "JIK": "Ikaria Island",
            "IOA": "Ioannina",
            "HER": "Heraklion",
            "KSO": "Argos Orestiko",
            "KIT": "Kithira Island",
            "EFL": "Kefallinia Island",
            "KZS": "Kastelorizo Island",
            "KLX": "Kalamata",
            "KGS": "Kos Island",
            "AOK": "Karpathos Island",
            "CFU": "Kerkyra (Corfu)",
            "KSJ": "Kasos Island",
            "KVA": "Kavala",
            "JKL": "Kalymnos Island",
            "KZI": "Kozani",
            "LRS": "Leros Island",
            "LXS": "Limnos Island",
            "LRA": "Larissa",
            "JMK": "Mykonos",
            "MLO": "Milos Island",
            "MJT": "Mytilene",
            "JNX": "Naxos",
            "PAS": "Paros",
            "JTY": "Astypalaia Island",
            "PVK": "Preveza",
            "RHO": "Rhodes",
            "GPA": "Patras",
            "CHQ": "Souda",
            "JSI": "Skiathos",
            "SMI": "Samos Island",
            "JSY": "Syros Island",
            "SPJ": "Sparti",
            "JTR": "Santorini Island",
            "JSH": "Crete Island",
            "SKU": "Skiros Island",
            "SKG": "Thessaloniki",
            "ZTH": "Zakynthos",
            "BUD": "Budapest",
            "DEB": "Debrecen",
            "PEV": "Pécs",
            "SOB": "Sármellék",
            "CRV": "Isola di Capo Rizzuto (KR)",
            "BRI": "Bari",
            "FOG": "Foggia (FG)",
            "TAR": "Grottaglie",
            "LCC": "Galatina (LE)",
            "PSR": "Pescara",
            "BDS": "Brindisi",
            "SUF": "Lamezia Terme (CZ)",
            "CIY": "Comiso",
            "CTA": "Catania",
            "LMP": "Lampedusa",
            "PNL": "Pantelleria (TP)",
            "PMO": "Palermo",
            "REG": "Reggio Calabria",
            "TPS": "Trapani (TP)",
            "BLX": "Belluno (BL)",
            "RAN": "Ravenna (RA)",
            "AHO": "Alghero",
            "DCI": "Decimomannu",
            "CAG": "Cagliari",
            "OLB": "Olbia (SS)",
            "FNU": "Oristano",
            "MXP": "Ferno (VA)",
            "BGY": "Orio al Serio (BG)",
            "TRN": "Caselle Torinese (TO)",
            "GOA": "Genova (GE)",
            "LIN": "Segrate (MI)",
            "PMF": "Parma (PR)",
            "AOT": "Saint-Christophe (AO)",
            "CUF": "Levaldigi (CN)",
            "AVB": "Aviano (PN)",
            "BZO": "Bolzano (BZ)",
            "BLQ": "Bologna",
            "TSF": "Treviso (TV)",
            "FRL": "Forlì (FC)",
            "VBS": "Montichiari (BS)",
            "TRS": "Ronchi dei Legionari (GO)",
            "RMI": "Rimini (RN)",
            "VRN": "Caselle (VR)",
            "AOI": "Falconara Marittima (AN)",
            "VCE": "Venezia (VE)",
            "CIA": "Rome",
            "FCO": "Rome",
            "QSR": "Salerno",
            "EBA": "Campo nell'Elba (LI)",
            "NAP": "Napoli",
            "PSA": "Pisa (PI)",
            "FLR": "Firenze (FI)",
            "GRS": "Grosseto (GR)",
            "PEG": "Perugia (PG)",
            "LJU": "Zgornji Brnik",
            "MBX": "Orehova Vas",
            "POW": "Sečovlje",
            "NUA": "Nuwara Eliya",
            "LKC": "Lekana",
            "JCL": "České Budějovice",
            "UHE": "Uherské Hradiště",
            "KLV": "Karlovy Vary",
            "HRA": "Mnichovo Hradiště",
            "OSR": "Mošnov",
            "OLO": "Olomouc",
            "PED": "Pardubice",
            "PRV": "Přerov",
            "PRG": "Prague",
            "BRQ": "Brno",
            "VOD": "Vodochody",
            "ZBE": "Dolní Benešov",
            "TLV": "Tel Aviv",
            "BEV": "Beersheba",
            "ETM": "Eilat",
            "EIY": "Sapir",
            "LLH": "La Lima",
            "HFA": "Haifa",
            "RPN": "Rosh Pina",
            "KSW": "Kiryat Shmona",
            "LLL": "Lissadell Station",
            "MTZ": "Masada",
            "VTM": "Beersheba",
            "VDA": "Eilat",
            "MIP": "Beersheba",
            "YOT": "Yotvata",
            "GZM": "Gozo",
            "MLA": "Valletta",
            "LMV": "Naifaru",
            "LMZ": "Palma",
            "MCM": "Fontvieille",
            "ANT": "Sankt Anton am Arlberg",
            "HOH": "Hohenems",
            "LOM": "Lagos de Moreno",
            "LOR": "Fort Rucker Ozark",
            "GRZ": "Feldkirchen bei Graz",
            "INN": "Innsbruck",
            "KLU": "Klagenfurt am Wörthersee",
            "LNZ": "Linz",
            "SZG": "Salzburg",
            "VIE": "Vienna",
            "SMA": "Vila do Porto",
            "BGC": "Bragança",
            "BYJ": "Beja",
            "CVU": "Corvo",
            "CAT": "Cascais",
            "FLW": "Santa Cruz das Flores",
            "FAO": "Faro",
            "GRW": "Santa Cruz da Graciosa",
            "HOR": "Horta",
            "TER": "Praia da Vitória",
            "FNC": "Funchal",
            "PDL": "Ponta Delgada",
            "PIX": "Pico Island",
            "PRM": "Portimão",
            "OPO": "Porto",
            "PXO": "Vila Baleira",
            "LIS": "Lisbon",
            "SJZ": "Velas",
            "VRL": "Vila Real",
            "VSE": "Viseu",
            "BNX": "Mahovljani",
            "OMO": "Mostar",
            "SJJ": "Sarajevo",
            "TZL": "Dubrave Gornje",
            "ARW": "Arad",
            "BCM": "Bacău",
            "BAY": "Tăuții-Măgherăuș",
            "BBU": "Bucharest",
            "GHV": "Brașov (Ghimbav)",
            "CND": "Mihail Kogălniceanu",
            "CLJ": "Cluj-Napoca",
            "CSB": "Caransebeş",
            "CRA": "Craiova",
            "IAS": "Iaşi",
            "OMR": "Oradea",
            "OTP": "Otopeni",
            "SBZ": "Sibiu",
            "SUJ": "Satu Mare",
            "SCV": "Suceava",
            "TCE": "Mihail Kogălniceanu",
            "TGM": "Recea",
            "TSR": "Timişoara",
            "GVA": "Geneva",
            "SIR": "Sion",
            "EML": "Emmen",
            "VIP": "Payerne",
            "LUG": "Agno",
            "BRN": "Bern",
            "BXO": "Buochs",
            "ZRH": "Zurich",
            "ACH": "St. Gallen",
            "SMV": "Samedan",
            "ESB": "Ankara",
            "ANK": "Ankara",
            "ADA": "Seyhan",
            "UAB": "Sarıçam",
            "AFY": "Afyonkarahisar",
            "AYT": "Antalya",
            "GZT": "Gaziantep",
            "KFS": "Kastamonu",
            "KYA": "Konya",
            "MZH": "Amasya",
            "VAS": "Sivas",
            "ONQ": "Zonguldak",
            "MLX": "Malatya",
            "ASR": "Kayseri",
            "TJK": "Tokat",
            "DNZ": "Denizli",
            "NAV": "Nevşehir",
            "ISL": "Bakırköy, Istanbul",
            "CII": "Aydın",
            "BZI": "Balıkesir",
            "BDM": "Bandırma",
            "CKZ": "Çanakkale",
            "ESK": "Eskişehir",
            "ADB": "Gaziemir",
            "IGL": "Çiğli",
            "USQ": "Uşak",
            "KCO": "Kartepe",
            "YEI": "Yenişehir",
            "DLM": "Dalaman",
            "TEQ": "Çorlu",
            "BXN": "Bodrum",
            "AOE": "Eskişehir",
            "KZR": "Altıntaş",
            "EZS": "Elazığ",
            "OGU": "Ordu",
            "DIY": "Diyarbakır",
            "ERC": "Erzincan",
            "ERZ": "Erzurum",
            "KSY": "Kars",
            "TZX": "Trabzon",
            "VAN": "Van",
            "BAL": "Batman",
            "MSR": "Muş",
            "SXZ": "Siirt",
            "NOP": "Sinop",
            "KCM": "Kahramanmaraş",
            "AJI": "Ağrı",
            "ADF": "Adıyaman",
            "MQM": "Mardin",
            "GNY": "Şanlıurfa",
            "IGD": "Iğdır",
            "BGG": "Bingöl",
            "NKT": "Şırnak",
            "YKO": "Hakkari",
            "HTY": "Antakya",
            "COV": "Tarsus",
            "LTF": "Leitre",
            "IZM": "Selçuk",
            "ISE": "Isparta",
            "EDO": "Edremit",
            "BJV": "Bodrum",
            "GZP": "Gazipaşa",
            "SZF": "Samsun",
            "SAW": "Pendik, Istanbul",
            "GKD": "Gökçeada",
            "IST": "Arnavutköy, Istanbul",
            "RZV": "Rize",
            "BZY": "Bălți",
            "RMO": "Chişinău",
            "LWA": "Lebak",
            "OHD": "Ohrid",
            "SKP": "Ilinden",
            "GIB": "Gibraltar",
            "BCQ": "Brak",
            "DNF": "Martuba",
            "BEG": "Belgrade",
            "IVG": "Berane",
            "BJY": "Zemun",
            "KVO": "Kraljevo",
            "INI": "Niš",
            "TGD": "Podgorica",
            "TIV": "Tivat",
            "UZC": "Stapari",
            "LZG": "Nanchong (Langzhong)",
            "BTS": "Bratislava",
            "KSC": "Košice",
            "LUE": "Lučenec",
            "PZY": "Piešťany",
            "POV": "Prešov",
            "SLD": "Sliač",
            "TAT": "Poprad",
            "ILZ": "Dolný Hričov",
            "DRU": "Drummond",
            "GLN": "Guelmim",
            "UWA": "Ware",
            "MAP": "Mamai",
            "GDT": "Cockburn Town",
            "MDS": "Middle Caicos",
            "NCA": "North Caicos",
            "PIC": "Pine Cay",
            "PLS": "Providenciales",
            "XSC": "South Caicos",
            "SLX": "Salt Cay",
            "BRX": "Barahona",
            "CBJ": "Cabo Rojo",
            "AZS": "Samana",
            "COZ": "Costanza",
            "JBQ": "La Isabela",
            "LRM": "La Romana",
            "PUJ": "Punta Cana",
            "POP": "Puerto Plata",
            "SDQ": "Santo Domingo",
            "STI": "Santiago",
            "MDV": "Médouneu, Gabon",
            "LIZ": "Limestone",
            "MEF": "Melfi",
            "NKO": "Ankokoambo",
            "RLR": "Isalo",
            "DOA": "Doany",
            "CBV": "Coban",
            "CMM": "Carmelita",
            "CTF": "Coatepeque",
            "GUA": "Guatemala City",
            "HUG": "Huehuetenango",
            "MGI": "Matagorda Island",
            "MGP": "Manga Mission",
            "PBR": "Puerto Barrios",
            "PKJ": "Playa Grande",
            "PON": "Poptún",
            "AQB": "Santa Cruz del Quiché",
            "AAZ": "Quezaltenango",
            "RUV": "Rubelsanto",
            "LCF": "Rio Dulce",
            "RER": "Retalhuleu",
            "GSJ": "Puerto San José",
            "FRS": "San Benito",
            "UJE": "Ujae Atoll",
            "AIM": "Ailuk Island",
            "AUL": "Aur Atoll",
            "BII": "Bikini Atoll",
            "EBN": "Ebadon Island",
            "JAT": "Ailinglapalap Atoll",
            "JEJ": "Ailinglapalap Atoll",
            "LIK": "Likiep Island",
            "LML": "Lae Island",
            "MAV": "Maloelap Island",
            "MJB": "Mejit Atoll",
            "MJE": "Majkin",
            "NDK": "Namorik Atoll",
            "RNP": "Rongelap Island",
            "TIC": "Arno Atoll",
            "UIT": "Jabor Jaluit Atoll",
            "WJA": "Woja",
            "WTE": "Wotje",
            "WTO": "Wotho Island",
            "AHS": "Ahuas",
            "BHG": "Brus Laguna",
            "LUI": "La Unión",
            "CYL": "Coyoles",
            "CDD": "Cauquira",
            "OAN": "Olanchito",
            "CAA": "El Aguacate",
            "GAC": "Gracias",
            "IRN": "Iriona",
            "JUT": "Jutigalpa",
            "LCE": "La Ceiba",
            "LEZ": "La Esperanza",
            "SAP": "San Pedro Sula",
            "LMH": "Limón",
            "MHN": "Mullen",
            "GJA": "Guanaja",
            "PCH": "Palacios",
            "PEU": "Puerto Lempira",
            "RTB": "Coxen Hole",
            "RUY": "Copán Ruinas",
            "XPL": "Palmerola",
            "TEA": "Tela",
            "TGU": "Tegucigalpa",
            "TJI": "Trujillo",
            "TCF": "Tocoa",
            "SCD": "Sulaco",
            "UII": "Utila Island",
            "ORO": "Yoro",
            "MIZ": "Mainoru",
            "MJJ": "Moki",
            "MJS": "Maganja",
            "OCJ": "Boscobel",
            "KIN": "Kingston",
            "MBJ": "Montego Bay",
            "POT": "Ken Jones",
            "NEG": "Negril",
            "KTP": "Tinson Pen",
            "MIJ": "Mili Island",
            "HEB": "Hinthada",
            "TZM": "Tizimin",
            "ACA": "Acapulco",
            "NTR": "Monterrey",
            "AGU": "Aguascalientes",
            "HUX": "Huatulco",
            "CNA": "Cananea",
            "CVJ": "Temixco",
            "ACN": "Ciudad Acuña",
            "CME": "Ciudad del Carmen",
            "NCG": "Nuevo Casas Grandes",
            "CUL": "Culiacán",
            "CTM": "Chetumal",
            "CEN": "Ciudad Obregón",
            "CJT": "Comitán",
            "CPE": "Campeche",
            "CJS": "Ciudad Juárez",
            "CZA": "Tinúm",
            "CUU": "Chihuahua",
            "CVM": "Ciudad Victoria",
            "CYW": "Celaya",
            "CZM": "Cozumel",
            "CUA": "Comondú",
            "MMC": "Ciudad Mante",
            "DGO": "Durango",
            "TPQ": "Tepic",
            "ESE": "Ensenada",
            "GDL": "Guadalajara",
            "GYM": "Guaymas",
            "GUB": "San Quintín",
            "TCN": "Tehuacán",
            "HMO": "Hermosillo",
            "CLQ": "Colima",
            "ISJ": "Isla Mujeres",
            "SLW": "Saltillo",
            "IZT": "Ixtepec",
            "JAL": "Emiliano Zapata",
            "AZP": "Atizapán de Zaragoza",
            "LZC": "Lázaro Cárdenas",
            "LMM": "Los Mochis",
            "BJX": "Silao",
            "LAP": "La Paz",
            "LTO": "Loreto",
            "MAM": "Matamoros",
            "MID": "Mérida",
            "MUG": "Mulege",
            "MXL": "Mexicali",
            "MLM": "Morelia",
            "MTT": "Cosoleacaque",
            "LOV": "Monclova",
            "MEX": "Ciudad de México",
            "MTY": "Monterrey",
            "MZT": "Mazatlàn",
            "NOG": "Nogales",
            "NLD": "Nuevo Laredo",
            "OAX": "Oaxaca",
            "PAZ": "Poza Rica",
            "PBC": "Puebla",
            "PPE": "Puerto Peñasco",
            "PDS": "Piedras Negras",
            "PCO": "La Ribera",
            "UPN": "Uruapan",
            "PQM": "Palenque",
            "PVR": "Puerto Vallarta",
            "PXM": "Puerto Escondido",
            "QRO": "Querétaro",
            "REX": "Reynosa",
            "SJD": "San José del Cabo",
            "SFH": "Mexicali",
            "NLU": "Mexico City",
            "SLP": "San Luis Potosí",
            "SCX": "Salina Cruz",
            "TRC": "Torreón",
            "TGZ": "Tuxtla Gutiérrez",
            "TIJ": "Tijuana",
            "TQO": "Tulum",
            "TAM": "Tampico",
            "TSL": "Tamuín",
            "TLC": "Toluca",
            "TAP": "Tapachula",
            "TUY": "Tulum",
            "CUN": "Cancún",
            "MMV": "Mal Island",
            "VSA": "Villahermosa",
            "VER": "Veracruz",
            "ZCL": "Zacatecas",
            "ZIH": "Ixtapa",
            "ZMM": "Zamora",
            "ZLO": "Manzanillo",
            "BEF": "Bluefields",
            "BZA": "Bonanza",
            "ECI": "Tola",
            "RNI": "Corn Island",
            "MGA": "Managua",
            "MNP": "Hermit Islands",
            "PUZ": "Puerto Cabezas",
            "RFS": "La Rosita",
            "NCR": "San Carlos",
            "SIU": "Siuna",
            "WSP": "Waspam",
            "MOH": "Morowali",
            "MOS": "Elim",
            "BOC": "Isla Colón",
            "CTD": "Chitré",
            "CHX": "Changuinola",
            "DAV": "David",
            "ONX": "Colón",
            "BLB": "Panamá City",
            "MPI": "Mamitupu",
            "JQE": "Jaqué",
            "PAC": "Albrook",
            "PUE": "Puerto Obaldía",
            "PDM": "Pedasí",
            "SYP": "Santiago",
            "RIH": "Río Hato",
            "PTY": "Tocumen",
            "PVE": "El Porvenir",
            "NBL": "San Blas",
            "FON": "La Fortuna",
            "BAI": "Punta Arenas",
            "BCL": "Pococi",
            "TTQ": "Tortuguero",
            "OTR": "Corredores",
            "JAP": "Puntarenas",
            "PLD": "Carrillo",
            "DRK": "Puntarenas",
            "FMG": "Brasilito",
            "GLF": "Golfito",
            "GPL": "Pococi",
            "PBP": "Nandayure",
            "LIR": "Liberia",
            "LSL": "Los Chiles",
            "LIO": "Puerto Limon",
            "CSC": "Cañas",
            "NCT": "Nicoya/Guanacate",
            "NOB": "Nicoya",
            "SJO": "San José (Alajuela)",
            "PJM": "Puerto Jimenez",
            "PMZ": "Palmar Sur",
            "SYQ": "San Jose",
            "XQP": "Quepos",
            "RFR": "Rio Frio / Progreso",
            "IPZ": "Pérez Zeledón",
            "TOO": "Coto Brus",
            "MRT": "Moroak",
            "TNO": "Tamarindo",
            "TMU": "Nicoya",
            "UPL": "Upala",
            "MSB": "Saint Martin",
            "SAL": "San Salvador (San Luis Talpa)",
            "ILS": "San Salvador",
            "JCO": "Comino",
            "CYA": "Les Cayes",
            "CAP": "Cap Haitien",
            "MTX": "Fairbanks",
            "JAK": "Jacmel",
            "JEE": "Carrefour Sanon",
            "PAP": "Port-au-Prince",
            "PAX": "Port-de-Paix",
            "MTU": "Montepuez",
            "AHG": "Vingt Cinq",
            "BCA": "Baracoa",
            "BWW": "Cayo Santa Maria",
            "BYM": "Bayamo",
            "AVI": "Ciro Redondo",
            "CCC": "Cayo Coco",
            "CFG": "Cienfuegos",
            "CYO": "Cayo Largo del Sur",
            "CMW": "Camaguey",
            "SCU": "Santiago",
            "NBW": "Guantanamo Bay Naval Station",
            "GAO": "Guantánamo",
            "HAV": "Havana",
            "HOG": "Holguin",
            "VRO": "Santa Marta",
            "LCL": "Pinar del Rio",
            "UMA": "Maisí",
            "MJG": "Mayajigua",
            "MOA": "Moa",
            "MZO": "Manzanillo",
            "GER": "Nueva Gerona",
            "UPB": "Havana",
            "SNU": "Santa Clara",
            "SNJ": "Sandino",
            "SZJ": "Isla de la Juventud",
            "USS": "Sancti Spiritus",
            "TND": "Trinidad",
            "VRA": "Matanzas",
            "VTU": "Las Tunas",
            "FMT": "Faresmaathodaa",
            "MUM": "Muli",
            "CYB": "West End",
            "LYB": "Blossom Village",
            "GCM": "George Town",
            "MWR": "Motswari Private Game Reserve",
            "MWU": "Mussau Island",
            "AJS": "Mulegé",
            "AZG": "Apatzingán",
            "PCM": "Playa del Carmen",
            "PCV": "Mulegé",
            "SGM": "Mulegé",
            "UAC": "San Luis Río Colorado",
            "XAL": "Álamos",
            "MXC": "Monticello",
            "GTK": "Sungai Tekai",
            "LBP": "Long Banga",
            "SPT": "Sipitang",
            "MAY": "Mangrove Cay",
            "ASD": "Andros Town",
            "TZN": "Andros",
            "MHH": "Marsh Harbour",
            "SAQ": "Andros Island",
            "AXP": "Spring Point",
            "TCB": "Treasure Cay",
            "WKR": "Walkers Cay",
            "CCZ": "Chub Cay",
            "GHC": "Bullocks Harbour",
            "BIM": "South Bimini",
            "ATC": "Arthur's Town",
            "TBI": "Cat Island",
            "CXY": "North Cat Cay",
            "CRI": "Colonel Hill",
            "PWN": "Pitts Town",
            "GGT": "Moss Town",
            "ELH": "North Eleuthera",
            "GHB": "Governor's Harbour",
            "NMC": "Normans Cay",
            "RSD": "Rock Sound",
            "TYM": "Staniel Cay",
            "FPO": "Freeport",
            "WTD": "West End",
            "IGA": "Matthew Town",
            "MYK": "May Creek",
            "LGI": "Deadman's Cay",
            "SML": "Stella Maris",
            "MYG": "Abraham Bay Settlement",
            "NAS": "Nassau",
            "DCT": "Duncan Town",
            "RCY": "Port Nelson",
            "MYS": "Moyale",
            "ZSA": "San Salvador",
            "NTC": "Santa Carolina",
            "TGS": "Chokwé",
            "BZE": "Belize City",
            "CYD": "Maya Flats",
            "PLJ": "Placencia",
            "IMI": "Arno Atoll",
            "BQI": "Bagani",
            "AIT": "Aitutaki",
            "AIU": "Atiu Island",
            "MGS": "Mangaia Island",
            "MHX": "Manihiki Island",
            "MUK": "Mauke Island",
            "MOI": "Mitiaro Island",
            "PZK": "Pukapuka Atoll",
            "PYE": "Penrhyn Island",
            "RAR": "Avarua",
            "EPG": "Weeping Water",
            "ICI": "Cicia",
            "CST": "Castaway Island",
            "NAN": "Nadi",
            "PTF": "Malolo Lailai Island",
            "RBI": "Rabi Island",
            "KDV": "Vunisea",
            "MNF": "Mana Island",
            "MFJ": "Moala",
            "SUV": "Nausori",
            "LEV": "Bureta",
            "PHR": "Nanuku Auberge Resort",
            "NGI": "Ngau",
            "LUC": "Laucala Island",
            "LKB": "Lakeba Island",
            "LBS": "Labasa",
            "TVU": "Matei",
            "KXF": "Koro Island",
            "RTA": "Rotuma",
            "SVU": "Savusavu",
            "KAY": "Wakaya Island",
            "ONU": "Ono-i-Lau",
            "YAS": "Yasawa Island",
            "EUA": "Eua Island",
            "TBU": "Nuku'alofa",
            "HPA": "Lifuka",
            "NFO": "Angaha, Niuafo'ou Island",
            "NTT": "Niuatoputapu",
            "VAV": "Vava'u Island",
            "TTL": "Nanuya Levu Island",
            "VBV": "Vanua Balavu",
            "VTF": "Vatulele",
            "PHG": "Port Harcourt",
            "ABF": "Abaiang",
            "BEZ": "Beru",
            "FUN": "Funafuti",
            "KUC": "Kuria",
            "MNK": "Maiana",
            "MZK": "Marakei",
            "MTK": "Makin Island",
            "NIG": "Nikunau",
            "OOT": "Onotoa",
            "TRW": "Tarawa",
            "AEA": "Abemama",
            "TMN": "Tamana Island",
            "NON": "Nonouti",
            "AIS": "Arorae Island",
            "TSU": "Tabiteuea South",
            "BBG": "Butaritari",
            "AAK": "Buariki",
            "NIK": "Niokolo-Koba National Park",
            "NIN": "Ninilchik",
            "IUE": "Alofi",
            "NJJ": "Heihe",
            "NKD": "Sinak",
            "NLH": "Ninglang",
            "FUT": "Futuna Island",
            "WLS": "Wallis Island",
            "HBB": "Hobbs",
            "NND": "Nangade",
            "NOM": "Nomad River",
            "NOO": "Naoro Vilage",
            "PHH": "Pokhara",
            "NPG": "Nipa",
            "NRY": "Newry",
            "OFU": "Ofu",
            "AAU": "Asau",
            "APW": "Apia",
            "FGI": "Apia",
            "FTI": "Fitiuta Village",
            "MXS": "Maota",
            "PPG": "Pago Pago",
            "PPT": "Papeete",
            "RMT": "Rimatara Island",
            "AAA": "Anaa",
            "FGU": "Fangatau",
            "TIH": "Tuherahera",
            "APK": "Apataki",
            "REA": "Reao",
            "HHZ": "Hikueru",
            "KKR": "Raitahiti",
            "MKP": "Makemo",
            "NAU": "Napuka Island",
            "TKV": "Tatakoto",
            "PUK": "Pukaruha",
            "NUK": "Nukutavake",
            "ZTA": "Tureia",
            "AHE": "Ahe Atoll",
            "KHZ": "Kauehi",
            "FAC": "Faaite",
            "FHZ": "Fakahina",
            "TJN": "Takume",
            "NIU": "Naiu Atoll",
            "RRR": "Raroia",
            "KXU": "Katiu",
            "NKP": "Nukutepipi",
            "NHV": "Nuku Hiva",
            "AUQ": "Hiva Oa Island",
            "UAP": "Ua Pou",
            "UAH": "Ua Huka",
            "BOB": "Motu Mute",
            "TTI": "Tetiaroa",
            "HUH": "Fare",
            "MOZ": "Moorea-Maiao",
            "HOI": "Otepa",
            "RFP": "Uturoa",
            "TPX": "Tupai Atoll",
            "UOA": "Moruroa Atoll",
            "VHZ": "Vahitahi",
            "NUF": "Hatton",
            "UCC": "Mercury",
            "MTV": "Ablow",
            "SLH": "Sola",
            "TOH": "Loh/Linua",
            "EAE": "Emae Island",
            "CCV": "Craig Cove",
            "LOD": "Longana",
            "SSR": "Pentecost Island",
            "PBJ": "Paama Island",
            "LPM": "Lamap",
            "LNB": "Lamen Bay",
            "MWF": "Maewo Island",
            "LNE": "Lonorore",
            "NUS": "Norsup",
            "ZGU": "Gaua Island",
            "RCL": "Redcliffe",
            "SON": "Luganville",
            "TGH": "Tongoa Island",
            "ULB": "Ambrym Island",
            "VLS": "Epi Island",
            "WLH": "Walaha",
            "SWJ": "Malekula Island",
            "OLJ": "Olpoi",
            "AUY": "Anatom Island",
            "AWD": "Aniwa",
            "DLY": "Dillon's Bay",
            "FTA": "Futuna Island",
            "IPA": "Ipota",
            "VLI": "Port Vila",
            "TAH": "Tanna Island",
            "NWT": "Nowata",
            "TGJ": "Tiga",
            "BMY": "Waala",
            "KNQ": "Koné",
            "ILP": "Île des Pins",
            "KOC": "Koumac",
            "LIF": "Lifou",
            "GEA": "Nouméa",
            "PUV": "Malabou",
            "PDC": "Népoui",
            "MEE": "Maré",
            "TOU": "Touho",
            "UVE": "Ouvéa",
            "NOU": "Nouméa (La Tontouta)",
            "FGL": "Fox Glacier",
            "AKL": "Auckland",
            "TUO": "Taupo",
            "AMZ": "Manurewa",
            "ASG": "Ashburton",
            "CHC": "Christchurch",
            "CHT": "Te One",
            "CMV": "Coromandel",
            "DGR": "Dargaville",
            "DUD": "Dunedin",
            "GBZ": "Claris",
            "GIS": "Gisborne",
            "GTN": "Glentanner Station",
            "HLZ": "Hamilton",
            "WIK": "Waiheke Island",
            "KKE": "Kerikeri",
            "KKO": "Kaikohe",
            "KAT": "Awanui",
            "ALR": "Alexandra",
            "MHB": "Auckland City",
            "MRO": "Masterton",
            "NPL": "New Plymouth",
            "NPE": "Napier",
            "NSN": "Nelson",
            "IVC": "Invercargill",
            "PMR": "Palmerston North",
            "PCN": "Koromiko",
            "ZQN": "Queenstown",
            "RAG": "Raglan",
            "SZS": "Oban",
            "ROT": "Rotorua",
            "TRG": "Tauranga",
            "TKZ": "Tokoroa",
            "THH": "Taharoa",
            "TWZ": "Twitzel",
            "BHE": "Blenheim",
            "WKA": "Wanaka",
            "WLG": "Wellington",
            "WIR": "Wairoa",
            "WRE": "Whangarei",
            "WSZ": "Westport",
            "WTZ": "Whitianga",
            "WAG": "Wanganui",
            "NLN": "Kneeland",
            "BZF": "Redding",
            "BIN": "Bamyan",
            "BST": "Lashkar Gah",
            "CCN": "Chaghcharan",
            "SBF": "Sardeh Band",
            "DWR": "Reg",
            "DAZ": "Darwaz",
            "FAH": "Farah",
            "FBD": "Fayzabad",
            "GZI": "Ghazni",
            "GRG": "Gardez",
            "KWH": "Khwahan",
            "HEA": "Guzara",
            "OAI": "Bagram",
            "JAA": "Jalalabad",
            "KBL": "Kabul",
            "KDH": "Khvoshab",
            "KHT": "Khost",
            "MMZ": "Maymana",
            "MZR": "Mazar-i-Sharif",
            "URN": "Urgun",
            "LQN": "Qala-i-Naw",
            "URZ": "Orūzgān",
            "KUR": "Skazar",
            "OAS": "Sharana",
            "OAH": "Shindand",
            "OAA": "Baraki Barak",
            "OLR": "Khost",
            "SGA": "Shiveh",
            "TII": "Tarinkot",
            "TQN": "Taleqan",
            "UND": "Kunduz",
            "OAZ": "Lashkar Gah",
            "ZAJ": "Zaranj",
            "BAH": "Manama",
            "OCS": "Corisco Island",
            "AHB": "Abha",
            "HOF": "Hofuf",
            "ULH": "Al Ula",
            "ABT": "Al-Baha",
            "BHH": "Bisha",
            "DMM": "Ad Dammam",
            "DWD": "Dawadmi",
            "DHA": "Dhahran",
            "GIZ": "Jizan",
            "ELQ": "Buraidah",
            "URY": "Gurayat",
            "HAS": "Ha'il",
            "QJB": "Jubail",
            "JED": "Jeddah",
            "KMC": "King Khaled Military City",
            "KMX": "Khamis Mushait",
            "MED": "Medina",
            "EAM": "Najran",
            "NUM": "Sharma",
            "AQI": "Qaisumah",
            "AKH": "Al Kharj",
            "RAH": "Rafha",
            "RUH": "Riyadh",
            "RAE": "Arar",
            "SHW": "Sharurah",
            "AJF": "Al-Jawf",
            "SLF": "As-Sulayyil",
            "TUU": "Tabuk",
            "TIF": "Ta’if",
            "TUI": "Turaif",
            "WAE": "Wadi Al Dawasir",
            "EJH": "Al Wajh",
            "YNB": "Yanbu",
            "ZUL": "Zilfi",
            "OGM": "Ustupu",
            "IAQ": "Imam Hassan",
            "ABD": "Abadan",
            "DEF": "Dezful",
            "AKW": "Aghajari",
            "GCH": "Gachsaran",
            "QMJ": "Masjed Soleyman",
            "OMI": "Omidiyeh",
            "MRX": "Mahshahr",
            "AWZ": "Ahvaz",
            "AEU": "Abu Musa",
            "BUZ": "Bushehr",
            "KNR": "Jam",
            "KIH": "Kish Island",
            "BDH": "Bandar Lengeh",
            "PGU": "Khiyaroo",
            "KHK": "Khark",
            "SXI": "Siri",
            "LVP": "Lavan Airport",
            "KSH": "Kermanshah",
            "IIL": "Ilam",
            "IFH": "Hesa",
            "KKS": "Kashan",
            "IFN": "Isfahan",
            "CQD": "Shahrekord",
            "RAS": "Rasht",
            "HDM": "Hamadan",
            "AJK": "Araak",
            "NUJ": "Amirabad",
            "IKA": "Tehran",
            "THR": "Tehran",
            "GZW": "Qazvin",
            "PYK": "Karaj",
            "SNX": "Semnan",
            "BND": "Bandar Abbas",
            "JYR": "Jiroft",
            "KER": "Kerman",
            "BXR": "Bam",
            "HDR": "Bandar Abbas",
            "GSM": "Dayrestan",
            "RJN": "Rafsanjan",
            "SYJ": "Sirjan",
            "XBJ": "Birjand",
            "CKT": "Sarakhs",
            "RUD": "Shahrud",
            "MHD": "Mashhad",
            "BJB": "Bojnord",
            "AFZ": "Sabzevar",
            "TCX": "Tabas",
            "KLM": "Kalaleh",
            "GBT": "Gorgan",
            "BSM": "Amol",
            "NSH": "Nowshahr",
            "RZR": "Ramsar",
            "SRY": "Sari",
            "FAZ": "Fasa",
            "JAR": "Jahrom",
            "LRR": "Lar",
            "LFM": "Lamerd",
            "SYZ": "Shiraz",
            "YES": "Yasuj",
            "KHA": "Khaneh",
            "KHY": "Khoy",
            "ADU": "Ardabil",
            "ACP": "Maragheh",
            "PFQ": "Parsabad",
            "OMH": "Urmia",
            "TBZ": "Tabriz",
            "IMQ": "Showt",
            "JWN": "Zanjan",
            "AZD": "Yazd",
            "ACZ": "Zabol",
            "ZBR": "Konarak",
            "ZAH": "Zahedan",
            "IHR": "Iranshahr",
            "JSK": "Bandar-e-Jask",
            "AMM": "Amman",
            "ADJ": "Amman",
            "AQJ": "Aqaba",
            "OMF": "Mafraq",
            "XIJ": "Ahmed Al Jaber AB",
            "KWI": "Kuwait City",
            "BEY": "Beirut",
            "OLH": "Old Harbor",
            "KYE": "Tripoli",
            "BYB": "Dibba al Baya",
            "AOM": "Adam",
            "DQM": "Duqm",
            "MNH": "Al Masna'ah",
            "AUH": "Abu Dhabi",
            "AZI": "Abu Dhabi",
            "AAN": "Al Ain",
            "XSB": "Sir Bani Yas",
            "DXB": "Dubai",
            "ZDY": "Delma Island",
            "NHD": "Dubai",
            "DWC": "Jebel Ali",
            "FJR": "Fujairah",
            "RKT": "Ras Al Khaimah",
            "SHJ": "Sharjah",
            "OMY": "Tbeng Meanchey",
            "RMB": "Buraimi",
            "FAU": "Fahud",
            "RNM": "Ghaba",
            "JNJ": "Duqm",
            "KHS": "Khasab",
            "LKW": "Lekhwair",
            "MSH": "Masirah",
            "MCT": "Muscat",
            "OMM": "Marmul",
            "SLL": "Salalah",
            "OHS": "Sohar",
            "TTH": "Thumrait",
            "DDU": "Dadu",
            "BHW": "Bhagatanwala",
            "BNP": "Bannu",
            "WGB": "Bahawalnagar",
            "BHV": "Bahawalpur",
            "CJL": "Chitral",
            "CHB": "Chilas",
            "DBA": "Dalbandin",
            "DEA": "Dera Ghazi Khan",
            "DSK": "Dera Ismael Khan",
            "LYP": "Faisalabad",
            "GWD": "Gurandani",
            "GIL": "Gilgit",
            "ISB": "Attock",
            "JAG": "Jacobabad",
            "KHI": "Karachi",
            "HDD": "Hyderabad",
            "KDD": "Khuzdar",
            "OHT": "Kohat",
            "LHE": "Lahore",
            "LRG": "Loralai",
            "XJM": "Mangla",
            "MFG": "Muzaffarabad",
            "MWD": "Mianwali",
            "MJD": "Moenjodaro",
            "MPD": "Sindhri",
            "ATG": "Kamra",
            "MUX": "Multan",
            "WNS": "Nawabashah",
            "ORW": "Ormara Raik",
            "PAJ": "Parachinar",
            "PJG": "Panjgur",
            "PSI": "Pasni",
            "PEW": "Peshawar",
            "UET": "Quetta",
            "RYK": "Rahim Yar Khan",
            "RAZ": "Rawalakot",
            "SBQ": "Sibi",
            "KDU": "Skardu",
            "SKZ": "Mirpur Khas",
            "SYW": "Sehwan Sharif",
            "SGI": "Sargodha",
            "SDT": "Saidu Sharif",
            "SKT": "Sialkot",
            "SUL": "Sui",
            "RZS": "Sawan Gas Field",
            "TLB": "Tarbela",
            "BDN": "Badin",
            "TFT": "Taftan",
            "TUK": "Turbat",
            "WAF": "Waana",
            "PZH": "Fort Sandeman",
            "IQA": "Hīt",
            "TQD": "Al Habbaniyah",
            "BMN": "Bamarni",
            "BGW": "Baghdad",
            "OSM": "Mosul",
            "EBL": "Arbil",
            "ORI": "Port Lions",
            "KIK": "Kirkuk",
            "BSR": "Basra",
            "NJF": "Najaf",
            "RQW": "Qayyarah",
            "ISU": "Sulaymaniyah",
            "XNH": "Nasiriyah",
            "ALP": "Aleppo",
            "DAM": "Damascus",
            "DEZ": "Deir ez-Zor",
            "KAC": "Qamishly",
            "LTK": "Latakia",
            "PMS": "Tadmur",
            "DIA": "Doha",
            "XJD": "Ar Rayyan",
            "DOH": "Doha",
            "OTT": "Cotriguaçu",
            "OUM": "Oum Hadjer",
            "OXO": "Orientos",
            "ADE": "Aden",
            "EAB": "Abs",
            "AXK": "Ataq",
            "BYD": "Al-Bayda",
            "BHN": "Beihan",
            "BUK": "Al-Bough",
            "AAY": "Al Ghaydah",
            "KAM": "Kamaran",
            "MYN": "Marib",
            "UKR": "Mukayras",
            "IHN": "Qishn",
            "RIY": "Riyan",
            "SYE": "Sa'dah",
            "SAH": "Sanaa",
            "SCT": "Mori",
            "GXF": "Seiyun",
            "TAI": "Ta'izz",
            "ACU": "Mamitupu",
            "AIL": "Isla Lorenzo Bello",
            "CTE": "Cartí Islands",
            "MPP": "Mulatupo",
            "PYC": "Ukupseni",
            "NMG": "Isla del Rey",
            "TUW": "Coetupo",
            "PYV": "Yaviza",
            "AML": "Puerto Armuelles",
            "BFQ": "Puerto Piña",
            "ELE": "El Real de Santa María",
            "OTD": "Contadora Island",
            "SAX": "Boca de Sábalo",
            "AKB": "Atka",
            "PML": "Cold Bay",
            "PTD": "Port Alexander",
            "PAQ": "Palmer",
            "ATU": "Attu",
            "BTI": "Barter Island",
            "BET": "Bethel",
            "BVU": "Beluga",
            "BIG": "Delta Junction Ft Greely",
            "BKC": "Buckland",
            "BMX": "Big Mountain",
            "BRW": "Utqiaġvik",
            "BTT": "Bettles",
            "CDB": "Cold Bay",
            "CEM": "Central",
            "CIK": "Chalkyitsik",
            "CYF": "Chefornak",
            "SCM": "Scammon Bay",
            "IRC": "Circle",
            "WSF": "Cape Sarichef",
            "CDV": "Cordova",
            "CXF": "Coldfoot",
            "CYT": "Yakataga",
            "CZF": "Cape Romanzof",
            "DRG": "Deering",
            "RDB": "Red Dog",
            "ADK": "Adak",
            "DLG": "Dillingham",
            "MLL": "Marshall",
            "ADQ": "Kodiak",
            "DUT": "Unalaska",
            "KKH": "Kongiganak",
            "EDF": "Anchorage",
            "EEK": "Eek",
            "EAA": "Eagle",
            "EHM": "Cape Newenham",
            "EIL": "Fairbanks",
            "ELV": "Elfin Cove",
            "EMK": "Emmonak",
            "ENA": "Kenai",
            "WWT": "Mertarvik",
            "FAI": "Fairbanks",
            "FBK": "Fairbanks",
            "ABL": "Ambler",
            "FRN": "Fort Richardson",
            "NIB": "Nikolai",
            "GAL": "Galena",
            "GBH": "Galbraith Lake",
            "KWK": "Kwigillingok",
            "SHG": "Shungnak",
            "GKN": "Gulkana",
            "GLV": "Golovin",
            "GAM": "Gambell",
            "AGN": "Angoon",
            "BGQ": "Big Lake",
            "GST": "Gustavus",
            "NME": "Nightmute",
            "SGY": "Skagway",
            "GMT": "Granite Mountain",
            "HCR": "Holy Cross",
            "HSL": "Huslia",
            "HNS": "Haines",
            "HOM": "Homer",
            "HPB": "Hooper Bay",
            "HUS": "Hughes",
            "SHX": "Shageluk",
            "HYG": "Hydaburg",
            "IGG": "Igiugig",
            "EGX": "Egegik",
            "IAN": "Kiana",
            "ILI": "Iliamna",
            "UTO": "Utopia Creek",
            "MCL": "Denali Park",
            "WAA": "Wales",
            "KCG": "Chignik",
            "JNU": "Juneau",
            "KGK": "Koliganek",
            "KDK": "Kodiak",
            "KFP": "False Pass",
            "AKK": "Akhiok",
            "KPN": "Kipnuk",
            "KKA": "Koyuk",
            "LKK": "Kulik Lake",
            "AKN": "King Salmon",
            "IKO": "Nikolski",
            "AKP": "Anaktuvuk Pass",
            "KTN": "Ketchikan",
            "UUK": "Kuparuk",
            "KAL": "Kaltag",
            "KLW": "Klawock",
            "KYK": "Karluk",
            "KLN": "Larsen Bay",
            "KLG": "Kalskag",
            "PTA": "Port Alsworth",
            "LNI": "Point Lonely",
            "WCR": "Chandalar Lake",
            "LUR": "Cape Lisburne",
            "KMO": "Manokotak",
            "MCG": "McGrath",
            "MDO": "Middleton Island",
            "LMA": "Minchumina",
            "SMK": "St Michael",
            "MLY": "Manley Hot Springs",
            "MTM": "Metlakatla",
            "MOU": "Mountain Village",
            "MRI": "Anchorage",
            "MXY": "Mccarthy",
            "MYU": "Mekoryuk",
            "WNA": "Napakiak",
            "ANC": "Anchorage",
            "ANI": "Aniak",
            "ENN": "Nenana",
            "NNL": "Nondalton",
            "FNR": "Funter Bay",
            "ANN": "Metlakatla",
            "NUL": "Nulato",
            "ANV": "Anvik",
            "KNW": "New Stuyahok",
            "OBU": "Kobuk",
            "PCA": "Portage Creek",
            "HNH": "Hoonah",
            "OME": "Nome",
            "OOK": "Toksook Bay",
            "ORT": "Northway",
            "OTZ": "Kotzebue",
            "NLG": "Nelson Lagoon",
            "STG": "St George",
            "KPC": "Port Clarence",
            "KPV": "Perryville",
            "PSG": "Petersburg",
            "PTH": "Port Heiden",
            "PKA": "Napaskiak",
            "PTU": "Platinum",
            "PIP": "Pilot Point",
            "PHO": "Point Hope",
            "PPC": "Prospect Creek",
            "KWN": "Quinhagak",
            "NUI": "Nuiqsut",
            "ARC": "Arctic Village",
            "RSH": "Russian Mission",
            "RBY": "Ruby",
            "SVA": "Savoonga",
            "SCC": "Deadhorse",
            "SDP": "Sand Point",
            "SHH": "Shishmaref",
            "SIT": "Sitka",
            "WLK": "Selawik",
            "SLQ": "Sleetmute",
            "KSM": "St Mary's",
            "SNP": "St Paul Island",
            "SOV": "Seldovia",
            "SMU": "Sheep Mountain",
            "UMM": "Cantwell",
            "SVW": "Sparrevohn",
            "SKW": "Skwentna",
            "SXQ": "Soldotna",
            "SYA": "Shemya",
            "TAL": "Tanana",
            "TNC": "Tin City",
            "TLA": "Teller",
            "TOG": "Togiak Village",
            "TKA": "Talkeetna",
            "TLJ": "Takotna",
            "ATK": "Atqasuk",
            "AUK": "Alakanuk",
            "UMT": "Umiat",
            "UNK": "Unalakleet",
            "WOW": "Willow",
            "KQA": "Akutan",
            "VAK": "Chevak",
            "KVC": "King Cove",
            "VDZ": "Valdez",
            "VEE": "Venetie",
            "KVL": "Kivalina",
            "WBQ": "Beaver",
            "SWD": "Seward",
            "WRG": "Wrangell",
            "AIN": "Wainwright",
            "WMO": "White Mountain",
            "WTK": "Noatak",
            "WWA": "Wasilla",
            "YAK": "Yakutat",
            "CIS": "Abariringa",
            "PCQ": "Phongsaly",
            "PDR": "Presidente Dutra",
            "PTL": "Máncora",
            "BLP": "Bellavista",
            "PEB": "Pebane",
            "PEC": "Pelican",
            "AKI": "Akiak",
            "AET": "Allakaket",
            "NCN": "Chenega",
            "CLP": "Clarks Point",
            "ELI": "Elim",
            "KUK": "Kasigluk",
            "KNK": "Kokhanok",
            "KOT": "Kotlik",
            "KTS": "Brevig Mission",
            "KYU": "Koyukuk",
            "KWT": "Kwethluk",
            "ORV": "Noorvik",
            "SKK": "Shaktoolik",
            "TKJ": "Tok",
            "WSN": "South Naknek",
            "FYU": "Fort Yukon",
            "CPN": "Cape Rodney",
            "ESA": "Esa'ala",
            "MZN": "Minj",
            "SMP": "Stockholm",
            "BRH": "Brahman Mission",
            "TAJ": "Aitape",
            "IHU": "Ihu",
            "JAQ": "Jacquinot Bay",
            "KUY": "Kamusi",
            "LMY": "Lake Murray",
            "ULE": "Sule",
            "PGM": "Port Graham",
            "ROP": "Rota Island",
            "SPN": "I Fadang, Saipan",
            "UAM": "Yigo",
            "GUM": "Hagåtña",
            "TIQ": "Tinian Island",
            "TGB": "Rizal",
            "BKH": "Kekaha",
            "HDH": "Mokuleia",
            "HHI": "Wahiawa",
            "HNM": "Hana",
            "HIK": "Honolulu",
            "JHM": "Lahaina",
            "JRF": "Kapolei",
            "KOA": "Kailua-Kona",
            "LIH": "Lihue",
            "LUP": "Kalaupapa",
            "MKK": "Kaunakakai",
            "MUE": "Waimea (Kamuela)",
            "NGF": "Kaneohe",
            "HNL": "Honolulu, Oahu",
            "LNY": "Lanai City",
            "OGG": "Kahului",
            "PAK": "Hanapepe",
            "BSF": "Waimea (Kamuela)",
            "ITO": "Hilo",
            "UPP": "Hawi",
            "BHC": "Bhurban",
            "CWP": "Campbellpore",
            "GRT": "Gujrat",
            "KCF": "Kadanwari",
            "REQ": "Chagai",
            "ENT": "Eniwetok Atoll",
            "MAJ": "Majuro Atoll",
            "KWA": "Kwajalein",
            "CXI": "Kiritimati",
            "TNV": "Tabuaeran Island",
            "TNQ": "Teraina",
            "MDY": "Sand Island",
            "PIZ": "Point Lay",
            "PPX": "Nepesi",
            "PQD": "Batticaloa",
            "HUC": "Humacao",
            "XSO": "Siocon",
            "TKK": "Weno Island",
            "PNI": "Pohnpei Island",
            "ROR": "Babelthuap Island",
            "KSA": "Okat",
            "YAP": "Yap Island",
            "PUA": "Puas Mission",
            "AWK": "Wake Island",
            "PWR": "Port Walter",
            "PBT": "Puerto Leda",
            "PCJ": "Puerto La Victoria",
            "PYL": "Perry Island",
            "KIO": "Kili Island",
            "QFX": "Igaliku",
            "QJP": "Pocheon",
            "RAA": "Rakanda",
            "RAW": "Arawa",
            "KNH": "Shang-I",
            "CMJ": "Qimei",
            "LZN": "Matsu (Nangan)",
            "TTT": "Taitung City",
            "GNI": "Lüdao",
            "KHH": "Kaohsiung (Xiaogang)",
            "CYI": "Shuishang",
            "HCN": "Hengchun",
            "DSX": "Kaohsiung (Cijin - Pratas Island)",
            "KYD": "Orchid Island",
            "RMQ": "Taichung (Qingshui)",
            "MFK": "Matsu (Beigan)",
            "TNN": "Tainan (Rende)",
            "HSZ": "Hsinchu City",
            "MZG": "Huxi",
            "PIF": "Pingtung",
            "TSA": "Taipei (Songshan)",
            "TPE": "Taoyuan",
            "WOT": "Wang'an",
            "HUN": "Hualien City",
            "RDV": "Red Devil",
            "RHT": "Badanjilin",
            "NRT": "Narita",
            "MMJ": "Matsumoto",
            "IBR": "Omitama",
            "MUS": "Ogasawara",
            "IWO": "Ogasawara",
            "KIX": "Osaka",
            "SHM": "Shirahama",
            "UKB": "Kobe",
            "HIW": "Hiroshima",
            "TJH": "Toyooka",
            "OBO": "Obihiro",
            "CTS": "Sapporo",
            "HKD": "Hakodate",
            "KUH": "Kushiro",
            "MMB": "Ōzora",
            "SHB": "Nakashibetsu",
            "OKD": "Sapporo",
            "RBJ": "Rebun",
            "WKJ": "Wakkanai",
            "AXJ": "Amakusa",
            "IKI": "Iki",
            "UBJ": "Ube",
            "TSJ": "Tsushima",
            "OMJ": "Nagasaki",
            "MBE": "Monbetsu",
            "AKJ": "Higashikagura",
            "OIR": "Okushiri Island",
            "RIS": "Rishiri",
            "KUM": "Yakushima",
            "FUJ": "Goto",
            "FUK": "Fukuoka",
            "TNE": "Tanegashima",
            "KOJ": "Kagoshima",
            "KMI": "Miyazaki",
            "OIT": "Oita",
            "KKJ": "Kitakyushu",
            "HSG": "Saga",
            "KMJ": "Kumamoto",
            "NGS": "Nagasaki",
            "NGO": "Tokoname",
            "ASJ": "Amami",
            "OKE": "Wadomari",
            "KKX": "Kikai",
            "TKN": "Amagi",
            "NKM": "Nagoya",
            "FKJ": "Fukui",
            "QGU": "Gifu",
            "KMQ": "Kanazawa",
            "OKI": "Okinoshima",
            "FSZ": "Makinohara / Shimada",
            "TOY": "Toyama",
            "NTQ": "Wajima",
            "HIJ": "Hiroshima",
            "OKJ": "Okayama",
            "IZO": "Izumo",
            "YGJ": "Yonago",
            "IWK": "Iwakuni",
            "KCZ": "Nankoku",
            "MYJ": "Matsuyama",
            "ITM": "Osaka",
            "TTJ": "Tottori",
            "TKS": "Tokushima",
            "TAK": "Takamatsu",
            "IWJ": "Masuda",
            "AOJ": "Aomori",
            "GAJ": "Higashine",
            "SDS": "Sado",
            "FKS": "Sukagawa",
            "HHE": "Hachinohe",
            "HNA": "Hanamaki",
            "AXT": "Akita",
            "MSJ": "Misawa",
            "KIJ": "Niigata",
            "ONJ": "Kitaakita",
            "SDJ": "Natori",
            "SYO": "Shonai",
            "NJA": "Ayase / Yamato",
            "HAC": "Hachijojima",
            "OIM": "Izu Oshima",
            "MYE": "Miyakejima",
            "HND": "Tokyo",
            "OKO": "Fussa",
            "MWX": "Muan (Piseo-ri)",
            "KWJ": "Gwangju",
            "KUV": "Gunsan",
            "CHN": "Jeonju",
            "RSU": "Yeosu",
            "KAG": "Gangneung",
            "WJU": "Wonju",
            "YNY": "Gonghang-ro",
            "CJU": "Jeju City",
            "JDG": "Jeju Island",
            "CHF": "Jinhae",
            "PUS": "Busan",
            "HIN": "Sacheon",
            "USN": "Ulsan",
            "ICN": "Seoul",
            "SSN": "Seongnam",
            "OSN": "Pyeongtaek",
            "GMP": "Seoul",
            "SWU": "Suwon",
            "QDY": "Taean",
            "KPO": "Pohang",
            "JWO": "Gimseang-ro",
            "UJN": "Bongsan-ri, Uljin",
            "TAE": "Daegu",
            "HMY": "Seosan",
            "CJJ": "Cheongju",
            "YEC": "Yecheon-ri",
            "RKY": "Rokeby",
            "RLP": "Rosella Plains",
            "RMP": "Rampart",
            "OKA": "Naha",
            "DNA": "Okinawa",
            "ISG": "Ishigaki",
            "UEO": "Kumejima",
            "KJP": "Zamami",
            "MMD": "Minamidaito",
            "MMY": "Miyakojima",
            "AGJ": "Aguni",
            "IEJ": "Ie",
            "HTR": "Taketomi",
            "KTD": "Kitadaitōjima",
            "SHI": "Miyakojima",
            "TRA": "Tarama",
            "RNJ": "Yoron",
            "OGN": "Yonaguni",
            "ENI": "El Nido",
            "SFS": "Olongapo",
            "CRK": "Mabalacat",
            "BSI": "Balesin",
            "LLC": "Lal-lo",
            "LAO": "Laoag City",
            "DRP": "Legazpi",
            "MNL": "Manila (Pasay)",
            "CYU": "Cuyo",
            "SGL": "Cavite",
            "LBX": "Lubang",
            "AAV": "Surallah",
            "CBO": "Datu Odin Sinsuat",
            "DVO": "Davao",
            "BXU": "Butuan",
            "BPH": "Bislig",
            "DPL": "Dipolog",
            "CGM": "Mambajao",
            "IGN": "Balo-i",
            "JOL": "Jolo",
            "MLP": "Malabang",
            "TWT": "Bongao",
            "OZC": "Ozamiz",
            "PAG": "Pagadian",
            "MXI": "Mati",
            "GES": "General Santos",
            "SUG": "Surigao City",
            "CDY": "Mapun",
            "IPE": "Ipil",
            "TDG": "Tandag",
            "CGY": "Laguindingan",
            "ZAM": "Zamboanga",
            "IAO": "Del Carmen",
            "RZP": "Taytay",
            "TAG": "Panglao",
            "SWL": "San Vicente",
            "BAG": "Baguio",
            "DTE": "Daet",
            "SJI": "San Jose",
            "MBO": "Mamburao",
            "WNP": "Naga",
            "BSO": "Basco",
            "BQA": "Baler",
            "SFE": "San Fernando",
            "TUG": "Tuguegarao City",
            "VRC": "Virac",
            "MRQ": "Gasan",
            "CYZ": "Cauayan City",
            "RPV": "Roper Valley",
            "TAC": "Tacloban City",
            "BCD": "Bacolod City",
            "CYP": "Calbayog City",
            "DGT": "Dumaguete City",
            "MPH": "Caticlan",
            "CRM": "Catarman",
            "ILO": "Cabatuan",
            "MBT": "Masbate",
            "KLO": "Kalibo",
            "CEB": "Lapu-Lapu City",
            "OMC": "Ormoc City",
            "PPS": "Puerto Princesa",
            "RXS": "Roxas City",
            "EUQ": "San Jose",
            "TBH": "Tablas Island",
            "USU": "Coron",
            "BPA": "Borongan City",
            "RRM": "Marromeu",
            "RSE": "Sydney",
            "RSI": "Hanak",
            "TKM": "Taksimo",
            "NOI": "Krymsk",
            "MJY": "Motygino",
            "UHS": "Aleksandrovsk-Sakhalinskiy",
            "KVK": "Apatity",
            "TYA": "Tula",
            "LNX": "Smolensk",
            "EIK": "Yeysk",
            "RUU": "Kawbenaberi",
            "RVC": "River Cess",
            "LPS": "Lopez",
            "KEH": "Kenmore",
            "MJR": "Miramar",
            "COC": "Concordia",
            "GHU": "Gualeguaychu",
            "PRA": "Parana",
            "ROS": "Rosario",
            "SFN": "Santa Fe",
            "AEP": "Buenos Aires",
            "LCM": "La Cumbre",
            "COR": "Cordoba",
            "LPG": "La Plata",
            "EPA": "El Palomar",
            "EZE": "Buenos Aires (Ezeiza)",
            "RAF": "Rafaela",
            "NCJ": "Sunchales",
            "HOS": "Chos Malal",
            "CVH": "Lafontaine",
            "GNR": "General Roca",
            "RDS": "Rincon de los Sauces",
            "APZ": "Zapala",
            "SAM": "Salamo",
            "MDZ": "Mendoza",
            "LGS": "Malargue",
            "AFA": "San Rafael",
            "CTC": "Catamarca",
            "SDE": "Santiago del Estero",
            "IRJ": "La Rioja",
            "RHD": "Termas de Río Hondo",
            "TUC": "San Miguel de Tucumán",
            "UAQ": "San Juan",
            "CRR": "Ceres",
            "RCU": "Rio Cuarto",
            "VDR": "Villa Dolores",
            "VME": "Villa Mercedes",
            "RLO": "Merlo",
            "LUQ": "San Luis",
            "CNQ": "Corrientes",
            "RES": "Resistencia",
            "FMA": "Formosa",
            "IGR": "Puerto Iguazu",
            "AOL": "Paso de los Libres",
            "MCS": "Monte Caseros",
            "PSS": "Posadas",
            "PRQ": "Presidencia Roque Sáenz Peña",
            "SLA": "Salta",
            "JUJ": "San Salvador de Jujuy",
            "ORA": "Orán",
            "TTG": "Tartagal",
            "CLX": "Clorinda",
            "ELO": "El Dorado",
            "OYA": "Goya",
            "LLS": "Las Lomitas",
            "MDX": "Mercedes",
            "RCQ": "Reconquista",
            "UZU": "Curuzu Cuatia",
            "EHL": "El Bolsón",
            "CRD": "Comodoro Rivadavia",
            "EMX": "El Maitén",
            "EQS": "Esquel",
            "LHS": "Las Heras",
            "IGB": "Ingeniero Jacobacci",
            "OLN": "Sarmiento",
            "OES": "San Antonio Oeste",
            "MQD": "Maquinchao",
            "ARR": "Alto Rio Senguerr",
            "SGV": "Sierra Grande",
            "REL": "Rawson",
            "VDM": "Viedma / Carmen de Patagones",
            "PMY": "Puerto Madryn",
            "FTE": "El Calafate",
            "PUD": "Puerto Deseado",
            "RGA": "Rio Grande",
            "RGL": "Rio Gallegos",
            "USH": "Ushuaia",
            "ULA": "San Julian",
            "ROY": "Rio Mayo",
            "PMQ": "Perito Moreno",
            "GGS": "Gobernador Gregores",
            "JSM": "Chubut",
            "RYO": "Rio Turbio",
            "RZA": "Puerto Santa Cruz",
            "BHI": "Bahía Blanca",
            "CSZ": "Coronel Suarez",
            "OVR": "Olavarria",
            "GPO": "General Pico",
            "OYO": "Tres Arroyos",
            "SST": "Santa Teresita",
            "MDQ": "Mar del Plata",
            "NQN": "Neuquen",
            "NEC": "Necochea",
            "PEH": "Pehuajó",
            "RSA": "Santa Rosa",
            "BRC": "San Carlos de Bariloche",
            "TDL": "Tandil",
            "VLG": "Villa Gesell",
            "CUT": "Cutral-Co",
            "CPC": "Chapelco/San Martin de los Andes",
            "VIU": "Viru",
            "CDJ": "Conceição do Araguaia",
            "ARX": "Aracati",
            "JTC": "Bauru",
            "AQA": "Araraquara",
            "AJU": "Aracaju",
            "AFL": "Alta Floresta",
            "ARU": "Araçatuba",
            "AAX": "Araxá",
            "BEL": "Belém",
            "BGX": "Bagé",
            "PLU": "Belo Horizonte",
            "BFH": "Curitiba",
            "BJP": "Bragança Paulista",
            "BSB": "Brasília",
            "BAT": "Barretos",
            "BVB": "Boa Vista",
            "BPG": "Barra do Garças",
            "BZC": "Cabo Frio",
            "CAC": "Cascavel",
            "CFB": "Cabo Frio",
            "CFC": "Caçador",
            "CNF": "Belo Horizonte",
            "CGR": "Campo Grande",
            "XAP": "Chapecó",
            "CLN": "Carolina",
            "CKS": "Parauapebas",
            "CCM": "Criciúma",
            "CLV": "Caldas Novas",
            "QNS": "Porto Alegre",
            "CAW": "Campos dos Goytacazes",
            "CMG": "Corumbá",
            "CWB": "Curitiba",
            "CRQ": "Caravelas",
            "CXJ": "Caxias Do Sul",
            "CGB": "Cuiabá",
            "CZS": "Cruzeiro Do Sul",
            "BYO": "Bonito",
            "PPB": "Presidente Prudente",
            "DOU": "Dourados",
            "MAO": "Manaus",
            "JCR": "Jacareacanga",
            "IGU": "Foz do Iguaçu",
            "FLN": "Florianópolis",
            "FEN": "Fernando de Noronha",
            "FOR": "Fortaleza",
            "GIG": "Rio De Janeiro",
            "GJM": "Guajará-Mirim",
            "GYN": "Goiânia",
            "GRU": "São Paulo",
            "GPB": "Guarapuava",
            "GVR": "Governador Valadares",
            "GUJ": "Guaratinguetá",
            "ATM": "Altamira",
            "ITA": "Itacoatiara",
            "ITB": "Itaituba",
            "IOS": "Ilhéus",
            "IPN": "Ipatinga",
            "ITR": "Itumbiara",
            "IMP": "Imperatriz",
            "JJG": "Jaguaruna",
            "QDV": "Jundiaí",
            "JJD": "Cruz",
            "JDF": "Juiz de Fora",
            "JHF": "São Roque",
            "JPR": "Ji-Paraná",
            "JPA": "João Pessoa",
            "RRJ": "Rio De Janeiro",
            "JDO": "Juazeiro do Norte",
            "JOI": "Joinville",
            "CPV": "Campina Grande",
            "VCP": "Campinas",
            "LEC": "Lençóis",
            "LAJ": "Lages",
            "LIP": "Lins",
            "LDB": "Londrina",
            "LAZ": "Bom Jesus da Lapa",
            "MAB": "Marabá",
            "MQH": "Minaçu",
            "MEU": "Almeirim",
            "MEA": "Macaé",
            "MGF": "Maringá",
            "MOC": "Montes Claros",
            "MII": "Marília",
            "PLL": "Manaus",
            "MCZ": "Maceió",
            "MCP": "Macapá",
            "MVF": "Mossoró",
            "RTE": "São Paulo",
            "MNX": "Manicoré",
            "NVT": "Navegantes",
            "GEL": "Santo Ângelo",
            "OYK": "Oiapoque",
            "POA": "Porto Alegre",
            "PHB": "Parnaíba",
            "POO": "Poços De Caldas",
            "PFB": "Passo Fundo",
            "PGZ": "Ponta Grossa",
            "PMW": "Palmas",
            "PET": "Pelotas",
            "PNZ": "Petrolina",
            "PNB": "Porto Nacional",
            "PTO": "Pato Branco",
            "PMG": "Ponta Porã",
            "BPS": "Porto Seguro",
            "PVH": "Porto Velho",
            "RBR": "Rio Branco",
            "ROO": "Rondonópolis",
            "REC": "Recife",
            "SDU": "Rio de Janeiro",
            "RAO": "Ribeirão Preto",
            "BRB": "Barreirinhas",
            "SNZ": "Rio de Janeiro",
            "NAT": "Natal",
            "OPS": "Sinop",
            "SJK": "São José Dos Campos",
            "SLZ": "São Luís",
            "RIA": "Santa Maria",
            "STM": "Santarém",
            "SMT": "Sorriso",
            "CGH": "São Paulo",
            "SJP": "São José do Rio Preto",
            "SSZ": "Guarujá",
            "SSA": "Salvador",
            "TMT": "Oriximiná",
            "UNA": "Una",
            "TOW": "Toledo",
            "THE": "Teresina",
            "TFF": "Tefé",
            "TJL": "Três Lagoas",
            "TRQ": "Tarauacá",
            "TEC": "Telêmaco Borba",
            "TSQ": "Torres",
            "TBT": "Tabatinga",
            "TUR": "Tucuruí",
            "SJL": "São Gabriel da Cachoeira",
            "PAV": "Paulo Afonso",
            "URG": "Uruguaiana",
            "UDI": "Uberlândia",
            "UBA": "Uberaba",
            "RPU": "Urucu",
            "VAG": "Varginha",
            "BVH": "Vilhena",
            "VIX": "Vitória",
            "QPS": "Pirassununga",
            "IZA": "Juiz de Fora",
            "ZUD": "Ancud",
            "LOB": "Los Andes",
            "WAP": "Palena",
            "ARI": "Arica",
            "WPA": "Puerto Aysén",
            "CPO": "Copiapo",
            "BBA": "Balmaceda",
            "TOQ": "Tocopilla",
            "DPB": "Bahia Inutil",
            "CCH": "Chile Chico",
            "CJC": "Calama",
            "YAI": "Chillan",
            "PUQ": "Punta Arenas",
            "COW": "Coquimbo",
            "GXQ": "Coyhaique",
            "IQQ": "Iquique",
            "SCL": "Santiago",
            "ESR": "El Salvador",
            "FRT": "Frutillar",
            "ANF": "Antofagasta",
            "WPR": "Porvenir",
            "FFU": "Futaleufu",
            "UGL": "Union Glacier",
            "LSQ": "Los Angeles",
            "WPU": "Puerto Williams",
            "LGR": "Cochrane",
            "CCP": "Concepcion",
            "IPC": "Isla De Pascua",
            "ZOS": "Osorno",
            "CPP": "Pica",
            "VLR": "Vallenar",
            "ZLR": "Linares",
            "PNT": "Puerto Natales",
            "OVL": "Ovalle",
            "ZPC": "Pucon",
            "MHC": "Dalcahue",
            "PUX": "Puerto Varas",
            "ZCO": "Temuco",
            "CNR": "Chañaral",
            "VAP": "Viña Del Mar",
            "TNM": "Villa Las Estrellas",
            "SMB": "Cerro Sombrero",
            "LSC": "La Serena-Coquimbo",
            "SSD": "San Felipe",
            "WCA": "Castro",
            "PZS": "Temuco",
            "PMC": "Puerto Montt",
            "TLX": "Talca",
            "WCH": "Chaitén",
            "ZIC": "Victoria",
            "TTC": "Taltal",
            "ZAL": "Valdivia",
            "KNA": "Viña del Mar",
            "BVM": "Belmonte",
            "GDR": "Angra dos Reis",
            "OLC": "São Paulo De Olivença",
            "SOD": "Sorocaba",
            "JTN": "Itanhaém",
            "FEC": "Feira de Santana",
            "JLS": "Jales",
            "PBA": "Cairu",
            "JMR": "Maricá",
            "NVM": "Nova Mutum",
            "OUS": "Ourinhos",
            "OIA": "Ourilândia do Norte",
            "REZ": "Resende",
            "QSC": "São Carlos",
            "JPY": "Paraty",
            "UBT": "Ubatuba",
            "ITP": "Itaperuna",
            "VOT": "Votuporanga",
            "JTA": "Tauá",
            "HUV": "Hudiksvall",
            "ATF": "Ambato",
            "OCC": "Coca",
            "CUE": "Cuenca",
            "GPS": "Isla Baltra",
            "GYE": "Guayaquil",
            "IBB": "Puerto Villamil",
            "TNW": "Ahuano",
            "JIP": "Jipijapa",
            "LTX": "Latacunga",
            "MRR": "Macará",
            "XMS": "Macas",
            "MEC": "Manta",
            "LGQ": "Lago Agrio",
            "PYO": "Puerto Putumayo",
            "PVO": "Portoviejo",
            "UIO": "Quito",
            "ETR": "Santa Rosa",
            "SNC": "Salinas",
            "SUQ": "Sucúa",
            "PTZ": "Shell Mera",
            "SCY": "Puerto Baquerizo Moreno",
            "BHA": "Bahía de Caraquez",
            "TSC": "Taisha",
            "TPN": "Tiputini",
            "LOH": "La Toma (Catamayo)",
            "ESM": "Tachina",
            "TPC": "Tarapoa",
            "TUA": "Tulcán",
            "PSY": "Stanley",
            "ASU": "Asunción",
            "AYO": "Ayolas",
            "BFA": "Bahía Negra",
            "CIO": "Concepción",
            "ENO": "Encarnación",
            "AGT": "Ciudad del Este",
            "FLM": "Filadelfia",
            "ESG": "Mariscal Estigarribia",
            "OLK": "Fuerte Olimpo",
            "PIL": "Pilar",
            "PJC": "Pedro Juan Caballero",
            "SIC": "Las Perlas",
            "ITJ": "Itajaí",
            "LVR": "Lucas do Rio Verde",
            "SFV": "Santa Fé do Sul",
            "FRC": "Franca",
            "MUU": "Maraú",
            "JUA": "Juara",
            "SJF": "Cruz Bay",
            "CFO": "Confresa",
            "NPR": "Novo Progresso",
            "AQM": "Ariquemes",
            "JRT": "Juruti",
            "RIG": "Rio Grande",
            "ARS": "Aragarças",
            "ECO": "El Encanto",
            "MIX": "Mirití-Paraná",
            "ARO": "Arboletes",
            "ULS": "Mulatos",
            "SJR": "San Juan De Uraba",
            "NPU": "San Pedro de Urabá",
            "PCC": "Puerto Rico",
            "SQF": "Solano",
            "AYI": "Yari",
            "CUI": "Currillo",
            "MOY": "Monterrey",
            "NUH": "Nunchia",
            "EUO": "Paratebueno",
            "PRE": "Pore",
            "SQE": "San Luis De Palenque",
            "TTM": "Tablón De Tamara",
            "LMX": "Micay",
            "AYC": "Ayacucho",
            "GRA": "Puerto Mosquito",
            "DZI": "Codazzi",
            "SJH": "San Juan Del César",
            "PZR": "Bajo Baudó",
            "UNC": "Unguía",
            "AYA": "Ayapel",
            "SCA": "Santa Catalina",
            "MND": "Medina",
            "NAD": "Macanal",
            "GCA": "Guacamayas",
            "SRO": "Santana Ramos",
            "IVO": "Chivolo",
            "GAA": "Guamal",
            "BAC": "Barranca De Upia",
            "CJD": "Candilejas",
            "CQT": "Caquetania",
            "ELJ": "Ruperto Polania",
            "MSK": "Puerto Gaitán",
            "SOH": "Solita",
            "MQR": "Mosquera",
            "PYN": "Payán",
            "ISD": "Iscuandé",
            "AZT": "Zapatoca",
            "HRR": "Campiña",
            "PLA": "Planadas",
            "SQB": "Piedras",
            "ARF": "Acaricuara",
            "MFB": "Monfort",
            "MHF": "Morichal",
            "VAB": "Yavarate",
            "CSR": "Casuarito",
            "GMC": "Puerto Carreño",
            "ACR": "Araracuara",
            "ACD": "Acandí",
            "HAY": "Aguachica",
            "AFI": "Amalfi",
            "API": "Apiay",
            "AXM": "Armenia",
            "PUU": "Puerto Asís",
            "ARQ": "Arauquita",
            "ELB": "El Banco",
            "BGA": "Bucaramanga",
            "NBB": "Barranco Minas",
            "BOG": "Bogota",
            "BAQ": "Barranquilla",
            "BSC": "Bahía Solano",
            "BUN": "Buenaventura",
            "CPB": "Acandí",
            "CUC": "Cúcuta",
            "COG": "Condoto",
            "CTG": "Cartagena",
            "CCO": "Puerto López",
            "CLO": "Cali",
            "CIM": "Cimitarra",
            "RAV": "Cravo Norte",
            "TCO": "Tumaco",
            "BHF": "Bahía Solano",
            "CUO": "Carurú",
            "CAQ": "Caucasia",
            "CVE": "Coveñas",
            "CZU": "Corozal",
            "EBG": "El Bagre",
            "ECR": "El Charco",
            "EJA": "Barrancabermeja",
            "FLA": "Florencia",
            "FDA": "Fundación",
            "GIR": "Girardot",
            "CRC": "Cartago",
            "GPI": "Guapi",
            "CPL": "Chaparral",
            "HTZ": "Hato Corozal",
            "IBE": "Ibagué",
            "IGO": "Chigorodó",
            "LPE": "La Primavera",
            "IPI": "Ipiales",
            "JUO": "Juradó",
            "APO": "Carepa",
            "LQM": "Puerto Leguízamo",
            "MCJ": "La Mina-Maicao",
            "LPD": "La Pedrera",
            "LET": "Leticia",
            "TBD": "Timbiqui",
            "EOH": "Medellín",
            "MFS": "Miraflores",
            "MGN": "Magangué",
            "MTB": "Montelíbano",
            "MMP": "Santa Cruz de Mompóx",
            "MTR": "Montería",
            "MVP": "Mitú",
            "MZL": "Manizales",
            "LMC": "La Macarena",
            "NCI": "Necocli",
            "NQU": "Nuquí",
            "NVA": "Neiva",
            "OCV": "Ocaña",
            "ORC": "Orocue",
            "OTU": "Remedios",
            "RON": "Paipa",
            "PCR": "Puerto Carreño",
            "PDA": "Puerto Inírida",
            "PEI": "Pereira",
            "PTX": "Pitalito",
            "PLT": "Plato",
            "NAR": "Armenia",
            "PPN": "Popayán",
            "PAL": "La Dorada",
            "PBE": "Puerto Berrio",
            "PSO": "Chachagüí",
            "PVA": "Providencia",
            "PZA": "Paz De Ariporo",
            "MQU": "Mariquita",
            "TCD": "Tarapacá",
            "MDE": "Medellín",
            "RCH": "Riohacha",
            "SNT": "Sabana de Torres",
            "RVE": "Saravena",
            "SJE": "San José Del Guaviare",
            "SSL": "Santa Rosalia",
            "SMR": "Santa Marta",
            "SOX": "Sogamoso",
            "ADZ": "San Andrés",
            "SRS": "San Marcos",
            "SVI": "San Vicente Del Caguán",
            "TAU": "Tauramena",
            "TIB": "Tibú",
            "TDA": "Trinidad",
            "TLU": "Santiago de Tolú",
            "TME": "Tame",
            "TQS": "Tres Esquinas",
            "TRB": "Turbo",
            "URI": "La Uribe",
            "AUC": "Arauca",
            "UIB": "Quibdó",
            "ULQ": "Tuluá",
            "URR": "Urrao",
            "VGZ": "Villa Garzón",
            "PYA": "Puerto Boyacá",
            "VUP": "Valledupar",
            "VVC": "Villavicencio",
            "AYG": "San Vicente Del Caguán",
            "EYP": "Yopal",
            "MHW": "El Bañado",
            "SRE": "Yamparaez",
            "APB": "Apolo",
            "ASC": "Ascensión de Guarayos",
            "BJO": "Bermejo",
            "CAM": "Camiri",
            "CBB": "Cochabamba",
            "CIJ": "Cobija",
            "CEP": "Concepción",
            "SRZ": "Santa Cruz",
            "GYA": "Guayaramerín",
            "CCA": "Chimore",
            "BVK": "Itenes",
            "SJS": "San José de Chiquitos",
            "SJB": "San Joaquín",
            "SJV": "San Javier",
            "LPB": "La Paz / El Alto",
            "MGD": "Magdalena",
            "ORU": "Oruro",
            "POI": "Potosí",
            "PUR": "Puerto Rico/Manuripi",
            "PSZ": "Puerto Suárez",
            "SRD": "San Ramón / Mamoré",
            "RBO": "Roboré",
            "RIB": "Riberalta",
            "RBQ": "Rurrenabaque",
            "REY": "Reyes",
            "SBL": "Santa Ana del Yacuma",
            "SRJ": "San Borja",
            "SNG": "San Ignacio de Velasco",
            "SNM": "San Ignacio de Moxos",
            "SRB": "Santa Rosa",
            "MQK": "San Matías",
            "TJA": "Tarija",
            "TDD": "Trinidad",
            "UYU": "Quijarro",
            "VAH": "Vallegrande",
            "VLM": "Villamontes",
            "VVI": "Santa Cruz",
            "BYC": "Yacuíba",
            "ABN": "Albina",
            "AAJ": "Awaradam",
            "TOT": "Totness",
            "DRJ": "Drietabbetje",
            "LDO": "Aurora",
            "PBM": "Zandery",
            "MOJ": "Moengo",
            "ICK": "Nieuw Nickerie",
            "OEM": "Paloemeu",
            "SMZ": "Stoelmanseiland",
            "KCB": "Kasikasima",
            "AGI": "Wageningen",
            "WSO": "Washabo",
            "ORG": "Paramaribo",
            "JSO": "Sobral",
            "JAW": "Araripina",
            "APQ": "Arapiraca",
            "AMJ": "Almenara",
            "AIF": "Assis",
            "BDC": "Barra do Corda",
            "BRA": "Barreiras",
            "BSS": "Balsas",
            "BQQ": "Barra",
            "MXQ": "Cairu",
            "EEA": "Correia Pinto",
            "QCH": "Colatina",
            "RDC": "Redenção",
            "DTI": "Diamantina",
            "DIQ": "Divinópolis",
            "JPE": "Paragominas",
            "CNV": "Canavieiras",
            "VCC": "Vacaria",
            "SXX": "São Félix do Xingu",
            "GUZ": "Guarapari",
            "GDP": "Guadalupe",
            "GNM": "Guanambi",
            "QGP": "Garanhuns",
            "SET": "Serra Talhada",
            "IRE": "Irecê",
            "QIG": "Iguatu",
            "QIT": "Itapetinga",
            "IPU": "Ipiaú",
            "JCM": "Jacobina",
            "JEQ": "Jequié",
            "JMA": "Manhuaçu",
            "JNA": "Januária",
            "JDR": "São João Del Rei",
            "CDI": "Cachoeiro do Itapemirim",
            "QCP": "Currais Novos",
            "LHN": "Linhares",
            "SSO": "São Lourenço",
            "MTE": "Monte Alegre",
            "MVS": "Mucuri",
            "SBJ": "São Mateus",
            "PTQ": "Porto de Moz",
            "NNU": "Nanuque",
            "PSW": "Passos",
            "FEJ": "Feijó",
            "ORX": "Oriximiná",
            "PCS": "Picos",
            "POJ": "Patos de Minas",
            "PIV": "Pirapora",
            "SNQ": "San Quintín",
            "FLB": "Floriano",
            "CHD": "Mucugê",
            "PDF": "Prado",
            "CAU": "Caruaru",
            "OPP": "Salinópolis",
            "SFK": "Soure",
            "TXF": "Teixeira de Freitas",
            "OBI": "Óbidos",
            "TFL": "Teófilo Otoni",
            "JPO": "Patos",
            "AIY": "Araçuaí",
            "VAL": "Valença",
            "BVS": "Breves",
            "CMC": "Camocim",
            "JCS": "Crateús",
            "GGF": "Almeirim",
            "PHI": "Pinheiro",
            "GMS": "Guimarães",
            "PPY": "Pouso Alegre",
            "PYT": "Paracatu",
            "ITE": "Ituberá",
            "LKR": "Las Khorey",
            "GUO": "Guriel",
            "BXX": "Borama",
            "SOA": "Sóc Trăng",
            "CAY": "Matoury",
            "GSI": "Grand-Santi",
            "MPY": "Maripasoula",
            "OYP": "Saint-Georges-de-l'Oyapock",
            "LDX": "Saint-Laurent-du-Maroni",
            "REI": "Régina",
            "XAU": "Saül",
            "SOR": "T2",
            "ALD": "Fortaleza",
            "AOP": "Andoas",
            "AYX": "Atalaya",
            "MBP": "Moyobamba",
            "IBP": "Iberia",
            "PCL": "Pucallpa",
            "TDP": "Corrientes",
            "CHM": "Chimbote",
            "TGI": "Tingo Maria",
            "CIX": "Chiclayo",
            "AYP": "Ayacucho",
            "ANS": "Andahuaylas",
            "ATA": "Anta",
            "UMI": "Quince Mil",
            "LIM": "Lima",
            "UCZ": "Uchiza",
            "RIJ": "Rioja",
            "JAE": "Jaén",
            "JJI": "Juanjuí",
            "JAU": "Jauja",
            "JUL": "Juliaca",
            "SJA": "San Juan de Marcona",
            "CJA": "Cajamarca",
            "RIM": "Rodriguez de Mendoza",
            "ILQ": "Ilo",
            "TBP": "Tumbes",
            "MZA": "Mazamari",
            "YMS": "Yurimaguas",
            "HUU": "Huánuco",
            "SQU": "Plaza Saposoa",
            "CHH": "Chachapoyas",
            "IQT": "Iquitos",
            "AQP": "Arequipa",
            "TRU": "Trujillo",
            "PIO": "Pisco",
            "TPP": "Tarapoto",
            "SYC": "Shiringayoc",
            "TCQ": "Tacna",
            "PEM": "Puerto Maldonado",
            "PIU": "Piura",
            "TYL": "Talara",
            "NZC": "Nazca",
            "CUZ": "Cusco",
            "EAX": "Kwatta",
            "SRL": "Mulegé",
            "SRM": "Sandringham Station",
            "SRV": "Stony River",
            "CZB": "Cruz Alta",
            "APU": "Apucarana",
            "BGV": "Bento Gonçalves",
            "BNU": "Blumenau",
            "CCI": "Concórdia",
            "CSS": "Cassilândia",
            "CEL": "Canela",
            "CKO": "Cornélio Procópio",
            "GGH": "Cianorte",
            "ERM": "Erechim",
            "FBE": "Francisco Beltrão",
            "GGJ": "Guaíra",
            "HRZ": "Horizontina",
            "IJU": "Ijuí",
            "ITQ": "Itaqui",
            "JCB": "Joaçaba",
            "CBW": "Campo Mourão",
            "QDB": "Cachoeira Do Sul",
            "OAL": "Cacoal",
            "LOI": "Lontras",
            "ALQ": "Alegrete",
            "QGF": "Montenegro",
            "QHV": "Novo Hamburgo",
            "SQX": "São Miguel do Oeste",
            "APX": "Arapongas",
            "VRZ": "Lavras",
            "AIR": "Aripuanã",
            "PNG": "Paranaguá",
            "PVI": "Paranavaí",
            "PBB": "Paranaíba",
            "SQY": "São Lourenço Do Sul",
            "SSS": "Siassi",
            "JBS": "São Borja",
            "CSU": "Santa Cruz do Sul",
            "UMU": "Umuarama",
            "ZFU": "Arujá",
            "UVI": "União da Vitória",
            "VIA": "Videira",
            "BMS": "Brumado",
            "AXE": "Xanxerê",
            "SRA": "Santa Rosa",
            "ATI": "Artigas",
            "BUV": "Bella Union",
            "CYR": "Colonia del Sacramento",
            "DZO": "Durazno",
            "PDP": "Punta del Este",
            "MLZ": "Melo",
            "MVD": "Ciudad de la Costa",
            "PDU": "Paysandú",
            "RVY": "Rivera",
            "STY": "Salto",
            "TAW": "Tacuarembo",
            "TYT": "Treinta y Tres",
            "VCH": "Vichadero",
            "AGV": "Acarigua",
            "AAO": "Anaco",
            "LPJ": "Guayabal",
            "BLA": "Barcelona",
            "BNS": "Barinas",
            "BRM": "Barquisimeto",
            "MYC": "Maracay",
            "CBL": "Ciudad Bolivar",
            "ZRZ": "Zaraza",
            "CUV": "Casigua El Cubo",
            "CLZ": "Guarico",
            "CAJ": "Canaima",
            "CUP": "Carúpano",
            "CZE": "Coro",
            "PPZ": "Puerto Paez",
            "EOR": "Bolivar",
            "GDO": "Guasdualito",
            "GUQ": "Guanare",
            "HGE": "Higuerote",
            "ICC": "Isla de Coche",
            "LSP": "Paraguaná",
            "KAV": "Kavanayén",
            "KTV": "Kamarata",
            "MAR": "Maracaibo",
            "MRD": "Mérida",
            "PMV": "Isla Margarita",
            "CCS": "Maiquetía",
            "MUN": "Maturín",
            "CBS": "Cabimas",
            "PYH": "Puerto Ayacucho",
            "PBL": "Puerto Cabello",
            "PDZ": "Capure",
            "PPH": "Parai-tepuí",
            "SCI": "San Cristóbal",
            "PZO": "Puerto Ordaz-Ciudad Guayana",
            "PTM": "Palmarito",
            "LRV": "Gran Roque Island",
            "SVS": "Stevens Village",
            "SBB": "Santa Bárbara",
            "SNV": "Santa Elena de Uairén",
            "STD": "Santo Domingo",
            "SNF": "San Felipe",
            "SFD": "San Fernando de Apure",
            "SOM": "El Tigre",
            "STB": "San Carlos del Zulia",
            "TUV": "Tucupita",
            "URM": "Urimán",
            "WOK": "Uonquén",
            "VLN": "Valencia",
            "VIG": "El Vigía",
            "VLV": "Valera",
            "BAZ": "Barcelos",
            "JSB": "São Benedito",
            "LCB": "Pontes e Lacerda",
            "RBB": "Borba",
            "CAF": "Carauari",
            "CQS": "Costa Marques",
            "DMT": "Diamantino",
            "DNO": "Dianópolis",
            "ERN": "Eirunepé",
            "CQA": "Canarana",
            "SXO": "São Félix Do Araguaia",
            "GRP": "Gurupi",
            "AUX": "Araguaína",
            "GGB": "Água Boa",
            "HUW": "Humaitá",
            "IPG": "Santo Antônio do Içá",
            "IDO": "Cristalândia",
            "JIA": "Juína",
            "JTI": "Jataí",
            "CCX": "Cáceres",
            "CIZ": "Coari",
            "NSR": "São Raimundo Nonato",
            "TLZ": "Catalão",
            "LBR": "Lábrea",
            "RVD": "Rio Verde",
            "MBZ": "Maués",
            "NVP": "Novo Aripuanã",
            "BCR": "Boca do Acre",
            "NQL": "Niquelândia",
            "APS": "Anápolis",
            "FBA": "Fonte Boa",
            "PIN": "Parintins",
            "PBQ": "Pimenta Bueno",
            "PBX": "Porto Alegre do Norte",
            "IRZ": "Santa Isabel Do Rio Negro",
            "TGQ": "Tangará da Serra",
            "AZL": "Sapezal",
            "SQM": "São Miguel do Araguaia",
            "VLP": "Vila Rica",
            "MBK": "Matupá",
            "NOK": "Nova Xavantina",
            "IUP": "Apuí",
            "ITI": "Itambacuri",
            "SXP": "Nunam Iqua",
            "AHL": "Aishalton",
            "NAI": "Annai",
            "SYB": "Seal Bay",
            "BMJ": "Baramita",
            "GFO": "Bartica",
            "GEO": "Georgetown",
            "SYF": "Gabriola Island",
            "OGL": "Ogle",
            "IMB": "Imbaimadai",
            "KAI": "Kaieteur Falls",
            "KAR": "Kamarang",
            "KRM": "Karanambo",
            "KRG": "Karasabai",
            "KTO": "Kato",
            "KKG": "Konawaruk",
            "SYL": "Camp Roberts/San Miguel",
            "LUB": "Lumid Pau",
            "LTM": "Lethem",
            "USI": "Mabaruma",
            "MHA": "Mahdia",
            "VEG": "Maikwak",
            "MYM": "Monkey Mountain",
            "MWJ": "Matthews Ridge",
            "QSX": "New Amsterdam",
            "ORJ": "Orinduik",
            "PKM": "Port Kaituma",
            "PIQ": "Pipillipai",
            "PMT": "Paramakatoi",
            "PRR": "Paruima",
            "SDC": "Sand Creek",
            "SKM": "Skeldon",
            "ANU": "Osbourn",
            "BBQ": "Codrington",
            "BGI": "Bridgetown",
            "TBV": "Tabal Island",
            "TCT": "Takotna",
            "DCF": "Canefield",
            "DOM": "Marigot",
            "DSD": "Grande Anse",
            "BBR": "Basse-Terre",
            "SFC": "St-François",
            "FDF": "Fort-de-France",
            "SFG": "Grand Case",
            "SBH": "Gustavia",
            "GBJ": "Grand-Bourg",
            "PTP": "Pointe-à-Pitre",
            "LSS": "Les Saintes",
            "GND": "Saint George's",
            "CRU": "Carriacou Island",
            "THW": "Trincomalee",
            "STT": "Charlotte Amalie",
            "STX": "Christiansted",
            "ARE": "Arecibo",
            "BQN": "Aguadilla",
            "TJC": "Ticantiquí",
            "CPX": "Culebra",
            "SIG": "San Juan",
            "MAZ": "Mayaguez",
            "PSE": "Ponce",
            "NRR": "Ceiba",
            "SJU": "San Juan",
            "VQS": "Vieques",
            "TKE": "Tenakee Springs",
            "TKL": "Taku Lodge",
            "SKB": "Basseterre",
            "NEV": "Charlestown",
            "SLU": "Castries",
            "UVF": "Vieux Fort",
            "TLT": "Tuluksak",
            "AUA": "Oranjestad",
            "BON": "Kralendijk",
            "CUR": "Willemstad",
            "EUX": "Oranjestad",
            "SXM": "Sint Maarten",
            "SAB": "Zion's Hill",
            "TOK": "Torokina",
            "TOV": "Tortola",
            "TPT": "Tapeta",
            "AXA": "The Valley",
            "XXX": "Serik",
            "MNI": "Gerald's Park",
            "TSG": "Tanacross",
            "TSI": "Tsile Tsile",
            "TAB": "Scarborough",
            "POS": "Port of Spain",
            "TTW": "Tissamaharama",
            "TUJ": "Tum",
            "NGD": "Anegada",
            "EIS": "Beef Island",
            "VIJ": "Spanish Town",
            "SVD": "Kingstown",
            "BQU": "Bequia",
            "CIW": "Canouan",
            "MQS": "Lovell",
            "UNI": "Union Island",
            "TWC": "Tumxuk",
            "TWH": "Two Harbors",
            "BDA": "Hamilton",
            "TYE": "Tyonek",
            "GIT": "Geita",
            "TZO": "Ankisatra",
            "DBS": "Dubois",
            "MXR": "Myrhorod",
            "KHU": "Kremenchuk",
            "KCP": "Kamyan'ka",
            "ALA": "Almaty",
            "BXH": "Balkhash",
            "USJ": "Usharal",
            "BXJ": "Boralday",
            "TDK": "Taldykorgan",
            "NQZ": "Astana",
            "KOV": "Kokshetau",
            "PPK": "Petropavl",
            "DMB": "Taraz",
            "BSZ": "Bishkek",
            "OSS": "Osh",
            "IKG": "Karakol",
            "CIT": "Shymkent",
            "HSA": "Turkıstan",
            "DZN": "Zhezkazgan",
            "KGF": "Karaganda",
            "BXY": "Baikonur",
            "KZO": "Kyzylorda",
            "URA": "Uralsk",
            "EKB": "Ekibastuz",
            "UKK": "Ust-Kamenogorsk (Oskemen)",
            "PWQ": "Pavlodar",
            "PLX": "Semey",
            "SZI": "Zaysan",
            "SCO": "Aktau",
            "GUW": "Atyrau",
            "AKX": "Aktobe",
            "AYK": "Arkalyk",
            "KSN": "Kostanay",
            "GYD": "Baku",
            "FZL": "Fuzuli",
            "GNJ": "Ganja",
            "LLK": "Lankaran",
            "NAJ": "Nakhchivan",
            "GBB": "Gabala",
            "ZTU": "Zaqatala",
            "ZZE": "Zangilan",
            "YLV": "Yevlakh",
            "IKU": "Tamchy",
            "LWN": "Gyumri",
            "EVN": "Yerevan",
            "BQJ": "Batagay",
            "SUK": "Batagay-Alyta",
            "UKG": "Ust-Kuyga",
            "TLK": "Talakan Oil Field",
            "ADH": "Aldan",
            "YKS": "Yakutsk",
            "NER": "Neryungri",
            "MQJ": "Khonuu",
            "KDY": "Khandyga",
            "GYG": "Magan",
            "OLZ": "Olyokminsk",
            "USR": "Ust-Nera",
            "UMS": "Ust-Maya",
            "VHV": "Verkhnevilyuisk",
            "NYR": "Nyurba",
            "SUY": "Suntar",
            "VYI": "Vilyuisk",
            "ULK": "Lensk",
            "ONK": "Olenyok",
            "PYJ": "Yakutia",
            "MJZ": "Mirny",
            "SYS": "Saskylakh",
            "BGN": "Belaya Gora",
            "SEK": "Srednekolymsk",
            "CKH": "Chokurdah",
            "CYX": "Cherskiy",
            "IKS": "Tiksi",
            "ZKP": "Zyryanka",
            "ZIX": "Zhigansk",
            "KXO": "Kisoro",
            "KHX": "Kihihi",
            "OYG": "Moyo",
            "UGB": "Pilot Point",
            "KUT": "Kopitnari",
            "BUS": "Batumi",
            "SUI": "Sukhumi",
            "TBS": "Tbilisi",
            "BQS": "Blagoveschensk",
            "EYA": "Zeya",
            "TYD": "Tynda",
            "KHV": "Khabarovsk",
            "KXK": "Komsomolsk-on-Amur",
            "GVN": "Sovetskaya Gavan",
            "DYR": "Anadyr",
            "PVS": "Chukotka",
            "KPW": "Keperveem",
            "GDX": "Magadan",
            "KVM": "Markovo",
            "PWE": "Apapelgino",
            "SWV": "Evensk",
            "BQG": "Bogorodskoye",
            "NLI": "Nikolayevsk-na-Amure Airport",
            "OHO": "Okhotsk",
            "PKC": "Petropavlovsk-Kamchatsky",
            "BVV": "Kurilsk",
            "OHH": "Okha",
            "ITU": "Kurilsk",
            "EKS": "Shakhtyorsk",
            "DEE": "Yuzhno-Kurilsk",
            "NGK": "Nogliki",
            "ZZO": "Tymovskoye",
            "UUS": "Yuzhno-Sakhalinsk",
            "AEM": "Amgu",
            "ETL": "Svetlaya",
            "EDN": "Yedinka",
            "KVR": "Kavalerovo",
            "TLY": "Plastun",
            "NEI": "Terney",
            "VVO": "Artyom",
            "HTA": "Chita",
            "CZR": "Chara",
            "BTK": "Bratsk",
            "UIK": "Ust-Ilimsk",
            "IKT": "Irkutsk",
            "ODO": "Bodaybo",
            "ERG": "Erbogachen",
            "KCK": "Kirensk",
            "RZH": "Preobrazheniye",
            "UKX": "Ust-Kut",
            "NZG": "Nizhneangarsk",
            "UUD": "Ulan Ude",
            "KBP": "Boryspil",
            "KRQ": "Kramatorsk",
            "MPW": "Mariupol",
            "ERD": "Berdyansk",
            "DNK": "Dnipro",
            "OZH": "Zaporizhia",
            "KWG": "Kryvyi Rih",
            "UKS": "Sevastopol",
            "SIP": "Simferopol",
            "KHC": "Kerch",
            "UKH": "Mukhaizna Oil Field",
            "HRK": "Kharkiv",
            "PLV": "Poltava",
            "UMY": "Sumy",
            "CKC": "Cherkasy",
            "KGO": "Kirovograd",
            "IEV": "Kyiv",
            "ZTR": "Zhytomyr",
            "UCK": "Lutsk",
            "HMJ": "Khmelnytskyi",
            "IFO": "Ivano-Frankivsk",
            "LWO": "Lviv",
            "CWC": "Chernivtsi",
            "RWN": "Rivne",
            "TNL": "Ternopil",
            "UDJ": "Uzhhorod",
            "KHE": "Kherson",
            "NLV": "Nikolayev",
            "ODS": "Odessa",
            "VIN": "Vinnitsa",
            "ARH": "Archangelsk",
            "VKV": "Arkhangelsk",
            "LDG": "Leshukonskoye",
            "NNM": "Naryan Mar",
            "CSH": "Solovetsky Islands",
            "AMV": "Amderma",
            "VRI": "Varandey",
            "KSZ": "Kotlas",
            "LED": "St. Petersburg",
            "MMK": "Murmansk",
            "PKV": "Pskov",
            "PES": "Petrozavodsk",
            "CEE": "Cherepovets",
            "VUS": "Velikiy Ustyug",
            "VGD": "Vologda",
            "BQT": "Brest",
            "GME": "Gomel",
            "VTB": "Vitebsk",
            "KGD": "Kaliningrad",
            "GNA": "Hrodna",
            "MSQ": "Minsk",
            "MVQ": "Mogilev",
            "ABA": "Abakan",
            "BAX": "Barnaul",
            "RGK": "Gorno-Altaysk",
            "KEJ": "Kemerovo",
            "BKA": "Baykit",
            "EIE": "Yeniseysk",
            "YAE": "Yartsevo",
            "TGP": "Bor",
            "VEO": "Severo-Yeniseysk",
            "GOY": "Tura",
            "VAQ": "Vanavara",
            "BGS": "Boguchany",
            "KJA": "Krasnoyarsk",
            "KCY": "Krasnoyarsk",
            "ACS": "Achinsk",
            "KYZ": "Kyzyl",
            "OVB": "Novosibirsk",
            "OMS": "Omsk",
            "SWT": "Strezhevoy",
            "TOF": "Tomsk",
            "NOZ": "Novokuznetsk",
            "DKS": "Dikson",
            "HTG": "Khatanga",
            "SES": "Svetlogorsk",
            "IAA": "Igarka",
            "NSK": "Norilsk",
            "THX": "Turukhansk",
            "AAQ": "Krasnyi Kurgan",
            "GDZ": "Gelendzhik",
            "KRR": "Krasnodar",
            "GRV": "Grozny",
            "MCX": "Makhachkala",
            "MRV": "Mineralnyye Vody",
            "NAL": "Nalchik",
            "OGZ": "Beslan",
            "IGT": "Sunzha",
            "STW": "Stavropol",
            "ROV": "Rostov-on-Don",
            "TGK": "Taganrog",
            "AER": "Sochi",
            "ASF": "Astrakhan",
            "ESL": "Elista",
            "VOG": "Volgograd",
            "BNH": "Boston",
            "RTL": "Okoboji",
            "FWL": "Farewell",
            "CRO": "Corcoran",
            "HLM": "Holland",
            "PQS": "Pilot Station",
            "CEK": "Chelyabinsk",
            "MQF": "Magnitogorsk",
            "SBT": "Sabetta",
            "BVJ": "Bovanenkovo",
            "SLY": "Salekhard",
            "YMK": "Mys Kamennyi",
            "KKQ": "Krasnoselkup",
            "TQL": "Tarko-Sale",
            "UEN": "Urengoy",
            "HMA": "Khanty-Mansiysk",
            "KXD": "Kondinskoye",
            "NYA": "Nyagan",
            "OVS": "Sovetskiy",
            "URJ": "Uray",
            "IJK": "Izhevsk",
            "KVX": "Kirov",
            "NYM": "Nadym",
            "NUX": "Novy Urengoy",
            "NJC": "Nizhnevartovsk",
            "PEE": "Perm",
            "KGP": "Kogalym",
            "NFG": "Nefteyugansk",
            "NOJ": "Noyabrsk",
            "SGC": "Surgut",
            "SVX": "Yekaterinburg",
            "RMZ": "Tobolsk",
            "TOX": "Tobolsk",
            "TJM": "Tyumen",
            "KRO": "Kurgan",
            "BKN": "Balkanabat",
            "GMV": "Oljato-Monument Valley",
            "ASB": "Ashgabat",
            "KEA": "Kerki",
            "KRW": "Turkmenbashi",
            "MYP": "Mary",
            "TAZ": "Daşoguz",
            "CRZ": "Türkmenabat",
            "DYU": "Dushanbe",
            "TJU": "Kulyab",
            "LBD": "Khujand",
            "KQT": "Kurgan-Tyube",
            "NMA": "Namangan",
            "AZN": "Andizhan",
            "FEG": "Fergana",
            "OQN": "Kokand",
            "MOK": "Muynak",
            "NCU": "Nukus",
            "UGC": "Urgench",
            "NVI": "Navoi",
            "BHK": "Bukhara",
            "KSQ": "Karshi",
            "AFS": "Zarafshan",
            "SKD": "Samarkand",
            "TMJ": "Termez",
            "TAS": "Tashkent",
            "OMN": "Zaamin",
            "UTU": "Ustupu",
            "KMW": "Kostroma",
            "KLF": "Kaluga",
            "IWA": "Ivanovo",
            "RYB": "Rybinsk",
            "BZK": "Bryansk",
            "ZIA": "Moscow",
            "DME": "Moscow",
            "IAR": "Tunoshna",
            "SVO": "Moscow",
            "KLD": "Tver",
            "OSF": "Moscow",
            "CKL": "Moscow",
            "EGO": "Belgorod",
            "URS": "Kursk",
            "LPK": "Lipetsk",
            "VOZ": "Voronezh",
            "TBW": "Tambov",
            "UUU": "Manumu",
            "VKO": "Moscow",
            "UCT": "Ukhta",
            "INA": "Inta",
            "PEX": "Pechora",
            "USK": "Usinsk",
            "VKT": "Vorkuta",
            "UTS": "Ust-Tsylma",
            "SCW": "Syktyvkar",
            "GOJ": "Nizhny Novgorod",
            "UUA": "Bugulma",
            "KZN": "Kazan",
            "NBC": "Nizhnekamsk",
            "JOK": "Yoshkar-Ola",
            "CSY": "Cheboksary",
            "ULV": "Ulyanovsk",
            "ULY": "Cherdakly",
            "REN": "Orenburg",
            "OSW": "Orsk",
            "PEZ": "Penza",
            "SKX": "Saransk",
            "BWO": "Balakovo",
            "GSV": "Saratov",
            "BCX": "Beloretsk",
            "OKT": "Kzyl-Yar",
            "UFA": "Ufa",
            "KUF": "Samara",
            "RBZ": "Shahrisabz",
            "UZM": "Hope Bay",
            "UZR": "Urzhar",
            "REW": "Rewa",
            "DIU": "Diu",
            "GDB": "Gondia",
            "AMD": "Ahmedabad",
            "AKD": "Akola",
            "IXU": "Aurangabad",
            "BOM": "Mumbai",
            "BHJ": "Bhuj",
            "IXG": "Belgaum",
            "BDQ": "Vadodara",
            "BHO": "Bhopal",
            "BHU": "Bhavnagar",
            "NMB": "Daman",
            "HBX": "Hubli",
            "HSR": "Rajkot",
            "IDR": "Indore",
            "JLR": "Jabalpur",
            "JLG": "Jalgaon",
            "JGA": "Jamnagar",
            "IXY": "Kandla",
            "HJR": "Khajuraho",
            "KLH": "Kolhapur",
            "IXK": "Keshod",
            "LTU": "Latur",
            "NDC": "Nanded",
            "NAG": "Nagpur",
            "ISK": "Nasik",
            "PNQ": "Pune",
            "PBD": "Porbandar",
            "RAJ": "Rajkot",
            "RPR": "Raipur",
            "SAG": "Kakadi",
            "SSE": "Solapur",
            "STV": "Surat",
            "UDR": "Udaipur",
            "CMB": "Colombo",
            "ACJ": "Anuradhapura",
            "BTC": "Batticaloa",
            "RML": "Colombo",
            "ADP": "Ampara",
            "HIM": "Polonnaruwa Town",
            "JAF": "Jaffna",
            "KCT": "Galle",
            "KTY": "Kalutara",
            "GIU": "Sigiriya",
            "TRR": "Trincomalee",
            "WRZ": "Weerawila",
            "HRI": "Mattala",
            "BBM": "Battambang",
            "KZC": "Kampong Chhnang",
            "KKZ": "Krong Khemara Phoumin",
            "MWV": "Sen Monorom",
            "PNH": "Phnom Penh (Pou Senchey)",
            "RBE": "Ratanakiri",
            "SAI": "Siem Reap",
            "KOS": "Preah Sihanouk",
            "KZD": "Krakor",
            "LGY": "Lagunillas",
            "SFX": "Ciudad Guayana",
            "SVV": "San Salvador de Paul",
            "ELX": "El Tigre",
            "AZH": "Azamgarh",
            "IXA": "Agartala",
            "IXB": "Siliguri",
            "RGH": "Balurghat",
            "SHL": "Shillong",
            "VNS": "Varanasi",
            "BBI": "Bhubaneswar",
            "PAB": "Bilaspur",
            "CCU": "Kolkata",
            "COH": "Cooch Behar",
            "CWK": "Chitrakoot",
            "RDP": "Durgapur",
            "DBR": "Darbhanga",
            "DGH": "Deoghar",
            "DEP": "Daporijo",
            "GOP": "Gorakhpur",
            "GAU": "Guwahati",
            "GAY": "Gaya",
            "IMF": "Imphal",
            "PYB": "Jeypore",
            "IXW": "Jamshedpur",
            "JRH": "Jorhat",
            "KBK": "Kushinagar",
            "IXQ": "Manik Bhandar",
            "IXH": "Kailashahar",
            "IXS": "Silchar",
            "IXN": "Khowai",
            "AJL": "Aizawl (Lengpui)",
            "IXI": "Lilabari",
            "LDA": "Malda",
            "DIB": "Dibrugarh",
            "DMU": "Dimapur",
            "MZU": "Muzaffarpur",
            "IXT": "Pasighat",
            "PAT": "Patna",
            "IXR": "Ranchi",
            "RRK": "Rourkela",
            "RUP": "Rupsi",
            "TEI": "Tezu",
            "VTZ": "Visakhapatnam",
            "ZER": "Ziro",
            "RAD": "Tortola",
            "BZL": "Barisal",
            "CXB": "Cox's Bazar",
            "CLA": "Comilla",
            "CGP": "Chattogram (Chittagong)",
            "DAC": "Dhaka",
            "IRD": "Ishurdi",
            "JSR": "Jashore (Jessore)",
            "RJH": "Rajshahi",
            "SPD": "Saidpur",
            "TKR": "Thakurgaon",
            "ZHM": "Shamshernagar",
            "ZYL": "Sylhet",
            "HKG": "Hong Kong",
            "HHP": "Central and Western",
            "SPB": "Charlotte Amalie",
            "SSB": "Christiansted",
            "AGR": "Agra",
            "HRH": "Aligarh",
            "IXD": "Allahabad",
            "ATQ": "Amritsar",
            "AIP": "Adampur",
            "BKB": "Bikaner",
            "KUU": "Bhuntar",
            "BEK": "Bareilly",
            "IXC": "Chandigarh",
            "KNU": "Kanpur",
            "DED": "Dehradun (Jauligrant)",
            "DEL": "New Delhi",
            "HDO": "Ghaziabad",
            "DHM": "Kangra",
            "GWL": "Gwalior",
            "HSS": "Hisar",
            "JDH": "Jodhpur",
            "JAI": "Jaipur",
            "IXJ": "Jammu",
            "KQH": "Ajmer (Kishangarh)",
            "KTU": "Kota",
            "IXL": "Leh",
            "LKO": "Lucknow",
            "MZS": "Moradabad",
            "IXP": "Pathankot",
            "PGH": "Pantnagar",
            "SLV": "Jubbarhatti",
            "SWN": "Sherpur Naqeebpur",
            "SXR": "Srinagar",
            "VSV": "Shravasti",
            "VIV": "Vivigani",
            "VJQ": "Gurue",
            "AOU": "Attopeu",
            "HOE": "Huay Xai",
            "LPQ": "Luang Phabang",
            "LXG": "Luang Namtha",
            "ODY": "Oudomsay",
            "PKZ": "Pakse",
            "ZBY": "Sainyabuli",
            "VNA": "Salavan",
            "THK": "Thakhek",
            "VTE": "Vientiane",
            "XKH": "Xieng Khouang",
            "XIE": "Xienglom",
            "VMI": "Puerto Vallemi",
            "MFM": "Nossa Senhora do Carmo",
            "BJH": "Bajhang",
            "BHP": "Bhojpur",
            "BGL": "Baglung",
            "BHR": "Bharatpur",
            "BJU": "Bajura",
            "BIT": "Baitadi",
            "BWA": "Siddharthanagar (Bhairahawa)",
            "BDP": "Bhadrapur",
            "DNP": "Dang",
            "DHI": "Dhangarhi",
            "DAP": "Darchula",
            "DOP": "Dolpa",
            "SIH": "Silgadi Doti",
            "GKH": "Gorkha",
            "JIR": "Jiri",
            "JUM": "Jumla",
            "JKR": "Janakpur",
            "JMO": "Jomsom",
            "KTM": "Kathmandu",
            "LDN": "Lamidanda",
            "LUA": "Lukla",
            "LTG": "Langtang",
            "NGX": "Ngawal",
            "MEY": "Meghauli",
            "XMG": "Mahendranagar",
            "KEP": "Nepalgunj",
            "PKR": "Pokhara",
            "PPL": "Phaplu",
            "RJB": "Rajbiraj",
            "RHP": "Ramechhap",
            "RUK": "Rukumkot",
            "RPA": "Rolpa",
            "RUM": "Rumjatar",
            "SYH": "Namche Bazaar",
            "SIF": "Simara",
            "SKH": "Surkhet",
            "FEB": "Sanfebagar",
            "IMK": "Simikot",
            "TPJ": "Taplejung",
            "TPU": "Tikapur",
            "TMI": "Tumling Tar",
            "BIR": "Biratnagar",
            "AGX": "Agatti",
            "BEP": "Bellary",
            "BLR": "Bangalore",
            "IXX": "Bidar",
            "VGA": "Gannavaram",
            "CJB": "Coimbatore",
            "COK": "Kochi",
            "CCJ": "Calicut",
            "CDP": "Kadapa",
            "CBD": "IAF Camp",
            "GOX": "Mopa",
            "GBI": "Kalaburagi",
            "GOI": "Vasco da Gama",
            "HYD": "Hyderabad",
            "BPM": "Hyderabad",
            "VDY": "Toranagallu",
            "CNN": "Kannur",
            "KJB": "Orvakal",
            "IXM": "Madurai",
            "IXE": "Mangalore",
            "MAA": "Chennai",
            "MYQ": "Mysore",
            "NVY": "Neyveli",
            "IXZ": "Port Blair",
            "PNY": "Puducherry (Pondicherry)",
            "PUT": "Puttaparthi",
            "RMD": "Ramagundam",
            "RJA": "Madhurapudi",
            "SXV": "Salem",
            "TJV": "Thanjavur",
            "TCR": "Vagaikulam",
            "TIR": "Tirupati",
            "TRZ": "Tiruchirappalli",
            "TRV": "Thiruvananthapuram",
            "WGC": "Warangal",
            "BUT": "Jakar",
            "GLU": "Gelephu",
            "PBH": "Paro",
            "YON": "Yongphulla",
            "HDK": "Kulhudhuffushi",
            "NMF": "Noonu Atoll",
            "IFU": "Ifuru Island",
            "DRV": "Baa Atoll",
            "FVM": "Fuvahmulah Island",
            "GAN": "Gan",
            "HAQ": "Haa Dhaalu Atoll",
            "KDO": "Kadhdhoo",
            "MLE": "Malé",
            "GKK": "Huvadhu Atoll",
            "KDM": "Huvadhu Atoll",
            "DDD": "Kudahuvadhoo",
            "VAM": "Maamigili",
            "TMF": "Thimarafushi",
            "RUL": "Maavaarulu",
            "DMK": "Bangkok",
            "KDT": "Nakhon Pathom",
            "KKM": "Lop Buri",
            "TDX": "Laem Ngop",
            "BKK": "Bangkok",
            "UTP": "Rayong",
            "CNX": "Chiang Mai",
            "HGN": "Mae Hong Son",
            "PYY": "Pai",
            "CEI": "Chiang Rai",
            "HHQ": "Hua Hin",
            "PHS": "Phitsanulok",
            "URT": "Surat Thani",
            "CJM": "Chumphon",
            "NST": "Nakhon Si Thammarat",
            "KBV": "Krabi",
            "USM": "Na Thon (Ko Samui Island)",
            "HKT": "Phuket",
            "UNN": "Ranong",
            "HDY": "Hat Yai",
            "TST": "Trang",
            "UTH": "Udon Thani",
            "PXR": "Surin",
            "KKC": "Khon Kaen",
            "BFV": "Buriram",
            "NAK": "Chaloem Phra Kiat",
            "UBP": "Ubon Ratchathani",
            "ROI": "Roi Et",
            "KOP": "Nakhon Phanom",
            "VUU": "Liwonde National Park",
            "BMV": "Buon Ma Thuot",
            "VCL": "Tam Nghĩa",
            "HPH": "Haiphong (Hai An)",
            "CAH": "Ca Mau City",
            "CXR": "Cam Ranh",
            "VCS": "Con Dao",
            "VCA": "Can Tho",
            "DIN": "Dien Bien Phu",
            "VDH": "Dong Hoi",
            "DLI": "Da Lat",
            "DAD": "Da Nang",
            "VVN": "Las Malvinas",
            "HAN": "Hanoi (Soc Son)",
            "SQH": "Mai Son",
            "HUI": "Huế",
            "UIH": "Quy Nohn",
            "PXU": "Pleiku",
            "PQC": "Phu Quoc Island",
            "PHA": "Phan Rang",
            "VKG": "Rach Gia",
            "TBB": "Tuy Hoa",
            "SGN": "Ho Chi Minh City",
            "THD": "Thanh Hóa",
            "VDO": "Van Don",
            "VII": "Vinh",
            "VTG": "Vũng Tàu",
            "VBA": "Aeng",
            "NYU": "Nyaung U",
            "BMO": "Banmaw",
            "VBP": "Bokpyinn",
            "VBC": "Mandalay",
            "TVY": "Dawei",
            "SRU": "Falam",
            "GAW": "Gangaw",
            "GWA": "Gwa",
            "HEH": "Kalaw Township",
            "HOX": "Hommalinn",
            "TIO": "Tilin",
            "KET": "Kengtung",
            "KHM": "Kanti",
            "KMV": "Kalemyo",
            "KYP": "Kyaukpyu",
            "KAW": "Kawthoung",
            "KYT": "Kyauktu",
            "LIW": "Loikaw",
            "LSH": "Lashio",
            "MDL": "Mandalay",
            "MGZ": "Mkeik",
            "MYT": "Myitkyina",
            "MNU": "Mawlamyine",
            "MGU": "Manaung",
            "MOG": "Mong Hsat",
            "MGK": "Mong Tong",
            "MWQ": "Magway",
            "NYW": "Monywar",
            "NMS": "Namsang",
            "NYT": "Pyinmana",
            "NMT": "Namtu",
            "PAA": "Hpa-N",
            "PAU": "Pauk",
            "BSX": "Pathein",
            "PPU": "Pa Pun",
            "PBU": "Putao",
            "PKK": "Pakhokku",
            "PRU": "Pye",
            "AKY": "Sittwe",
            "SNW": "Thandwe",
            "THL": "Tachileik",
            "XYE": "Ye",
            "RGN": "Yangon",
            "FBS": "Friday Harbor",
            "RSJ": "Rosario",
            "LKE": "Seattle",
            "RCE": "Roche Harbor",
            "TQQ": "Waha-Tomea Island",
            "WSX": "West Sound",
            "UPG": "Ujung Pandang",
            "BIK": "Biak",
            "ONI": "Moanamani",
            "FOO": "Nomfor",
            "WET": "Tigi",
            "NBX": "Nabire",
            "KBF": "Karubaga",
            "ILA": "Ilaga",
            "KOX": "Kokonao",
            "ZRI": "Serui",
            "TIM": "Timika",
            "EWI": "Enarotali",
            "WAD": "Andriamena",
            "BMU": "Palibelo, Bima",
            "DPS": "Kuta, Badung",
            "LOP": "Mataram (Pujut, Lombok Tengah)",
            "SWQ": "Sumbawa Besar",
            "TMC": "Radamata",
            "LYK": "Lunyuk",
            "WGP": "Waingapu-Sumba Island",
            "BWX": "Rogojampi, Banyuwangi",
            "TTE": "Ternate",
            "SQN": "Sanana",
            "OTI": "Gotalalamo-Morotai Island",
            "TRT": "Toraja",
            "LLO": "Palopo",
            "PLW": "Palu",
            "MJU": "Mamuju",
            "TLI": "Toli Toli-Celebes Island",
            "MXB": "Masamba",
            "PSJ": "Poso-Celebes Island",
            "OJU": "Tojo Una-Una",
            "LUW": "Luwok",
            "HMS": "Muara Teweh",
            "KLP": "Seruyan",
            "PKY": "Palangkaraya",
            "YIA": "Yogyakarta",
            "CXP": "Cilacap",
            "PWL": "Purwokerto-Java Island",
            "KWB": "Karimunjawa",
            "BUI": "Bokondini",
            "DRH": "Dabra",
            "BXM": "Batom",
            "ZRM": "Sarmi",
            "DJJ": "Sentani",
            "LHI": "Lereh-Papua Island",
            "LII": "Mulia-Papua Island",
            "OKL": "Oksibil",
            "SEH": "Senggeh",
            "MDP": "Mindiptana-Papua Island",
            "BXD": "Bade",
            "MKQ": "Merauke",
            "KCD": "Kamur",
            "OKQ": "Okaba",
            "KEI": "Kepi",
            "ZEG": "Senggo-Papua Island",
            "TMH": "Tanah Merah",
            "GHS": "Melak-Borneo Island",
            "TJS": "Tanjung Selor-Borneo Island",
            "DTD": "Datadawai-Borneo Island",
            "BPN": "Balikpapan",
            "TRK": "Tarakan",
            "AAP": "Samarinda",
            "BYQ": "Bunju Island",
            "GLX": "Galela",
            "PGQ": "Pekaulang",
            "GTO": "Gorontalo-Celebes Island",
            "NAH": "Tabukan Utara, Sangihe Islands",
            "LKM": "Lolak",
            "GEB": "Gebe Island",
            "KAZ": "Kao",
            "MDC": "Manado",
            "MNA": "Karakelong Island",
            "BRG": "Balirangen",
            "MWS": "Morowali",
            "IAX": "Miangas",
            "UOL": "Buol-Celebes Island",
            "BTW": "Batu Licin",
            "PKN": "Pangkalanbun",
            "KBU": "Stagen",
            "TJG": "Tanta-Tabalong",
            "BDJ": "Landasan Ulin",
            "SMQ": "Sampit",
            "TBM": "Tumbang Samba-Borneo Island",
            "AHI": "Amahai",
            "NDA": "Bandanaira",
            "DOB": "Dobo-Warmar Island",
            "MAL": "Mangole Island",
            "LUV": "Langgur",
            "NRE": "Namrole",
            "LAH": "Labuha-Halmahera Island",
            "BJK": "Maikoor Island",
            "NAM": "Namniwel",
            "AMQ": "Ambon",
            "TAX": "Tikong-Taliabu Island",
            "WBA": "Wahai",
            "RTU": "Maratua",
            "LNU": "Malinau",
            "BEJ": "Tanjung Redeb - Borneo Island",
            "MLG": "Malang",
            "CPF": "Blora",
            "JBB": "Jember",
            "JOG": "Yogyakarta",
            "SOC": "Surakarta",
            "SUB": "Surabaya",
            "SRG": "Semarang",
            "SUP": "Sumenep",
            "BXW": "Bawean",
            "AYW": "Ayawasi",
            "NTI": "Bintuni",
            "RSK": "Ransiki-Papua Island",
            "KEQ": "Kebar",
            "FKQ": "Fakfak",
            "INX": "Inanwatan",
            "KNG": "Kaimana",
            "RDE": "Merdei-Papua Island",
            "RJM": "Waisai",
            "BXB": "Babo",
            "MKW": "Manokwari",
            "SOQ": "Sorong",
            "TXM": "Atinjoe",
            "KBX": "Kambuaya-Papua Island",
            "WSR": "Wasior",
            "ABU": "Atambua",
            "BJW": "Soa, Ngada",
            "MOF": "Waioti",
            "ENE": "Ende",
            "RTG": "Satar Tacik, Manggarai",
            "LKA": "Tiwatobi",
            "ARD": "Kabola",
            "LBJ": "Labuan Bajo, Manggarai Barat",
            "RTI": "Ba'a - Rote Island",
            "SAU": "Sabu-Sawu Island",
            "KOE": "Kupang",
            "LWE": "Lewoleba",
            "WMX": "Wamena",
            "BUW": "Bau Bau",
            "WNI": "Wangi-wangi Island",
            "KSR": "Benteng",
            "APD": "Bone",
            "KXB": "Kolaka",
            "RAQ": "Raha",
            "SQR": "Soroako",
            "TTR": "Makale",
            "KDI": "Kendari",
            "WBB": "Stebbins",
            "BTU": "Bintulu",
            "BLG": "Belaga",
            "LSM": "Long Semado",
            "LGL": "Long Datih",
            "KCH": "Kuching",
            "ODN": "Long Seridan",
            "LMN": "Limbang",
            "MKM": "Mukah",
            "LKH": "Long Akah",
            "MUR": "Marudi",
            "BSE": "Sematan",
            "KPI": "Kapit",
            "BKM": "Bakalalan",
            "MYY": "Miri",
            "SBW": "Sibu",
            "LSU": "Long Sukang",
            "LWY": "Lawas",
            "BBN": "Bario",
            "SMM": "Semporna",
            "LDU": "Lahad Datu",
            "TEL": "Telupid",
            "KGU": "Keningau",
            "SXS": "Sahabat",
            "BKI": "Kota Kinabalu",
            "LBU": "Labuan",
            "TMG": "Tomanggong",
            "GSA": "Long Miau",
            "SPE": "Sepulot",
            "PAY": "Pamol",
            "RNU": "Ranau",
            "SDK": "Sandakan",
            "KUD": "Kudat",
            "TWU": "Tawau",
            "MZV": "Mulu",
            "BWN": "Bandar Seri Begawan",
            "TGC": "Belawai",
            "WDA": "Ain District",
            "WED": "Wedau",
            "WHL": "Welshpool",
            "PKU": "Pekanbaru",
            "DUM": "Dumai",
            "RGT": "Rengat-Sumatra Island",
            "SEQ": "Bengkalis-Sumatra Island",
            "TJB": "Tanjung Balai-Karinmunbesar Island",
            "KJT": "Kertajati",
            "RTO": "Tangerang-Java Island",
            "BDO": "Bandung",
            "CBN": "Cirebon-Java Island",
            "TSY": "Tasikmalaya-Java Island",
            "CJN": "Cijulang",
            "TBX": "Tambelan",
            "BTH": "Batam",
            "PPR": "Pasir Pengarayan",
            "LMU": "Bukit Padi",
            "MWK": "Palmatak",
            "TNJ": "Tanjung Pinang-Bintan Island",
            "SIQ": "Pasirkuning-Singkep Island",
            "MPC": "Muko Muko",
            "HLP": "Jakarta",
            "PCB": "Jakarta",
            "CGK": "Jakarta",
            "TKG": "Bandar Lampung",
            "TFY": "Krui",
            "LSW": "Lhok Seumawe-Sumatra Island",
            "GNS": "Gunungsitoli",
            "AEG": "Padang Sidempuan",
            "JHN": "Mandailing",
            "MES": "Medan",
            "KNO": "Beringin",
            "DTB": "Siborong-Borong",
            "SIW": "Parapat-Sumatra Island",
            "FLZ": "Sibolga (Pinangsori)",
            "LSR": "Kutacane",
            "TJQ": "Tanjung Pandan",
            "NPO": "Nanga Pinoh-Borneo Island",
            "KTG": "Ketapang",
            "NTX": "Ranai-Natuna Besar Island",
            "PNK": "Pontianak",
            "PSU": "Putussibau-Borneo Island",
            "SQG": "Sintang",
            "DJB": "Jambi",
            "LLJ": "Lubuk Linggau",
            "BUU": "Muara Bungo",
            "PGK": "Pangkal Pinang",
            "BKS": "Bengkulu",
            "PLM": "Palembang",
            "PDO": "Talang Gudang-Sumatra Island",
            "PDG": "Padang (Katapiang)",
            "PXA": "Bentayan",
            "TPK": "Tapaktuan",
            "MEQ": "Kuala Pesisir",
            "LKI": "Lubang",
            "TXE": "Takengon",
            "LSX": "Lhok Sukon-Sumatra Island",
            "SBG": "Sabang",
            "BTJ": "Banda Aceh",
            "SXT": "Taman Negara",
            "MEP": "Mersing",
            "SWY": "Sitiawan",
            "TPG": "Taiping",
            "TOD": "Tioman Island",
            "AOR": "Alor Satar",
            "BWH": "Butterworth",
            "KBR": "Kota Baharu",
            "KUA": "Kuantan",
            "KTE": "Kerteh",
            "IPH": "Ipoh",
            "JHB": "Johor Bahru",
            "KUL": "Sepang",
            "LGK": "Langkawi",
            "MKZ": "Malacca",
            "TGG": "Kuala Terengganu",
            "PEN": "Penang",
            "PKG": "Pangkor Island",
            "RDN": "Redang",
            "SZB": "Subang",
            "DTR": "Decatur",
            "SXK": "Saumlaki-Yamdena Island",
            "AUT": "Vila",
            "UAI": "Suai",
            "DIL": "Dili",
            "BCH": "Baucau",
            "MPT": "Maliana",
            "OEC": "Oecussi-Ambeno",
            "VIQ": "Viqueque",
            "SGQ": "Sanggata/Sangkimah",
            "LBW": "Long Bawan",
            "BXT": "Bontang-Borneo Island",
            "NNX": "Nunukan-Nunukan Island",
            "TNB": "Tanah Grogot",
            "LPU": "Long Apung-Borneo Island",
            "QPG": "Paya Lebar",
            "TGA": "Western Water Catchment",
            "WSB": "Steamboat Bay",
            "UGI": "San Juan",
            "WSM": "Wiseman",
            "XSP": "Seletar",
            "SIN": "Singapore",
            "GWV": "Glendale",
            "WZQ": "Urad Middle Banner",
            "MPB": "Miami",
            "XBB": "Blubber Bay",
            "XIG": "Xinguara",
            "XMA": "Maramag",
            "XRQ": "New Barag Right Banner",
            "XZM": "Sé",
            "UKN": "Waukon",
            "ALH": "Albany",
            "ABG": "Abingdon Downs",
            "YAJ": "Saturna Island",
            "MRP": "Marla",
            "ADO": "Andamooka",
            "ABH": "Alpha",
            "YAQ": "Maple Bay",
            "ARY": "Ararat",
            "ARM": "Armidale",
            "AAB": "Tanbar",
            "AUU": "Aurukun",
            "AVG": "Auvergne Station",
            "AYQ": "Yulara",
            "AYR": "Ayr",
            "MBN": "Wunaamin Miliwundi Ranges",
            "BCI": "Barcaldine",
            "ASP": "Alice Springs",
            "BDD": "Badu Island",
            "BNE": "Brisbane",
            "OOL": "Gold Coast",
            "BKQ": "Blackall",
            "CNS": "Cairns",
            "CTL": "Charleville",
            "BXF": "Pumululu National Park",
            "BEE": "Dampier Peninsula",
            "BQW": "Balgo",
            "YBH": "Bull Harbour",
            "BHQ": "Broken Hill",
            "HTI": "Hamilton Island",
            "BEU": "Bedourie",
            "BZP": "Lakefield National Park",
            "YBJ": "Baie-Johan-Beetz",
            "BLN": "Benalla",
            "ZBL": "Biloela",
            "BQB": "Busselton",
            "ISA": "Mount Isa",
            "MKY": "Mackay",
            "BNK": "Ballina",
            "BSJ": "Bairnsdale",
            "GIC": "Boigu Island",
            "KAH": "Melbourne",
            "PPP": "Proserpine",
            "YBQ": "Thetis Island",
            "ROK": "Rockhampton",
            "BME": "Broome",
            "MCY": "Maroochydore",
            "BHS": "Bathurst",
            "BRT": "Wurrumiyanga",
            "TSV": "Townsville",
            "BDB": "Bundaberg",
            "ZBO": "Bowen",
            "WEI": "Weipa",
            "WTB": "Toowoomba",
            "BVZ": "Wunaamin Miliwundi Ranges",
            "CVQ": "Carnarvon",
            "CBY": "Canobie",
            "CBI": "Cape Barren Island",
            "CPD": "Coober Pedy",
            "CCL": "Chinchilla",
            "CNJ": "Cloncurry",
            "CUD": "Caloundra",
            "YCF": "Cortes Bay",
            "CFH": "Clifton Hills",
            "CFS": "Coffs Harbour",
            "LLG": "Chillagoe",
            "CRH": "Cherrabah Homestead Resort",
            "CKW": "Christmas Creek Mine",
            "DCN": "Derby",
            "ODL": "Cordillo Downs",
            "CUQ": "Coen",
            "CIE": "Collie",
            "OOM": "Cooma",
            "CFP": "Carpentaria Downs",
            "CXQ": "Wangkat Jungka",
            "CJF": "Coondewanna",
            "COY": "Coolawanyah Station",
            "DNB": "Maramie",
            "DRB": "Derby",
            "DFP": "Palmer",
            "DDI": "Whitsundays",
            "DNG": "Drysdale River",
            "DXD": "New Dixie",
            "DKI": "Dunk Island",
            "DLK": "Dulkaninna",
            "DNQ": "Deniliquin",
            "DYW": "Daly Waters",
            "DVR": "Nauiyu",
            "NLF": "Darnley Island",
            "DRD": "Dorunda Outstation",
            "DPO": "Devonport",
            "DOX": "Port Denison",
            "DRY": "Drysdale River",
            "SRR": "North Stradbroke Island",
            "DKV": "Kaltukatjara",
            "RXA": "Ar Rawdah",
            "ETD": "Etadunna",
            "ENB": "Eneabba",
            "EIH": "Einasleigh",
            "ELC": "Elcho Island",
            "EMD": "Emerald",
            "EDD": "Ghan",
            "ERQ": "Elrose Mine",
            "EPR": "Esperance",
            "EVD": "Eva Downs",
            "EXM": "Exmouth",
            "FRB": "Forbes",
            "KFE": "Cloudbreak Village",
            "FLS": "Whitemark",
            "FIK": "Finke",
            "FVR": "Oombulgurri",
            "JFM": "Fremantle",
            "YGA": "Chongqing",
            "GBP": "Gamboola",
            "GAH": "Gayndah",
            "GDD": "Gordon Downs",
            "YGE": "Gorge Harbour",
            "GET": "Moonyoonooka",
            "GFN": "Grafton",
            "GBW": "Ginbata",
            "GBV": "Gibb",
            "GKL": "Great Keppel Island",
            "GLT": "Gladstone",
            "GLI": "Glen Innes",
            "YGN": "Broughton Island",
            "GFE": "Grenfell",
            "GPD": "Mount Gordon Mine",
            "GPN": "Pirlangimpi",
            "GSC": "Gascoyne Junction",
            "GTE": "Groote Eylandt",
            "GFF": "Griffith",
            "GTT": "Georgetown",
            "GEE": "George Town",
            "HWK": "Hawker",
            "HVB": "Hervey Bay",
            "HRY": "Ghan",
            "HIG": "Highbury",
            "HID": "Horn",
            "HLL": "Hillside",
            "HMG": "Hermannsburg (Ntaria)",
            "HOK": "Lajamanu",
            "MHU": "Mount Hotham",
            "HAP": "Long Island",
            "HPE": "Hope Vale",
            "HAT": "Shelburne",
            "HGD": "Hughenden",
            "IBM": "Japal Camp",
            "IDK": "Indulkana",
            "IKP": "Inkerman",
            "INJ": "Injune",
            "IVW": "Inverway",
            "IVR": "Inverell",
            "JUN": "Jundah",
            "JUR": "Jurien Bay",
            "UBU": "Kalumburu",
            "KQR": "Karara",
            "KYB": "Ken's Bore",
            "KDB": "Kambalda West",
            "KAX": "Kalbarri",
            "KBJ": "Petermann",
            "KCS": "Petermann",
            "OOD": "Koodaideri Mine",
            "KBB": "Kirkimbie",
            "KOH": "Maramie",
            "KKP": "Koolburra",
            "KCI": "Koolan Island",
            "KWM": "Kowanyama",
            "KPP": "Kalpower",
            "YKT": "Klemtu",
            "KUG": "Kubin Island",
            "KRD": "Kurundi Station",
            "LNO": "Leonora",
            "LFP": "Lakefield",
            "LDH": "Lord Howe Island",
            "IRG": "Lockhart River",
            "LTP": "Lyndhurst",
            "LIB": "Limbunya",
            "LDC": "Lindeman Island",
            "LSY": "Lismore",
            "LNH": "Alpurrurulam",
            "BEO": "City of Lake Macquarie",
            "LKD": "Lakeland Downs",
            "LOC": "Lock",
            "LTV": "Lotus Vale",
            "YLP": "Longue-Pointe-de-Mingan",
            "LRE": "Longreach",
            "LUT": "Laura Station",
            "LVO": "Laverton",
            "TGN": "Morwell",
            "UBB": "Mabuiag Island",
            "MYI": "Murray Island",
            "AVV": "Lara",
            "ABX": "East Albury",
            "MRG": "Mareeba",
            "DGE": "Mudgee",
            "MQA": "Eighty Mile Beach",
            "MEB": "Essendon Fields",
            "MIM": "Merimbula",
            "MLV": "Merluna",
            "MGT": "Milingimbi Island",
            "MNG": "Maningrida",
            "GSN": "Mount Gunson",
            "MVU": "Musgrave",
            "HBA": "Hobart (Cambridge)",
            "MHO": "Wunaamin Miliwundi Ranges",
            "MCV": "McArthur River Mine",
            "MQL": "Mildura",
            "MIH": "Mitchell Plateau",
            "MWY": "Miranda Downs",
            "LST": "Launceston (Western Junction)",
            "MBW": "Melbourne",
            "WUI": "Murrin Murrin",
            "MEL": "Melbourne",
            "MRZ": "Moree",
            "MET": "Moreton",
            "MQE": "Marqua",
            "MOV": "Moranbah",
            "MYA": "Moruya",
            "MGB": "Mount Gambier",
            "MUQ": "Muccan Station",
            "MNE": "Mungeranie",
            "MVK": "Mulka",
            "MWT": "Moolawatana Station",
            "MXD": "Marion Downs",
            "MBH": "Maryborough",
            "NRA": "Narrandera",
            "NAA": "Narrabri",
            "NBH": "Nambucca Heads",
            "NMP": "Basalt",
            "NPP": "Napperby",
            "ABM": "Bamaga",
            "NRG": "Narrogin",
            "NSM": "Norseman",
            "NTN": "Normanton",
            "UTD": "Nutwood Downs",
            "ZNE": "Newman",
            "YOI": "Éléonore Mine",
            "XCO": "Colac Otway Shire",
            "OLP": "Olympic Dam",
            "MOO": "Moomba",
            "OKB": "Orchid Beach",
            "OAG": "Orange",
            "ODR": "Ord River",
            "OYN": "Ouyen",
            "ADL": "Adelaide",
            "PBO": "Paraburdoo",
            "CCK": "West Island",
            "PDN": "Kangaroo Island",
            "DRW": "Darwin",
            "PRD": "Pardoo",
            "GOV": "Nhulunbuy",
            "JAD": "Perth",
            "KTA": "Karratha",
            "KGI": "Broadwood",
            "PKE": "Parkes",
            "PKT": "Wadeye",
            "KNX": "Kununurra",
            "PLO": "Port Lincoln",
            "LEA": "Exmouth",
            "PXH": "Mount Eba",
            "EDR": "Pormpuraaw",
            "PQQ": "Port Macquarie",
            "PEY": "Penong",
            "PHE": "Port Hedland",
            "PER": "Perth",
            "PEA": "Ironstone",
            "UMR": "Woomera",
            "XCH": "Flying Fish Cove",
            "YQJ": "Quadra Island",
            "YRC": "Desolation Sound",
            "YRD": "Kimsquit Valley",
            "RBU": "Roebourne",
            "RBC": "Robinvale",
            "RMA": "Roma",
            "RPB": "Roper Bar",
            "RTP": "Yagoonya",
            "NDS": "Sandstone",
            "BWU": "Sydney",
            "CBR": "Canberra",
            "WCD": "Cundeelee",
            "CDU": "Cobbitty",
            "DBO": "Dubbo",
            "SIX": "Singleton",
            "SGP": "Shay Gap",
            "MJK": "Denham",
            "WOL": "Albion Park Rail",
            "WSY": "Shute Harbour",
            "SBR": "Saibai Island",
            "GOS": "Gosford",
            "SOI": "South Molle Island Resort",
            "STH": "Strathmore",
            "SNB": "Milikapiti",
            "NLK": "Burnt Pine",
            "NOA": "Nowra Hill",
            "SLJ": "Karijini National Park",
            "XRH": "Richmond",
            "SYD": "Sydney (Mascot)",
            "STF": "Stephens Island",
            "TMW": "Tamworth",
            "SSP": "Silver Plains",
            "WGA": "Forest Hill",
            "TAQ": "Tarcoola",
            "TQP": "Trepell",
            "TEM": "Temora",
            "XTG": "Thargomindah",
            "GTS": "The Granites Gold Mine",
            "TDN": "Drysdale River",
            "TKY": "Turkey Creek",
            "PHQ": "Phosphate Hill",
            "TPR": "Tom Price",
            "TUM": "Tumut",
            "TYP": "Tobermorey",
            "TXR": "Tanbar Station",
            "THG": "Biloela",
            "TCA": "Tennant Creek",
            "TRO": "Taree",
            "TTX": "Anjo Peninsula",
            "TWB": "Toowoomba",
            "UDA": "Undara",
            "USL": "Useless Loop",
            "VCD": "Victoria River",
            "WAU": "Wauchope",
            "WLA": "Eighty Mile Beach",
            "SYU": "Sue Islet",
            "WND": "Laverton",
            "WRN": "Windarling Mine",
            "WNR": "Windorah",
            "WON": "Wondoola",
            "MFL": "Wando Vale",
            "GYB": "Wodgina",
            "WGT": "Laceby",
            "WYA": "Whyalla",
            "NTL": "Williamtown",
            "WPK": "Wrotham Park",
            "SXE": "Sale",
            "WWI": "Woodie Woodie",
            "WWY": "West Wyalong",
            "BWT": "Burnie",
            "YLG": "Yalgoo",
            "OKR": "Yorke Island",
            "XMY": "Yam Island",
            "KYI": "Yalata Mission",
            "KKI": "Akiachak",
            "BCC": "Bear Creek",
            "JBT": "Bethel",
            "CZP": "Cape Pole",
            "KBW": "Chignik",
            "KBC": "Birch Creek",
            "CZC": "Copper Center",
            "HPR": "Pretoria",
            "TDT": "Timbavati",
            "HZV": "Hazyview",
            "KHO": "Khoka Moya",
            "MBM": "Mkambati",
            "INY": "Inyati",
            "TSD": "Tshipise",
            "SSX": "Singita Safari Lodge",
            "KIG": "Koingnaas",
            "PEK": "Beijing",
            "PKX": "Beijing",
            "CDE": "Chengde",
            "CIF": "Chifeng",
            "CIH": "Changzhi",
            "BPE": "Qinhuangdao (Changli)",
            "DSN": "Ordos",
            "DAT": "Datong",
            "ERL": "Erenhot",
            "YIE": "Arxan",
            "HDG": "Handan",
            "HET": "Hohhot",
            "HUO": "Holingol",
            "HLD": "Hailar",
            "LFQ": "Linfen (Yaodu)",
            "LLV": "Lüliang",
            "NZH": "Manzhouli",
            "BAV": "Baotou",
            "SZH": "Shuozhou",
            "SJW": "Shijiazhuang",
            "TVS": "Tangshan (Fengrun)",
            "TSN": "Tianjin",
            "TGO": "Tongliao",
            "UCB": "Ulanqab",
            "WUA": "Wuhai",
            "HLH": "Ulanhot",
            "XIL": "Xilinhot",
            "XNT": "Xingtai",
            "WUT": "Xinzhou",
            "YCU": "Yuncheng (Yanhu)",
            "TYN": "Taiyuan",
            "RLK": "Bavannur",
            "ZQZ": "Zhangjiakou",
            "NZL": "Zhalantun",
            "ZDM": "Ramallah",
            "BHY": "Beihai (Yinhai)",
            "AEB": "Baise (Tianyang)",
            "CGD": "Changde (Dingcheng)",
            "HJJ": "Huaihua",
            "HCZ": "Chenzhou",
            "DYG": "Zhangjiajie (Yongding)",
            "FUO": "Foshan (Nanhai)",
            "CAN": "Guangzhou (Huadu)",
            "CSX": "Changsha (Changsha)",
            "HCJ": "Hechi (Jinchengjiang)",
            "HNY": "Hengyang",
            "HUZ": "Huizhou (Pingtan)",
            "KWL": "Guilin (Lingui)",
            "LLF": "Yongzhou",
            "MXZ": "Meizhou (Meixian)",
            "NNG": "Nanning (Jiangnan)",
            "SWA": "Jieyang (Rongcheng)",
            "ZUH": "Zhuhai (Jinwan)",
            "WGN": "Shaoyang (Wugang)",
            "SZX": "Shenzhen (Bao'an)",
            "WUZ": "Tangbu",
            "XIN": "Meizhou (Xingning)",
            "DXJ": "Xiangxi",
            "YLX": "Yùlín",
            "YYA": "Yueyang (Yueyanglou)",
            "LZH": "Liuzhou (Liujiang)",
            "ZHA": "Zhanjiang",
            "AYN": "Anyang",
            "CGO": "Zhengzhou",
            "EHU": "Ezhou",
            "ENH": "Enshi (Enshi)",
            "LHK": "Xiangyang (Laohekou)",
            "WUH": "Wuhan (Huangpi)",
            "SHS": "Jingzhou (Shashi)",
            "LYA": "Luoyang (Laocheng)",
            "NNY": "Nanyang (Wancheng)",
            "HQQ": "Anyang",
            "HPG": "Shennongjia (Hongping)",
            "WDS": "Shiyan (Maojian)",
            "XFN": "Xiangyang (Xiangzhou)",
            "XAI": "Xinyang",
            "YIH": "Yichang (Xiaoting)",
            "ZIZ": "Zamzama Gas Field",
            "HAK": "Haikou (Meilan)",
            "BAR": "Qionghai (Basuo)",
            "SYX": "Sanya (Tianya)",
            "RGO": "Hoemun-ri",
            "FNJ": "Pyongyang",
            "DSO": "Sŏndŏng-ni",
            "YJS": "Samjiyŏn",
            "UJU": "Uiju",
            "WOS": "Wonsan",
            "AKA": "Ankang (Hanbin)",
            "DNH": "Dunhuang",
            "HXD": "Delingha",
            "GMQ": "Golog (Maqên)",
            "GOQ": "Golmud",
            "GYU": "Guyuan (Yuanzhou)",
            "HBQ": "Haibei (Qilian)",
            "HTT": "Mengnai",
            "HZG": "Hanzhong (Chenggu)",
            "INC": "Yinchuan",
            "JIC": "Jinchang",
            "JGN": "Jiayuguan",
            "LHW": "Lanzhou (Yongdeng)",
            "LNL": "Longnan (Cheng)",
            "IQN": "Qingyang (Xifeng)",
            "SIA": "Xi'an (Baqiao)",
            "THQ": "Tianshui (Maiji)",
            "GXH": "Gannan (Xiahe)",
            "XNN": "Haidong (Huzhu Tu Autonomous County)",
            "XIY": "Xianyang (Weicheng)",
            "ENY": "Yan'an (Baota)",
            "UYN": "Yulin",
            "YUS": "Yushu (Batang)",
            "ZHY": "Zhongwei (Shapotou)",
            "YZY": "Zhangye (Ganzhou)",
            "UMB": "Kalumbila",
            "AVK": "Arvaikheer",
            "LTI": "Altai",
            "BYN": "Bayankhongor",
            "UGA": "Bulgan",
            "UGT": "Khankhongor",
            "HBU": "Bulgan",
            "UBN": "Ulaanbaatar (Sergelen)",
            "ZMD": "Sena Madureira",
            "ULZ": "Uliastai",
            "DLZ": "Dalanzadgad",
            "HTM": "Hatgal",
            "HJT": "Khujirt",
            "HVD": "Khovd",
            "MXW": "Mandalgobi",
            "MXV": "Mörön",
            "TSZ": "Tsetserleg",
            "TNZ": "Tosontsengel",
            "ULN": "Ulaanbaatar",
            "ULO": "Ulaangom",
            "UNR": "Öndörkhaan",
            "ULG": "Ölgii",
            "ZNC": "Nyac",
            "ZNU": "Namu",
            "BSD": "Baoshan (Longyang)",
            "CWJ": "Lincang (Cangyuan)",
            "DLU": "Dali (Xiaguan)",
            "DIG": "Diqing (Shangri-La)",
            "JHG": "Jinghong (Gasa)",
            "JMJ": "Pu'er (Lancang)",
            "LNJ": "Lincang",
            "LJG": "Lijiang (Gucheng)",
            "LUM": "Dehong (Mangshi)",
            "KMG": "Kunming",
            "SYM": "Pu'er",
            "WNH": "Wenshan",
            "YUA": "Chuxiong (Yuanmou)",
            "ZAT": "Zhaotong (Zhaoyang)",
            "XMN": "Xiamen",
            "AQG": "Anqing",
            "BFU": "Bengbu",
            "CZX": "Changzhou",
            "KHN": "Nanchang",
            "AZJ": "Zhenjiang",
            "DOY": "Dongying (Kenli)",
            "FUG": "Yingzhou, Fuyang",
            "FOC": "Fuzhou (Changle)",
            "KOW": "Ganzhou",
            "HGH": "Hangzhou",
            "HZA": "Heze (Dingtao)",
            "JDZ": "Jingdezhen",
            "JNG": "Jining",
            "JIU": "Jiujiang",
            "TNA": "Jinan (Licheng)",
            "JUZ": "Quzhou (Kezheng)",
            "LYG": "Lianyungang",
            "LCX": "Longyan (Liancheng)",
            "HYN": "Taizhou (Luqiao)",
            "LYI": "Linyi (Hedong)",
            "NGB": "Ningbo",
            "NKG": "Nanjing",
            "NTG": "Nantong (Tongzhou)",
            "HFE": "Hefei",
            "PVG": "Shanghai (Pudong)",
            "TAO": "Qingdao (Jiaozhou)",
            "JJN": "Quanzhou",
            "RUG": "Rugao (Nantong)",
            "RIZ": "Rizhao (Donggang)",
            "HIA": "Huai'an",
            "SQJ": "Sanming (Sha)",
            "SQD": "Shangrao (Hengfeng)",
            "SHA": "Shanghai (Minhang)",
            "SZV": "Suzhou",
            "TXN": "Huangshan",
            "WHA": "Wuhu",
            "WEF": "Weifang (Kuiwen)",
            "WEH": "Weihai",
            "WHU": "Wuhu",
            "WUX": "Wuxi",
            "WUS": "Wuyishan",
            "WNZ": "Wenzhou (Longwan)",
            "XUZ": "Xuzhou",
            "YTY": "Yangzhou",
            "YIC": "Yichun",
            "YNZ": "Yancheng (Tinghu)",
            "YNT": "Yantai",
            "YIW": "Jinhua (Yiwu)",
            "HSN": "Zhoushan",
            "NGQ": "Shiquanhe",
            "AVA": "Anshun (Xixiu)",
            "BCJ": "Mianyang",
            "BPX": "Bangda",
            "BFJ": "Bijie",
            "CKG": "Chongqing",
            "DZH": "Dazhou (Dachuan)",
            "DCY": "Garzê (Daocheng)",
            "DEJ": "Tongren",
            "DAX": "Dazhou (Daxian)",
            "DZU": "Dazu",
            "GHN": "Deyang (Guanghan)",
            "GYS": "Guangyuan (Lizhou)",
            "KWE": "Guiyang (Nanming)",
            "GZG": "Garzê (Garzê)",
            "AHJ": "Ngawa (Hongyuan)",
            "JZH": "Ngawa (Songpan)",
            "KGT": "Garzê (Kangding)",
            "KJH": "Kaili  (Huangping)",
            "LLB": "Qiannan (Libo)",
            "LIA": "Liangping",
            "LXA": "Shannan (Gonggar)",
            "LZO": "Luzhou (Yunlong)",
            "WMT": "Zunyi",
            "MIG": "Mianyang (Fucheng)",
            "NAO": "Nanchong (Gaoping)",
            "HZH": "Liping",
            "LZY": "Nyingchi (Mainling)",
            "LPF": "Liupanshui (Zhongshan)",
            "JIQ": "Qianjiang",
            "RKZ": "Xigazê (Samzhubzê)",
            "LGZ": "Shannan",
            "TCZ": "Baoshan (Tengchong)",
            "TFU": "Chengdu (Jianyang)",
            "TEN": "Tongren (Daxing)",
            "CTU": "Chengdu (Shuangliu)",
            "CQW": "Wulong",
            "WSK": "Wushan",
            "WXN": "Wanzhou",
            "XIC": "Liangshan (Xichang)",
            "YBP": "Yibin (Cuiping)",
            "ACX": "Xingyi",
            "PZI": "Panzhihua (Renhe)",
            "ZYI": "Zunyi",
            "AKU": "Aksu (Onsu)",
            "ACF": "Aral",
            "AAT": "Altay",
            "BPL": "Bole",
            "IQM": "Qiemo",
            "FYN": "Fuyun",
            "HMI": "Hami",
            "SHF": "Shihezi",
            "KCA": "Kuqa",
            "KRL": "Korla",
            "KRY": "Karamay",
            "KJI": "Burqin",
            "NLT": "Xinyuan",
            "RQA": "Ruoqiang Town",
            "QSZ": "Shache",
            "KHG": "Kashgar",
            "SXJ": "Shanshan",
            "TCG": "Tacheng",
            "TLQ": "Turpan",
            "HTN": "Hotan",
            "URC": "Ürümqi",
            "YIN": "Ili (Yining / Ghulja)",
            "YTW": "Hotan (Yutian)",
            "AOG": "Anshan",
            "DBC": "Baicheng",
            "NBS": "Baishan",
            "CGQ": "Changchun",
            "CNI": "Dalian (Changhai)",
            "CHG": "Shuangta, Chaoyang",
            "DDG": "Dandong (Zhenxing)",
            "DQA": "Daqing",
            "DTU": "Heihe",
            "FYJ": "Fuyuan",
            "HRB": "Harbin",
            "HEK": "Heihe",
            "JGD": "Jiagedaqi",
            "JIL": "Jilin",
            "JMU": "Jiamusi",
            "JSJ": "Jiansanjiang",
            "JXA": "Jixi",
            "JNZ": "Jinzhou (Linghai)",
            "LDS": "Yichun",
            "MDG": "Mudanjiang",
            "OHE": "Mohe",
            "NDG": "Qiqihar",
            "HSF": "Suifenhe",
            "YSQ": "Qian Gorlos Mongol Autonomous County",
            "DLC": "Dalian (Ganjingzi)",
            "TNH": "Tonghua",
            "SHE": "Hunnan, Shenyang",
            "XEN": "Huludao (Xingcheng)",
            "YNJ": "Yanji",
            "YKH": "Yingkou (Laobian)"
        }
    ];
    const getCityByCode = (code: string) => {
        const airportData = airports.find(airport => airport[code]);
        return airportData ? airportData[code] : code;
    };

    return {
        getCityByCode
    }
}